// src/activate.ts
var translations = {
  "en_AU": {
    "Facebook": "Facebook",
    "Google": "Google",
    "or connect with": "or connect with",
    "Sign Up to Activate Device": "Sign Up to Activate Device",
    "Region Not Supported": "Region Not Supported",
    "Log In to Activate Device": "Log In to Activate Device",
    "\u201CAlexa, play z one hundred on iHeartRadio\u201D": "\u201CAlexa, play z one hundred on iHeartRadio\u201D",
    "\u201CAlexa, play Post Malone radio on iHeartRadio\u201D": "\u201CAlexa, play Post Malone radio on iHeartRadio\u201D",
    "\u201CAlexa, play Stuff You Should Know Podcast on iHeartRadio\u201D": "\u201CAlexa, play Stuff You Should Know Podcast on iHeartRadio\u201D",
    "Your iHeartRadio account is now linked!": "Your iHeartRadio account is now linked!",
    "Try these popular phrases from other listeners:": "Try these popular phrases from other listeners:",
    "Please enter your activate code.": "Please enter your activate code.",
    "Check your activation code and try again, or get a new activation code from your device.": "Check your activation code and try again, or get a new activation code from your device.",
    "An unknown error occurred.": "An unknown error occurred.",
    "Activate": "Activate",
    "Log in as a different user": "Log in as a different user",
    "Activation Code": "Activation Code",
    "Your iHeartRadio account is now available on your device.": "Your iHeartRadio account is now available on your device.",
    "Do not sell or share my personal information": "",
    "Log In": "Log In",
    "Wrong email or password. Please try again with a different email address or password": "",
    "Too many repeated log in attempts. Your account is locked temporarily. Please wait and try again later": "",
    "Sorry, an error occurred. Please try again later.": "Sorry, an error occurred. Please try again later.",
    "Don't have an account?": "Don't have an account?",
    "Sign up": "Sign up",
    "Forgot Password?": "Forgot Password?",
    "Email": "Email",
    "Password": "Password",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "Sorry for the inconvenience, but we do not allow account sign-up for your current location.",
    "Visit our Help Center": "Visit our Help Center",
    "Return to Log In": "Return to Log In",
    "Male": "Male",
    "Female": "Female",
    "Prefer not to say": "Prefer not to say",
    "Other": "Other",
    "8 to 32 characters": "",
    "an upper case and lower case letter": "",
    "a number (0-9)": "",
    "Error": "",
    "Success": "",
    "Optional": "",
    "Password must have eight to thiry two characters": "",
    "Password doesn't have eight to thirty two characters": "",
    "Password has eight to thirty two characters": "",
    "Password must have an uppercase and lower case letter": "",
    "Password doesn't have an upper case and lower case letter": "",
    "Password has an upper case and lower case letter": "",
    "Password must have a number between zero and nine": "",
    "Password doesn't have a number between zero and nine": "",
    "password has a number between zero and nine": "",
    "Please fill out all form fields": "Please fill out all form fields",
    "Username already exists.": "Username already exists.",
    "Password is too weak": "",
    "Password shouldn't have common words or passwords": "",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign.": "",
    "Invalid Email Address": "Invalid Email Address",
    "Invalid password": "",
    "Password must have:": "",
    "Birth Year": "Birth Year",
    "By creating an account, you also agree to our {termsOfService} and {privacyPolicy}.": "By creating an account, you also agree to our {termsOfService} and {privacyPolicy}.",
    "Terms of Service": "Terms of Service",
    "Privacy Policy": "Privacy Policy",
    "Sign Up": "Sign Up",
    "Postal Code": "Postal Code",
    "ZIP code": "ZIP code",
    "Invalid Postal Code": "Invalid Postal Code",
    "Invalid ZIP Code": "Invalid ZIP Code",
    "Sorry, you are not eligible to register for iHeartRadio": "Sorry, you are not eligible to register for iHeartRadio",
    "Have an account?": "Have an account?"
  },
  "en_NZ": {
    "Facebook": "Facebook",
    "Google": "Google",
    "or connect with": "or connect with",
    "Sign Up to Activate Device": "Sign Up to Activate Device",
    "Region Not Supported": "Region Not Supported",
    "Log In to Activate Device": "Log In to Activate Device",
    "\u201CAlexa, play z one hundred on iHeartRadio\u201D": "\u201CAlexa, play z one hundred on iHeartRadio\u201D",
    "\u201CAlexa, play Post Malone radio on iHeartRadio\u201D": "\u201CAlexa, play Post Malone radio on iHeartRadio\u201D",
    "\u201CAlexa, play Stuff You Should Know Podcast on iHeartRadio\u201D": "\u201CAlexa, play Stuff You Should Know Podcast on iHeartRadio\u201D",
    "Your iHeartRadio account is now linked!": "Your iHeartRadio account is now linked!",
    "Try these popular phrases from other listeners:": "Try these popular phrases from other listeners:",
    "Please enter your activate code.": "Please enter your activate code.",
    "Check your activation code and try again, or get a new activation code from your device.": "Check your activation code and try again, or get a new activation code from your device.",
    "An unknown error occurred.": "An unknown error occurred.",
    "Activate": "Activate",
    "Log in as a different user": "Log in as a different user",
    "Activation Code": "Activation Code",
    "Your iHeartRadio account is now available on your device.": "Your iHeartRadio account is now available on your device.",
    "Do not sell or share my personal information": "",
    "Log In": "Log In",
    "Wrong email or password. Please try again with a different email address or password": "",
    "Too many repeated log in attempts. Your account is locked temporarily. Please wait and try again later": "",
    "Sorry, an error occurred. Please try again later.": "Sorry, an error occurred. Please try again later.",
    "Don't have an account?": "Don't have an account?",
    "Sign up": "Sign up",
    "Forgot Password?": "Forgot Password?",
    "Email": "Email",
    "Password": "Password",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "Sorry for the inconvenience, but we do not allow account sign-up for your current location.",
    "Visit our Help Center": "Visit our Help Center",
    "Return to Log In": "Return to Log In",
    "Male": "Male",
    "Female": "Female",
    "Prefer not to say": "Prefer not to say",
    "Other": "Other",
    "8 to 32 characters": "",
    "an upper case and lower case letter": "",
    "a number (0-9)": "",
    "Error": "",
    "Success": "",
    "Optional": "",
    "Password must have eight to thiry two characters": "",
    "Password doesn't have eight to thirty two characters": "",
    "Password has eight to thirty two characters": "",
    "Password must have an uppercase and lower case letter": "",
    "Password doesn't have an upper case and lower case letter": "",
    "Password has an upper case and lower case letter": "",
    "Password must have a number between zero and nine": "",
    "Password doesn't have a number between zero and nine": "",
    "password has a number between zero and nine": "",
    "Please fill out all form fields": "Please fill out all form fields",
    "Username already exists.": "Username already exists.",
    "Password is too weak": "",
    "Password shouldn't have common words or passwords": "",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign.": "",
    "Invalid Email Address": "Invalid Email Address",
    "Invalid password": "",
    "Password must have:": "",
    "Birth Year": "Birth Year",
    "By creating an account, you also agree to our {termsOfService} and {privacyPolicy}.": "By creating an account, you also agree to our {termsOfService} and {privacyPolicy}.",
    "Terms of Service": "Terms of Service",
    "Privacy Policy": "Privacy Policy",
    "Sign Up": "Sign Up",
    "Postal Code": "Postal Code",
    "ZIP code": "ZIP code",
    "Invalid Postal Code": "Invalid Postal Code",
    "Invalid ZIP Code": "Invalid ZIP Code",
    "Sorry, you are not eligible to register for iHeartRadio": "Sorry, you are not eligible to register for iHeartRadio",
    "Have an account?": "Have an account?"
  },
  "es": {
    "Facebook": "Facebook",
    "Google": "Google",
    "or connect with": "o con\xE9ctate con",
    "Sign Up to Activate Device": "Reg\xEDstrate para activar el dispositivo",
    "Region Not Supported": "Regi\xF3n no soportada",
    "Log In to Activate Device": "Inicia sesi\xF3n para activar el dispositivo",
    "\u201CAlexa, play z one hundred on iHeartRadio\u201D": '"Alexa, toca z one hundred en iHeartRadio"',
    "\u201CAlexa, play Post Malone radio on iHeartRadio\u201D": '"Alexa, toca la radio de Post Malone en iHeartRadio"',
    "\u201CAlexa, play Stuff You Should Know Podcast on iHeartRadio\u201D": 'Alexa, toca Stuff You Should Know Podcast en iHeartRadio"',
    "Your iHeartRadio account is now linked!": "Tu cuenta de iHeartRadio est\xE1 ahora asociada!",
    "Try these popular phrases from other listeners:": "Intenta estas frases populares de otros usuarios:",
    "Please enter your activate code.": "Por favor ingresa tu c\xF3digo de activaci\xF3n",
    "Check your activation code and try again, or get a new activation code from your device.": "Revisa tu c\xF3digo de activaci\xF3n e intenta de nuevo, u obt\xE9n un nuevo c\xF3digo de activaci\xF3n en tu dispositivo",
    "An unknown error occurred.": "Ocurri\xF3 un error desconocido",
    "Activate": "Activar",
    "Log in as a different user": "Inicia sesi\xF3n con un usuario diferente",
    "Activation Code": "C\xF3digo de activaci\xF3n",
    "Your iHeartRadio account is now available on your device.": "Tu cuenta de iHeartRadio est\xE1 ahora disponible en tu dispositivo.",
    "Do not sell or share my personal information": "No vender mi informaci\xF3n personal",
    "Log In": "Iniciar sesi\xF3n",
    "Wrong email or password. Please try again with a different email address or password": "Correo o contrase\xF1a incorrectos. Por favor intenta nuevamente con un correo o contrase\xF1a diferente",
    "Too many repeated log in attempts. Your account is locked temporarily. Please wait and try again later": "Muchos intentos de inicio de sesi\xF3n. Tu cuenta ha sido bloqueada temporalmente. Por favor espera e intenta de nuevo m\xE1s tarde. ",
    "Sorry, an error occurred. Please try again later.": "Lo sentimos, ocurri\xF3 un error. Por favor, int\xE9ntalo de nuevo m\xE1s tarde.",
    "Don't have an account?": "\xBFNo tienes una cuenta?",
    "Sign up": "Reg\xEDstrate",
    "Forgot Password?": "\xBFOlvidaste tu contrase\xF1a?",
    "Email": "Correo electr\xF3nico",
    "Password": "Contrase\xF1a",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "Lamentamos el inconveniente, pero no aceptamos registro de usuario en tu ubicaci\xF3n actual.",
    "Visit our Help Center": "Visita nuestro centro de ayuda",
    "Return to Log In": "Regresar a inicio de sesi\xF3n",
    "Male": "Masculino",
    "Female": "Femenino ",
    "Prefer not to say": "Prefiero no decir",
    "Other": "Otro",
    "8 to 32 characters": "8 a 32 caracteres",
    "an upper case and lower case letter": "una may\xFAscula y una min\xFAscula",
    "a number (0-9)": "un n\xFAmero (0-9)",
    "Error": "Error",
    "Success": "Correcto",
    "Optional": "Opcional",
    "Password must have eight to thiry two characters": "La contrase\xF1a debe tener de 8 a 32 caracteres",
    "Password doesn't have eight to thirty two characters": "La contrase\xF1a no tiene de 8 a 32 caracteres",
    "Password has eight to thirty two characters": "La contrase\xF1a tiene de 8 a 32 caracteres",
    "Password must have an uppercase and lower case letter": "La contrase\xF1a debe tener una may\xFAscula y una min\xFAscula",
    "Password doesn't have an upper case and lower case letter": "La contrase\xF1a no tiene una may\xFAscula ni una min\xFAsula",
    "Password has an upper case and lower case letter": "La contrase\xF1a tiene una may\xFAscula y una min\xFAscula",
    "Password must have a number between zero and nine": "La contrase\xF1a debe tener un n\xFAmero entre cero y nuevo.",
    "Password doesn't have a number between zero and nine": "La contrase\xF1a no tiene un n\xFAmero entre cero y nueve. ",
    "password has a number between zero and nine": "La contrase\xF1a tiene un n\xFAmero entre cero y nueve",
    "Please fill out all form fields": "Por favor llena todos los campos del formulario",
    "Username already exists.": "El nombre de usuario ya existe.",
    "Password is too weak": "La contrase\xF1a es muy d\xE9bil",
    "Password shouldn't have common words or passwords": "La contrase\xF1a no debe tener palabras comunes.",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "La contrase\xF1a solo puede tener letras, n\xFAmeros, espacios y los siguientes caracteres especiales: . ! ? - _ , ; : / ( ) [ ] ~ @ # $ % ^ & * + = \\",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign.": "La contrase\xF1a solo puede tener letras, n\xFAmeros, espacios y los siguientes caracteres especiales: punto, signo de exclamaci\xF3n, signo de interrogaci\xF3n, guion, guion bajo, coma, punto y coma, dos puntos, barra oblicua, barra invertida, apertura de par\xE9ntesis, cierre de par\xE9ntesis, tilde, arroba, signo de n\xFAmero, signo de moneda, signo de porcentaje, intercalaci\xF3n, ampersand, asterisco, signo de m\xE1s, signo de igual, ap\xF3strofe, comillas, acento grave, barra vertical, apertura de corchete, cierre de corchete, signo menor que y signo mayor que.",
    "Invalid Email Address": "Correo electr\xF3nico no v\xE1lido",
    "Invalid password": "Contrase\xF1a inv\xE1lida",
    "Password must have:": "La contrase\xF1a debe tener:",
    "Birth Year": "A\xF1o de nac",
    "By creating an account, you also agree to our {termsOfService} and {privacyPolicy}.": "Al crear una cuenta, tambi\xE9n aceptas nuestros {termsOfService} y {privacyPolicy}.",
    "Terms of Service": "T\xE9rminos de servicio",
    "Privacy Policy": "Pol\xEDtica de Privacidad",
    "Sign Up": "Reg\xEDstrate",
    "Postal Code": "C\xF3digo Postal",
    "ZIP code": "C\xF3digo postal",
    "Invalid Postal Code": "C\xF3digo postal no v\xE1lido",
    "Invalid ZIP Code": "C\xF3digo postal no v\xE1lido",
    "Sorry, you are not eligible to register for iHeartRadio": "Lo sentimos, usted no es elegible para registrarse en iHeartRadio",
    "Have an account?": "\xBFTienes una cuenta?"
  },
  "fr": {
    "Facebook": "Facebook",
    "Google": "Google",
    "or connect with": "ou connectez-vous avec",
    "Sign Up to Activate Device": "Inscrivez-vous pour activer l'appareil",
    "Region Not Supported": "R\xE9gion non prise en charge",
    "Log In to Activate Device": "Connectez-vous pour activer l'appareil",
    "\u201CAlexa, play z one hundred on iHeartRadio\u201D": "\xAB Alexa, joue z one hundred sur iHeartRadio \xBB",
    "\u201CAlexa, play Post Malone radio on iHeartRadio\u201D": "\xAB Alexa, joue Post Malone sur iHeartRadio \xBB",
    "\u201CAlexa, play Stuff You Should Know Podcast on iHeartRadio\u201D": "\xAB Alexa, joue le balado Stuff You Should Know sur iHeartRadio \xBB",
    "Your iHeartRadio account is now linked!": "Votre compte iHeartRadio a \xE9t\xE9 li\xE9!",
    "Try these popular phrases from other listeners:": "Essayez ces phrases populaires utilisateurs par d'autres utilisateurs :",
    "Please enter your activate code.": "Veuillez entrer votre code d'activation.",
    "Check your activation code and try again, or get a new activation code from your device.": "V\xE9rifiez votre code d'activation et essayez de nouveau, ou demandez un nouveau code d'activation de votre appareil.",
    "An unknown error occurred.": "Une erreur inconnue est survenue.",
    "Activate": "Activer",
    "Log in as a different user": "Se connecter comme autre utilisateur",
    "Activation Code": "Code d'activation",
    "Your iHeartRadio account is now available on your device.": "Votre compte iHeartRadio est maintenant disponible sur votre appareil.",
    "Do not sell or share my personal information": "Ne pas vendre mon information personnelle",
    "Log In": "Connexion",
    "Wrong email or password. Please try again with a different email address or password": "Adresse courriel ou mot de passe invalide. Veuillez r\xE9essayer avec une autre adresse courriel ou un autre mot de passe ",
    "Too many repeated log in attempts. Your account is locked temporarily. Please wait and try again later": "Trop d'essais de connexion r\xE9p\xE9t\xE9s. Votre compte est temporairement verrouill\xE9. Veuillez attendre et r\xE9essayer plus tard.",
    "Sorry, an error occurred. Please try again later.": "D\xE9sol\xE9s, une erreur s'est produite. Veuillez r\xE9essayer plus tard.",
    "Don't have an account?": "Vous n'avez pas de compte?",
    "Sign up": "Abonnez-vous",
    "Forgot Password?": "Mot de passe oubli\xE9?",
    "Email": "Adresse courriel",
    "Password": "Mot de passe",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "D\xE9sol\xE9s de l'inconv\xE9nient, mais nous ne permettons pas la cr\xE9ation de comptes pour votre emplacement. ",
    "Visit our Help Center": "Consulter notre Centre d'aide",
    "Return to Log In": "Revenir \xE0 la connexion",
    "Male": "Homme",
    "Female": "Femme",
    "Prefer not to say": "Je pr\xE9f\xE8re ne pas r\xE9pondre",
    "Other": "Autre",
    "8 to 32 characters": "8 \xE0 32 caract\xE8res",
    "an upper case and lower case letter": "une lettre majuscule et une minuscule",
    "a number (0-9)": "un chiffre (0-9)",
    "Error": "Erreur",
    "Success": "Succ\xE8s",
    "Optional": "Optionel",
    "Password must have eight to thiry two characters": "Le mot de passe doit comporter de huit \xE0 trente-deux caract\xE8res",
    "Password doesn't have eight to thirty two characters": "Le mot de passe ne comporte pas de huit \xE0 trente-deux caract\xE8res",
    "Password has eight to thirty two characters": "Le mot de passe comporte de huit \xE0 trente-deux caract\xE8res",
    "Password must have an uppercase and lower case letter": "Le mot de passe doit comprendre une lettre majuscule et une minuscule",
    "Password doesn't have an upper case and lower case letter": "Le mot de passe ne comprend pas une lettre majuscule et une minuscule",
    "Password has an upper case and lower case letter": "Le mot de passe comprend une lettre majuscule et une minuscule",
    "Password must have a number between zero and nine": "Le mot de passe doit comprendre un chiffre entre z\xE9ro et neuf",
    "Password doesn't have a number between zero and nine": "Le mot de passe ne comprend pas un chiffre entre z\xE9ro et neuf",
    "password has a number between zero and nine": "Le mot de passe comprend un chiffre entre z\xE9ro et neuf",
    "Please fill out all form fields": "Veuillez remplir tous les champs du formulaire ",
    "Username already exists.": "Nom d'usager d\xE9j\xE0 pris.",
    "Password is too weak": "Le mot de passe n'est pas assez s\xE9curitaire",
    "Password shouldn't have common words or passwords": "Le mot de passe ne devrait pas \xEAtre un mot ou un mot de passe commun",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign.": "",
    "Invalid Email Address": "Adresse courriel invalide",
    "Invalid password": "Mot de passe non valide",
    "Password must have:": "Le mot de passe doit comprendre :",
    "Birth Year": "Ann\xE9e de naissance",
    "By creating an account, you also agree to our {termsOfService} and {privacyPolicy}.": "En cr\xE9ant ce compte, vous acceptez \xE9galement nos {termsOfService} et {privacyPolicy}.",
    "Terms of Service": "Conditions d'utilisation",
    "Privacy Policy": "Politique de confidentialit\xE9",
    "Sign Up": "Abonnez-vous",
    "Postal Code": "Code postal",
    "ZIP code": "Code postal",
    "Invalid Postal Code": "Code postal invalide",
    "Invalid ZIP Code": "Code postal invalide",
    "Sorry, you are not eligible to register for iHeartRadio": "D\xE9sol\xE9s, vous n'\xEAtes pas \xE9ligible pour un compte iHeartRadio",
    "Have an account?": "Vous avez d\xE9j\xE0 un compte?"
  },
  "options": {
    "plural_rule": "n > 1",
    "plural_number": "2"
  }
};

// src/www.ts
var translations2 = {
  "en_AU": {
    "Facebook": "Facebook",
    "Google": "Google",
    "Region Not Supported": "Region Not Supported",
    "Do not sell or share my personal information": "",
    "Log In": "Log In",
    "Sorry, an error occurred. Please try again later.": "Sorry, an error occurred. Please try again later.",
    "Don't have an account?": "Don't have an account?",
    "Sign up": "Sign up",
    "Forgot Password?": "Forgot Password?",
    "Email": "Email",
    "Password": "Password",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "Sorry for the inconvenience, but we do not allow account sign-up for your current location.",
    "Visit our Help Center": "Visit our Help Center",
    "Return to Log In": "Return to Log In",
    "Male": "Male",
    "Female": "Female",
    "Prefer not to say": "Prefer not to say",
    "Other": "Other",
    "8 to 32 characters": "",
    "an upper case and lower case letter": "",
    "a number (0-9)": "",
    "Error": "",
    "Success": "",
    "Password must have eight to thiry two characters": "",
    "Password doesn't have eight to thirty two characters": "",
    "Password has eight to thirty two characters": "",
    "Password must have an uppercase and lower case letter": "",
    "Password doesn't have an upper case and lower case letter": "",
    "Password has an upper case and lower case letter": "",
    "Password must have a number between zero and nine": "",
    "Password doesn't have a number between zero and nine": "",
    "password has a number between zero and nine": "",
    "Please fill out all form fields": "Please fill out all form fields",
    "Password shouldn't have common words or passwords": "",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "",
    "Invalid Email Address": "Invalid Email Address",
    "Birth Year": "Birth Year",
    "Terms of Service": "Terms of Service",
    "Privacy Policy": "Privacy Policy",
    "Sign Up": "Sign Up",
    "Postal Code": "Postal Code",
    "Invalid Postal Code": "Invalid Postal Code",
    "Invalid ZIP Code": "Invalid ZIP Code",
    "Have an account?": "Have an account?",
    "Login unsuccessful. Please try again later.": "Login unsuccessful. Please try again later.",
    "Update successful.": "Update successful.",
    "Your account has been linked to {provider}.": "Your account has been linked to {provider}.",
    "This {accountType} account is already linked to an iHeartRadio account": "This {accountType} account is already linked to an iHeartRadio account",
    "{accountType} account linking failed. Please try again later.": "{accountType} account linking failed. Please try again later.",
    "Your account has been unlinked from {provider}.": "Your account has been unlinked from {provider}.",
    "{accountType} account unlinking failed. Please try again later.": "{accountType} account unlinking failed. Please try again later.",
    "Login unsuccessful. Window closed before completion. Please try again.": "Login unsuccessful. Window closed before completion. Please try again.",
    "Do You Have a Popup Blocker?": "Do You Have a Popup Blocker?",
    "To log in with your Facebook or Google account, ensure you've allowed popups from www.iheart.com, refresh, and then try again.": "To log in with your Facebook or Google account, ensure you've allowed popups from www.iheart.com, refresh, and then try again.",
    "Feat. {artistNames} and more": "Feat. {artistNames} and more",
    "iHeart": "iHeart",
    "For You": "For You",
    "Add to Playlist": "Add to Playlist",
    "Episode Info": "Episode Info",
    "Lyrics": "Lyrics",
    "Rename your Favorites Radio station now.": "Rename your Favourites Radio station now.",
    "This song is not available to start your station.": "This song is not available to start your station.",
    "Play this on web with All Access": "Play this on web with All Access",
    "Subscribe today for unlimited access to playlists": "Subscribe today for unlimited access to playlists",
    "Play the whole album with iHeart All Access.": "Play the whole album with iHeart All Access.",
    "Listen History": "Listen History",
    "Custom Stations Limit Exceeded": "Custom Stations Limit Exceeded",
    "Please delete some stations from your account under {listenHistoryLink} before creating new stations.": "Please delete some stations from your account under {listenHistoryLink} before creating new stations.",
    "Sorry, this station has run out of songs to play.": "Sorry, this station has run out of songs to play.",
    "Oops": "Oops",
    "We don't have enough info to create a custom station right now. We'll let our DJs know.": "We don't have enough info to create a custom station right now. We'll let our DJs know.",
    "Replay failed": "Replay failed",
    "An unknown error occurred. Please try again later.": "An unknown error occurred. Please try again later.",
    "Update Account": "Update Account",
    "Please enter a valid email": "Please enter a valid email",
    "New Email": "New Email",
    "Please enter the same email again": "Please enter the same email again",
    "Confirm New Email": "Confirm New Email",
    "Password must be 6 - 32 characters": "Password must be 6 - 32 characters",
    "New Password (6-32 Characters)": "New Password (6-32 Characters)",
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "Cannot add duplicate tracks to a playlist": "Cannot add duplicate tracks to a playlist",
    "Added {contentType} to {playlistName}": "Added {contentType} to {playlistName}",
    "Added song to {playlistName}": "Added song to {playlistName}",
    "Ok": "Ok",
    "Success!": "Success!",
    "Your email and password have been added to your account.": "Your email and password have been added to your account.",
    "Your email has been saved.": "Your email has been saved.",
    "Your contact information has been saved.": "Your contact information has been saved.",
    "Try Again": "Try Again",
    "For assistance, please visit our {helplink}.": "For assistance, please visit our {helplink}.",
    "Help Link": "Help Link",
    "Oops!": "Oops!",
    "Get Started": "Get Started",
    "You can now enjoy the full benefits of iHeart All Access for Family.": "You can now enjoy the full benefits of iHeart All Access for Family.",
    "Welcome to the Family!": "Welcome to the Family!",
    "Your password has been saved.": "Your password has been saved.",
    "Station Not Available": "Station Not Available",
    "We're sorry! This station is not available in your country.": "We're sorry! This station is not available in your country.",
    "Updated {updateDateAndTime}": "Updated {updateDateAndTime}",
    "Please complete the CAPTCHA": "Please complete the CAPTCHA",
    "Check Your Email": "",
    "Forgot Password": "Forgot Password",
    "Enter your email address below to log in by email or reset your password.": "Enter your email address below to log in by email or reset your password.",
    "Enter your email address below to reset your password.": "Enter your email address below to reset your password.",
    "If an account exists, you'll receive a password reset link shortly. Check your spam folder if it takes more than a minute or two.": "",
    "Okay": "",
    "Back to login": "Back to login",
    "Submit": "Submit",
    "Or, {backToLoginLink}": "Or, {backToLoginLink}",
    "Gender": "Gender",
    "Music and radio on demand": "Music and radio on demand",
    "Please log in first.": "Please log in first.",
    "Login": "Login",
    "To listen to thousands of live radio and artist stations, create a free account.": "To listen to thousands of live radio and artist stations, create a free account.",
    "To listen to thousands of live radio stations, create a free account.": "To listen to thousands of live radio stations, create a free account.",
    "Connect with your favorites": "Connect with your favourites",
    "To easily find your favorite and recently listened to stations, create a free account.": "To easily find your favourite and recently listened to stations, create a free account.",
    "Access your stations": "Access your stations",
    "To view recently listened to stations and songs, create a free account.": "To view recently listened to stations and songs, create a free account.",
    "See what you've been listening to": "See what you've been listening to",
    "To access your favorites anytime, anywhere, create a free account.": "To access your favourites anytime, anywhere, create a free account.",
    "Save stations you love": "Save stations you love",
    "To hear more music you like, create a free account.": "To hear more music you like, create a free account.",
    "Personalize your listening": "Personalize your listening",
    "To listen to this artist and more, without interruption, create your free account.": "To listen to this artist and more, without interruption, create your free account.",
    "Listen to {stationName}": "Listen to {stationName}",
    "Listen to Artist Stations": "Listen to Artist Stations",
    "To listen to music based on this song, create your free account.": "To listen to music based on this song, create your free account.",
    "Listen to songs like {stationName}": "Listen to songs like {stationName}",
    "Listen to songs like this": "Listen to songs like this",
    "To listen to this podcast and more, create your free account.": "To listen to this podcast and more, create your free account.",
    "Listen to Podcasts": "Listen to Podcasts",
    "To hear all your favorite songs and artists on your own personal station, create a free account.": "To hear all your favourite songs and artists on your own personal station, create a free account.",
    "Listen to {stationName}!": "Listen to {stationName}!",
    "Listen to Your Favorites Radio!": "Listen to Your Favourites Radio!",
    "To listen, create a free account.": "To listen, create a free account.",
    "Listen to Favorites Radio!": "Listen to Favourites Radio!",
    "All your favorite music. All your favorite stations. All free.": "All your favourite music. All your favourite stations. All free.",
    "Create Your iHeart Account": "Create Your iHeart Account",
    "Please create a free account.": "Please create a free account.",
    "Register first": "Register first",
    "Create a FREE account to add songs and albums to your playlist": "Create a FREE account to add songs and albums to your playlist",
    "Welcome to the All Access FREE Preview Weekend. Create your FREE account and listen to millions of songs, live radio, playlists, and podcasts \u2013 enjoy All Access, FREE this weekend only.": "Welcome to the All Access FREE Preview Weekend. Create your FREE account and listen to millions of songs, live radio, playlists, and podcasts \u2013 enjoy All Access, FREE this weekend only.",
    "Your Halloween treat is here": "Your Halloween treat is here",
    "To join the Family Plan you've been invited to, please create a free account": "To join the Family Plan you've been invited to, please create a free account",
    "Create a free account to join your Family Plan": "Create a free account to join your Family Plan",
    "Please correct all password errors": "",
    "Sorry, you are not eligible to register for iHeart": "Sorry, you are not eligible to register for iHeart",
    "Zip Code": "Zip Code",
    "Please enter a valid birth year": "Please enter a valid birth year",
    "Receive email updates on stations I listen to and more from iHeart.": "Receive email updates on stations I listen to and more from iHeart.",
    "By creating an account, you also agree to our {termsOfServiceLink} and {privacyPolicyLink}.": "By creating an account, you also agree to our {termsOfServiceLink} and {privacyPolicyLink}.",
    "Or Connect With": "Or Connect With",
    "Login with Facebook": "Login with Facebook",
    "Login with Google": "Login with Google",
    "Added By iHeart": "Added By iHeart",
    "Suggestions based on the songs you added.": "Suggestions based on the songs you added.",
    "You have All Access": "You have All Access",
    "Upgrade to All Access": "Upgrade to All Access",
    "Want to keep enjoying these perks after the weekend?": "Want to keep enjoying these perks after the weekend?",
    "Listen offline, unlimited skips, save and play songs from the radio.": "Listen offline, unlimited skips, save and play songs from the radio.",
    "Learn More": "Learn More",
    "Start 30 Day Free Trial": "Start 30 Day Free Trial",
    "You will lose unlimited skips, replay, and access to your playlist": "You will lose unlimited skips, replay, and access to your playlist",
    "You will lose offline listening, unlimited playlists, and replay": "You will lose offline listening, unlimited playlists, and replay",
    "Are you sure you want to cancel?": "Are you sure you want to cancel?",
    "Your subscription ends on {date}": "Your subscription ends on {date}",
    "Your playlists will be waiting for you should you decide to subscribe again.": "Your playlists will be waiting for you should you decide to subscribe again.",
    "Keep Current Plan": "Keep Current Plan",
    "Got It": "Got It",
    "Cancel Plan": "Cancel Plan",
    "Trending - Just Now": "Trending - Just Now",
    "Help Center": "Help Center",
    "There was an error updating your email": "There was an error updating your email",
    "Update Contact Information": "Update Contact Information",
    "Please enter your first name": "Please enter your first name",
    "Add your first name": "Add your first name",
    "First Name": "First Name",
    "Please enter your last name": "Please enter your last name",
    "Add your last name": "Add your last name",
    "Last Name": "Last Name",
    "Please enter a valid phone number": "Please enter a valid phone number",
    "Phone Number": "Phone Number",
    "Visit Our {helpCenterLink}": "Visit Our {helpCenterLink}",
    "This email address is already associated with an iHeart account": "This email address is already associated with an iHeart account",
    "Emails must match": "Emails must match",
    "Change Email": "Change Email",
    "Please enter the same value again": "Please enter the same value again",
    "Please enter your password": "Please enter your password",
    "Or, Visit Our {helpCenterLink}": "Or, Visit Our {helpCenterLink}",
    "Password doesn't match our records": "",
    "Uh-oh passwords don't match": "",
    "Your new password cannot be the same as your current password": "",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign": "",
    "Update Password": "",
    "Old Password": "Old Password",
    "New Password": "New Password",
    "Confirm Password": "Confirm Password",
    "Update": "",
    "Are you sure you want to continue?": "Are you sure you want to continue?",
    "Signed Out": "Signed Out",
    "You have been signed out. Please log back in.": "You have been signed out. Please log back in.",
    "\xA9 {fourDigitYear} iHeartMedia, Inc.": "\xA9 {fourDigitYear} iHeartMedia, Inc.",
    "Help": "Help",
    "Terms of Use": "Terms of Use",
    'Playlist "{playlistName}" created': 'Playlist "{playlistName}" created',
    "Create unlimited playlists with iHeart All Access.": "Create unlimited playlists with iHeart All Access.",
    "There was an error creating your playlist": "There was an error creating your playlist",
    "Device Limit": "Device Limit",
    "This stream stopped because you're listening on another device.": "This stream stopped because you're listening on another device.",
    "Listen on this device": "Listen on this device",
    "Got it": "Got it",
    "Album saved to Your Library": "Album saved to Your Library",
    "Save Album": "Save Album",
    "Saved {name} to Your Library": "Saved {name} to Your Library",
    "Removed {name} from Your Library": "Removed {name} from Your Library",
    "Follow Artist": "Follow Artist",
    "Remove Artist": "Remove Artist",
    "Not for Me": "Not for Me",
    "Delete": "Delete",
    "Follow station": "Follow station",
    "Unfollow station": "Unfollow station",
    "Connect": "Connect",
    "Call ": "Call ",
    "Text ": "Text ",
    "Edit Playlist": "Edit Playlist",
    "Delete Playlist": "Delete Playlist",
    "Unfollow Playlist": "Unfollow Playlist",
    "Follow Playlist": "Follow Playlist",
    "Followed {title}": "Followed {title}",
    "Unfollowed {title}": "Unfollowed {title}",
    "Follow Podcast": "Follow Podcast",
    "Unfollow Podcast": "Unfollow Podcast",
    "No added songs yet": "No added songs yet",
    "Tap ": "Tap ",
    "Save": "Save",
    " on the player to add a song to My Playlist": " on the player to add a song to My Playlist",
    "Click on the": "Click on the",
    "button next to a song": "button next to a song",
    "and select Add to Playlist.": "and select Add to Playlist.",
    "Find Music": "Find Music",
    "Uh oh, we can\u2019t find the page you\u2019re looking for.": "Uh oh, we can\u2019t find the page you\u2019re looking for.",
    "How about this page instead: ": "How about this page instead: ",
    "Read more": "Read more",
    "Explicit": "Explicit",
    "E": "",
    "Invite sent to {email}": "Invite sent to {email}",
    "Add family member...": "Add family member...",
    "email@example.com": "email@example.com",
    "Send Invite": "Send Invite",
    "You": "You",
    "Active": "Active",
    "{email} has been removed.": "{email} has been removed.",
    "Remove Member": "Remove Member",
    "Cancel Invite": "Cancel Invite",
    "Resend Invite": "Resend Invite",
    "Invite was sent on ": "Invite was sent on ",
    "Active \u2713": "Active \u2713",
    "Pending...": "Pending...",
    "Invitees must be 14 years or older": "Invitees must be 14 years or older",
    "Owner": "Owner",
    "Following": "Following",
    "Follow": "Follow",
    "Music, radio and podcasts, all free. Listen online or download the iHeart App.": "Music, radio and podcasts, all free. Listen online or download the iHeart App.",
    "Connect with Facebook": "Connect with Facebook",
    "Connect with Twitter": "Connect with Twitter",
    "iHeart Instagram": "iHeart Instagram",
    "iHeart Youtube": "iHeart Youtube",
    "Explore": "Explore",
    "Live Radio": "Live Radio",
    "Podcasts": "Podcasts",
    "On Demand Podcasts": "On Demand Podcasts",
    "Artist Radio": "Artist Radio",
    "Playlists": "Playlists",
    "Genres": "Genres",
    "Browse by Genre": "Browse by Genre",
    "Exclusives": "Exclusives",
    "News": "News",
    "iHeart News": "iHeart News",
    "Features": "Features",
    "Featured Exclusives on iHeart": "Featured Exclusives on iHeart",
    "Events": "Events",
    "iHeart Events": "iHeart Events",
    "Contests": "Win",
    "iHeart Contests": "iHeart Contests",
    "Photos": "Photos",
    "iHeart Photos": "iHeart Photos",
    "Information": "Information",
    "About": "About",
    "About iHeart": "About iHeart",
    "Advertise": "Advertise",
    "Advertise on iHeart": "Advertise on iHeart",
    "Blog": "Blog",
    "iHeart Blog": "iHeart Blog",
    "Brand Guidelines": "Brand Guidelines",
    "iHeart Logo and Guidelines": "iHeart Logo and Guidelines",
    "Contest Guidelines": "Contest Guidelines",
    "iHeart Contest Rules": "iHeart Contest Rules",
    "Subscription Offers": "Subscription Offers",
    "Jobs": "Jobs",
    "iHeart Jobs": "iHeart Jobs",
    "Get the App": "Get the App",
    "Automotive": "Automotive",
    "iHeart in your house": "iHeart in your house",
    "Home": "Home",
    "iHeart in your car": "iHeart in your car",
    "Mobile": "Mobile",
    "iHeart on your phone or tablet": "iHeart on your phone or tablet",
    "Wearables": "Wearables",
    "iHeart wearables": "iHeart wearables",
    "Your Library": "Your Library",
    "Saved {name} to {savedStationsLink}": "Saved {name} to {savedStationsLink}",
    "Removed {name} from {savedStationsLink}": "Removed {name} from {savedStationsLink}",
    "Followed {podcastName}": "Followed {podcastName}",
    "Unfollowed {podcastName}": "Unfollowed {podcastName}",
    "We won't play this song again on this station.": "We won't play this song again on this station.",
    "Thanks for your feedback.": "Thanks for your feedback.",
    "favorite songs": "favourite songs",
    "We'll play more like it. Check out your {favoriteSongsLink} to see everything you've liked.": "We'll play more like it. Check out your {favoriteSongsLink} to see everything you've liked.",
    "We'll let our DJs know you've heard enough of this song.": "We'll let our DJs know you've heard enough of this song.",
    "Check out your {favoriteSongsLink} to see everything you've liked.": "Check out your {favoriteSongsLink} to see everything you've liked.",
    "Glad you like it. We'll let our DJs know.": "Glad you like it. We'll let our DJs know.",
    "OK, we'll adjust your music mix.": "OK, we'll adjust your music mix.",
    "Favorites Radio": "Favourites Radio",
    "Great, we\u2019ll add this song to your own {favoritesRadioLink}!": "Great, we\u2019ll add this song to your own {favoritesRadioLink}!",
    "Great, we\u2019ll play you more songs like this": "Great, we\u2019ll play you more songs like this",
    "We appreciate you letting us know.": "We appreciate you letting us know.",
    "Nice! You\u2019ll hear this song more often.": "Nice! You\u2019ll hear this song more often.",
    "You've reached your skip limit.": "You've reached your skip limit.",
    "We're sorry, you can't skip any more songs right now. You can still thumb down a song. Want to know more? Visit {helpLink}": "We're sorry, you can't skip any more songs right now. You can still thumb down a song. Want to know more? Visit {helpLink}",
    "Report this issue.": "Report this issue.",
    "There's an error with episodes for this show. {reportLink}": "There's an error with episodes for this show. {reportLink}",
    "There's an error with this content. {reportLink}": "There's an error with this content. {reportLink}",
    "Playlist followed and saved to {link}": "Playlist followed and saved to {link}",
    "Playlist unfollowed and removed from {link}": "Playlist unfollowed and removed from {link}",
    "Click here": "Click here",
    "Having trouble logging into iHeart with your Facebook or Google account? {clickHereLink} for help.": "Having trouble logging into iHeart with your Facebook or Google account? {clickHereLink} for help.",
    "More": "More",
    "Subscribe": "Subscribe",
    "Upgrade": "Upgrade",
    "Upgrade Now": "Upgrade Now",
    "Settings": "Settings",
    "Log Out": "Log Out",
    "Account": "Account",
    "Sponsor Content": "Sponsor Content",
    "Mark As Unplayed": "Mark As Unplayed",
    "Mark as Played": "Mark as Played",
    "This station is not currently available": "This station is not currently available",
    "Please pick a different station or listen to this station using our free iHeart app": "Please pick a different station or listen to this station using our free iHeart app",
    "Listen in App": "Listen in App",
    "You haven't thumbed up any songs yet.": "You haven't thumbed up any songs yet.",
    "Favorite Songs": "Favourite Songs",
    "NEW": "NEW",
    "Welcome to": "Welcome to",
    "Your Favorites Radio!": "Your Favourites Radio!",
    "All your favorites and thumbs up in one station. The more you interact with iHeart, the better it gets.": "All your favorites and thumbs up in one station. The more you interact with iHeart, the better it gets.",
    "Please name your station now:": "Please name your station now:",
    "Refresh": "Refresh",
    "On Air": "On Air",
    "Share": "Share",
    "Go To Album": "Go To Album",
    "Go To Artist": "Go To Artist",
    "Go To Station": "Go To Station",
    "Unfollow Station": "Unfollow Station",
    "Follow Station": "Follow Station",
    "Go To Your Library": "Go To Your Library",
    "Go To Playlist": "Go To Playlist",
    "Share Episode": "",
    "Share from": "",
    "Pause": "Pause",
    "Stop": "Stop",
    "Play": "Play",
    "Play Newest": "Play Newest",
    "Create unlimited playlists. Try iHeart All Access.": "Create unlimited playlists. Try iHeart All Access.",
    "My Music": "My Music",
    "Theme Radio": "Theme Radio",
    "Playlist": "Playlist",
    "Playlist by": "Playlist by",
    "Podcast": "Podcast",
    "Thanks for listening!": "Thanks for listening!",
    "Rename": "Rename",
    "Edit": "Edit",
    "Add to Another Playlist": "Add to Another Playlist",
    "Shuffle": "Shuffle",
    "Added By You": "Added By You",
    "Recently Played": "Recently Played",
    "You like {station} on Facebook": "You like {station} on Facebook",
    "You listened to {station}": "You listened to {station}",
    "You are near {city}": "You are near {city}",
    "You like {genre}": "You like {genre}",
    "Just For You": "Just For You",
    "Popular On {iHeart}": "Popular On {iHeart}",
    "Discover how you can save and replay music on your favorite radio stations, or download and listen offline to millions of songs!": "Discover how you can save and replay music on your favourite radio stations, or download and listen offline to millions of songs!",
    "iHeart Plus & All Access - Upgrade to a Free Trial": "iHeart Plus & All Access - Upgrade to a Free Trial",
    "Playlist deleted": "Playlist deleted",
    "Select a song to replay": "Select a song to replay",
    "Save Playlist": "Save Playlist",
    "All": "All",
    "Live Stations": "Live Stations",
    "Artists": "Artists",
    "Albums": "Albums",
    "Songs": "Songs",
    "artists, stations or podcasts": "artists, stations or podcasts",
    "stations or podcasts": "stations or podcasts",
    "podcasts": "podcasts",
    "search": "search",
    "Album{bulletSeparator}{artistName}": "Album{bulletSeparator}{artistName}",
    "Top Result": "Top Result",
    "Search Results": "Search Results",
    "Show More Results": "Show More Results",
    "Search iHeart for artists, stations or podcasts.": "Search iHeart for artists, stations or podcasts.",
    "Search iHeart for stations or podcasts.": "Search iHeart for stations or podcasts.",
    "Search iHeart for podcasts.": "Search iHeart for podcasts.",
    'There are no results for "{searchQuery}"': 'There are no results for "{searchQuery}"',
    "Check your spelling or try another search": "Check your spelling or try another search",
    "Show all Live Stations": "Show all Live Stations",
    "Show all Artists": "Show all Artists",
    "Show all Albums": "Show all Albums",
    "Show all Songs": "Show all Songs",
    "Show all Playlists": "Show all Playlists",
    "Show all Podcasts": "Show all Podcasts",
    "Show all {title}": "Show all {title}",
    "Embed Widget": "Embed Widget",
    "Twitter": "Twitter",
    "See {moreTiles} of {itemCount}": "See {moreTiles} of {itemCount}",
    "See All": "See All",
    "See Less": "See Less",
    "Get The App": "Get The App",
    "Connect with ": "Connect with ",
    "on your favorite social network ": "on your favourite social network ",
    " Song": " Song",
    "Keep Thumbing!": "Keep Thumbing!",
    "Thumbing up songs personalizes the stations you listen to and adds them to Your Favorites Radio.": "Thumbing up songs personalizes the stations you listen to and adds them to Your Favourites Radio.",
    "1 song": "1 song",
    "All your favorite songs and artists.": "All your favourite songs and artists.",
    "Show Less": "Show Less",
    "Show More": "Show More",
    "Schedule": "Schedule",
    "Listen offline": "Listen offline",
    "Unlimited skips": "Unlimited skips",
    "Save songs from radio to playlists": "Save songs from radio to playlists",
    "Instantly replay songs from radio": "Instantly replay songs from radio",
    "Create unlimited playlists": "Create unlimited playlists",
    "Play millions of songs on demand": "Play millions of songs on demand",
    "Now you can create your own playlists with All Access!": "Now you can create your own playlists with All Access!",
    "Start Free 30 Day Trial": "Start Free 30 Day Trial",
    "Subscribe to All Access": "Subscribe to All Access",
    "is now better than ever!": "is now better than ever!",
    "All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "All your favourite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favourite artists and bands.",
    "Stream thousands of the best live radio stations and custom artist stations for FREE - all in one app.": "Stream thousands of the best live radio stations and custom artist stations for FREE - all in one app.",
    "Stream thousands of the best live radio stations for FREE, plus unlimited music on demand - all in one app.": "Stream thousands of the best live radio stations for FREE, plus unlimited music on demand - all in one app.",
    "Stream thousands of the best live radio stations for FREE - all in one app.": "Stream thousands of the best live radio stations for FREE - all in one app.",
    "All Genres": "All Genres",
    "Featured": "Featured",
    "Popular": "Popular",
    "You are now logged in as {profileName}": "You are now logged in as {profileName}",
    "Artist": "Artist",
    "Song by": "",
    "Song": "Song",
    "Live Station": "",
    "Album by": "",
    "Album": "",
    "Email or password is invalid. Please try again.": "Email or password is invalid. Please try again.",
    "There was an issue playing the audio, please check your connection and try again.": "There was an issue playing the audio, please check your connection and try again.",
    "There was a connection problem. Please reconnect and try again.": "There was a connection problem. Please reconnect and try again.",
    "See More": "See More",
    "all access": "all access",
    "Best Playlists": "Best Playlists",
    "concert pictures": "concert pictures",
    "create playlists": "create playlists",
    "custom radio station": "custom radio station",
    "event pictures": "event pictures",
    "favorite music": "favourite music",
    "Music Playlists": "Music Playlists",
    "my music": "my music",
    "Now Playing": "Now Playing",
    "On Demand": "On Demand",
    "Online Playlists": "Online Playlists",
    "paid music": "paid music",
    "paid songs": "paid songs",
    "personal radio station": "personal radio station",
    "personalized radio station": "personalized radio station",
    "play songs": "play songs",
    "Top Playlists": "Top Playlists",
    "recent photos": "recent photos",
    "recent pictures": "recent pictures",
    "saved music": "saved music",
    "saved songs": "saved songs",
    "top playlists": "top playlists",
    "App": "App",
    "Bands": "Bands",
    "Best": "Best",
    "Discover": "Discover",
    "Download": "Download",
    "Free": "Free",
    "Influencers": "Influencers",
    "Influences": "Influences",
    "Internet": "Internet",
    "Listen": "Listen",
    "Live": "Live",
    "Music": "Music",
    "Online": "Online",
    "Personalized": "Personalized",
    "photos": "photos",
    "pictures": "pictures",
    "Radio": "Radio",
    "Related": "Related",
    "Similar": "Similar",
    "Station": "Station",
    "Stations": "Stations",
    "stream": "stream",
    "Streaming": "Streaming",
    "Talk": "Talk",
    "Top": "Top",
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dec",
    "Password must have": "",
    "iHeart: Listen to Free Radio Stations & Music Online | iHeart": "iHeart: Listen to Free Radio Stations & Music Online | iHeart",
    "1 Song": "1 Song",
    "Listen to music you love! Create a custom radio station based on your favorite album by {artistName} on iHeartRadio!": "Listen to music you love! Create a custom radio station based on your favourite album by {artistName} on iHeartRadio!",
    "Stream Free Music from Albums by {artistName}": "Stream Free Music from Albums by {artistName}",
    "Create Artist Radio Stations": "Create Artist Radio Stations",
    "Popular {genre} Artists": "Popular {genre} Artists",
    "Artist Radio gives you the power to create custom stations from your favorite songs, albums or musical artists. Listen for free on iHeart!": "Artist Radio gives you the power to create custom stations from your favorite songs, albums or musical artists. Listen for free on iHeart!",
    "Create a personalized custom music station from thousands of {name} artists you love, only on iHeart!": "Create a personalized custom music station from thousands of {name} artists you love, only on iHeart!",
    "Create Custom Radio Stations on Artist Radio!": "Create Custom Radio Stations on Artist Radio!",
    "Listen to the Best {name} Music for Free on iHeart": "Listen to the Best {name} Music for Free on iHeart",
    "{artistName}": "{artistName}",
    "{name}, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, News, Music, Headlines, iHeartRadio, iHeart, Radio",
    "Latest {name} news from iHeart": "Latest {name} news from iHeart",
    "Read the latest News on {name} Online": "Read the latest News on {name} Online",
    "Biography": "Biography",
    "Similar Artists": "Similar Artists",
    "Latest Release": "Latest Release",
    "Popular On": "Popular On",
    "This artist doesn't have any top songs.": "This artist doesn't have any top songs.",
    "Top Songs": "Top Songs",
    "Stream Music from Artists Like {artistName}": "Stream Music from Artists Like {artistName}",
    "Listen to music you'll love! Create a custom radio station from your favorite songs by {artistName} on iHeart.": "Listen to music you'll love! Create a custom radio station from your favorite songs by {artistName} on iHeart.",
    "Stream Free Songs by {artistName} & Similar Artists": "Stream Free Songs by {artistName} & Similar Artists",
    "Almost there! Verify your zipcode to unlock your spot on the Family Plan": "Almost there! Verify your zipcode to unlock your spot on the Family Plan",
    "In order to add you to the plan, we need to make sure that you live at the same address as the plan owner. Please input your zipcode below to verify and unlock your account.": "In order to add you to the plan, we need to make sure that you live at the same address as the plan owner. Please input your zipcode below to verify and unlock your account.",
    "Household Zipcode": "Household Zipcode",
    "e.g 90210...": "e.g 90210...",
    "help site": "help site",
    "It looks like you're already subscribed": "It looks like you're already subscribed",
    "You must cancel your active subscription before you can continue. You can find out how to cancel your subscription at {supportLink}. Once you've cancelled your current subscription plan you will need to wait until your current subscription plan ends.": "You must cancel your active subscription before you can continue. You can find out how to cancel your subscription at {supportLink}. Once you've cancelled your current subscription plan you will need to wait until your current subscription plan ends.",
    "If you have any questions, please {helplink} contact us.": "If you have any questions, please {helplink} contact us.",
    "Please create a free account, or sign in": "Please create a free account, or sign in",
    "To accept the Family Plan invitation, you must be logged in.": "To accept the Family Plan invitation, you must be logged in.",
    "Welcome to Your Favorites Radio, a personalized station containing your favorite songs and artists. The more you thumb up and save stations on iHeart, the better your listening experience will be.": "Welcome to Your Favorites Radio, a personalized station containing your favorite songs and artists. The more you thumb up and save stations on iHeart, the better your listening experience will be.",
    "Listen to {title}. Thumb up songs to add them to your own Your Favorites Radio station. Find it under My Stations.": "Listen to {title}. Thumb up songs to add them to your own Your Favorites Radio station. Find it under My Stations.",
    "Featured Artists On This Station": "Featured Artists On This Station",
    "{name}'s Favorites Radio": "{name}'s Favourites Radio",
    "iHeartRadio Mobile Apps": "iHeartRadio Mobile Apps",
    "Made for You": "Made for You",
    "Listen to Stations For You": "Listen to Stations For You",
    "Change genre preferences {prefLink}": "Change genre preferences {prefLink}",
    "here": "here",
    "iHeart: Listen to Free Radio Stations & Music Online": "iHeart: Listen to Free Radio Stations & Music Online",
    "All Your Favorite Music. All Your Favorite Stations. All FREE. Listen to thousands of live stations or create your own artist stations. Let the music play!": "All Your Favourite Music. All Your Favourite Stations. All FREE. Listen to thousands of live stations or create your own artist stations. Let the music play!",
    "Improve Your Recommendations": "Improve Your Recommendations",
    "Change Preferences": "Change Preferences",
    "Change Genre Preferences": "Change Genre Preferences",
    "Find Stations by Genre": "Find Stations by Genre",
    "Finding your ideal station is quick and easy. Search for stations by genre & stream them online for free on iHeart.": "Finding your ideal station is quick and easy. Search for stations by genre & stream them online for free on iHeart.",
    "Discover Music and Radio Stations by Genre on iHeart": "Discover Music and Radio Stations by Genre on iHeart",
    "Pick Genre": "Pick Genre",
    "Tell us all the genres you like.": "Tell us all the genres you like.",
    "We'll suggest stations just For You.": "We'll suggest stations just For You.",
    "Get Stations": "Get Stations",
    "Find and stream {genreName} music stations for free, only on iHeart.": "Find and stream {genreName} music stations for free, only on iHeart.",
    "Listen to {genreName} Radio Stations for Free": "Listen to {genreName} Radio Stations for Free",
    "Find {genreName} Stations": "Find {genreName} Stations",
    "Featured {genreName} Stations": "Featured {genreName} Stations",
    "Top {genreName} Stations": "Top {genreName} Stations",
    "Top {genreName} Artists": "Top {genreName} Artists",
    "More Genres": "More Genres",
    "Latest News": "Latest News",
    "Partner Content": "Partner Content",
    "All Cities": "All Cities",
    "for {currentGenre}": "for {currentGenre}",
    "in {currentMarket}": "in {currentMarket}",
    "near you": "near you",
    "Find top stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})": "Find top stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})",
    "Listen to Live Radio": "Listen to Live Radio",
    "No stations currently available for this filter": "No stations currently available for this filter",
    "Listen to the Best Live Radio Stations in {countryAbbreviation}": "Listen to the Best Live Radio Stations in {countryAbbreviation}",
    "Listen to {genreName} Radio Stations in {city}": "Listen to {genreName} Radio Stations in {city}",
    "Listen to Top Radio Stations in {city}, Free": "Listen to Top Radio Stations in {city}, Free",
    "Live {genreName} Radio Stations in {countryAbbreviation}": "Live {genreName} Radio Stations in {countryAbbreviation}",
    "Listen to hundreds of the best live radio stations{countryName}, for free! Search for stations near you & around the country.": "Listen to hundreds of the best live radio stations{countryName}, for free! Search for stations near you & around the country.",
    "Listen to the Best Live Radio{country} for Free on iHeart.": "Listen to the Best Live Radio{country} for Free on iHeart.",
    "Stream the best live {genreName} radio stations in {city} online for free, only on iHeart!": "Stream the best live {genreName} radio stations in {city} online for free, only on iHeart!",
    "Listen to Top {genreName} Radio Stations in {city}": "Listen to Top {genreName} Radio Stations in {city}",
    "Listen to the best live radio stations in {city}. Stream online for free, only on iHeart!": "Listen to the best live radio stations in {city}. Stream online for free, only on iHeart!",
    "Listen to Top Radio Stations in {city} for Free": "Listen to Top Radio Stations in {city} for Free",
    "Stream the best live {genreName} radio stations in {countryAbbreviation} for free on iHeart.": "Stream the best live {genreName} radio stations in {countryAbbreviation} for free on iHeart.",
    "Listen to Free, Live {genreName} Radio Stations in {countryAbbreviation} on iHeart": "Listen to Free, Live {genreName} Radio Stations in {countryAbbreviation} on iHeart",
    "Contests and Promotions": "Contests and Promotions",
    "If you like {stationName}...": "If you like {stationName}...",
    "Similar Stations": "Similar Stations",
    "{stationName}, {stateAbbreviation}, {city}, {genre}": "{stationName}, {stateAbbreviation}, {city}, {genre}",
    "Genre": "Genre",
    "Location": "Location",
    "On Air Schedule": "On Air Schedule",
    "Share Song": "Share Song",
    "Get the latest music news - rock, pop, hip-hop, rock, alternative, and country music news from iHeart. Get the latest music and trending news, from your favorite artists and bands.": "Get the latest music news - rock, pop, hip-hop, rock, alternative, and country music news from iHeart. Get the latest music and trending news, from your favourite artists and bands.",
    "Breaking Music News, Celeb and Entertainment News and Gossip": "Breaking Music News, Celeb and Entertainment News and Gossip",
    "Advertise With Us": "Advertise With Us",
    "Discover thousands of top playlists with songs handcrafted by your favorite personalities and music experts on iHeartRadio.": "Discover thousands of top playlists with songs handcrafted by your favourite personalities and music experts on iHeartRadio.",
    "Listen to the Best Online Music Playlists": "Listen to the Best Online Music Playlists",
    "Recommended For You": "Recommended For You",
    "Moods & Activities": "Moods & Activities",
    "Decades": "Decades",
    "Featured Playlists": "Featured Playlists",
    "By": "By",
    "Your songs shuffled with songs we think you\u2019ll like. The more songs you add, the better our picks get.": "Your songs shuffled with songs we think you\u2019ll like. The more songs you add, the better our picks get.",
    "Introducing a new playlist experience": "Introducing a new playlist experience",
    "Song saved to Your Library": "Song saved to Your Library",
    "Go to Artist": "Go to Artist",
    "Go to Album": "Go to Album",
    "Remove from Playlist": "Remove from Playlist",
    "SONG": "SONG",
    "ALBUM TITLE": "ALBUM TITLE",
    "ARTIST": "ARTIST",
    "DURATION": "DURATION",
    "Done": "Done",
    "Discover and stream the best {categoryTitle} playlists, handcrafted by the music experts at iHeart.": "Discover and stream the best {categoryTitle} playlists, handcrafted by the music experts at iHeart.",
    "{categoryTitle}, {categoryTitle} Playlists, Stream {categoryTitle} Music, Play {categoryTitle} Songs, Top {categoryTitle} Playlists, Best { categoryTitle} Playlists": "{categoryTitle}, {categoryTitle} Playlists, Stream {categoryTitle} Music, Play {categoryTitle} Songs, Top {categoryTitle} Playlists, Best { categoryTitle} Playlists",
    "Top {categoryTitle} Playlists; Find Your Perfect Music Mix": "Top {categoryTitle} Playlists; Find Your Perfect Music Mix",
    "Host": "Host",
    "iHeart Podcast Networks": "iHeart Podcast Networks",
    "{name}, Blog, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, Blog, News, Music, Headlines, iHeartRadio, iHeart, Radio",
    "{name} Blog, News & Videos": "{name} Blog, News & Videos",
    "Go behind the scenes, get exclusive stories and learn more about the show!": "Go behind the scenes, get exclusive stories and learn more about the show!",
    "Played": "Played",
    "Listen to the best {categoryName} radio shows, free and on demand, only on iHeart.": "Listen to the best {categoryName} radio shows, free and on demand, only on iHeart.",
    "Listen to the Best Free {categoryName} Podcasts": "Listen to the Best Free {categoryName} Podcasts",
    "On Demand, On-Demand, Show, Shows, Personalities, Programs, Listen, iHeartRadio, iHeart": "On Demand, On-Demand, Show, Shows, Personalities, Programs, Listen, iHeartRadio, iHeart",
    "Discover Top Podcasts": "Discover Top Podcasts",
    "Listen to the latest episodes from top podcasts. Get news, sports & lifestyle info from your favorite personalities for free!": "Listen to the latest episodes from top podcasts. Get news, sports & lifestyle info from your favourite personalities for free!",
    "Listen to the Best Podcasts Online for Free on iHeart": "Listen to the Best Podcasts Online for Free on iHeart",
    "Listen to the Best Podcasts & Shows Online, Free": "Listen to the Best Podcasts & Shows Online, Free",
    "Talk, Show, Host, Personality, On Demand, Topic, Category, Health, News, Politics, Comedy, Station, Internet, Online, iHeartRadio, iHeart": "Talk, Show, Host, Personality, On Demand, Topic, Category, Health, News, Politics, Comedy, Station, Internet, Online, iHeartRadio, iHeart",
    "Stream Top Podcasts": "Stream Top Podcasts",
    "All Topics": "All Topics",
    "{name} Podcasts": "{name} Podcasts",
    "Topics": "Topics",
    "All Episodes": "All Episodes",
    "These episodes aren't here yet...": "These episodes aren't here yet...",
    "Follow this podcast to be notified when they're ready": "Follow this podcast to be notified when they're ready",
    "Share Podcast": "",
    "The Latest News": "The Latest News",
    "Listen to {episodeTitle} | {showTitle} | Podcasts": "Listen to {episodeTitle} | {showTitle} | Podcasts",
    "{episodeTitle},{showTitle},Talk,Radio,Listen,On Demand,iHeartRadio,iHeart": "{episodeTitle},{showTitle},Talk,Radio,Listen,On Demand,iHeartRadio,iHeart",
    "{title}, Talk, Radio, Listen, On Demand, iHeartRadio, iHeart": "{title}, Talk, Radio, Listen, On Demand, iHeartRadio, iHeart",
    "Episodes": "Episodes",
    "Popular Podcasts": "Popular Podcasts",
    "Stream the best podcasts from your favorite stations": "Stream the best podcasts from your favourite stations",
    "Follow Us On": "Follow Us On",
    "Show Links": "Show Links",
    "Settings | See Your Music Profile": "Settings | See Your Music Profile",
    "Log in and see which live radio stations and custom artist stations you love. You can also view your listening history. All free.": "Log in and see which live radio stations and custom artist stations you love. You can also view your listening history. All free.",
    "Connections": "Connections",
    "Unlink": "Unlink",
    "Link": "Link",
    "Genre added.": "Genre added.",
    "Genre removed.": "Genre removed.",
    "You've added {genreName} to your genres.": "You've added {genreName} to your genres.",
    "You've removed {genreName} from your genres.": "You've removed {genreName} from your genres.",
    "Your preferences have been changed.": "Your preferences have been changed.",
    "Not provided": "Not provided",
    "Publish my listening activity to my Facebook music dashboard": "Publish my listening activity to my Facebook music dashboard",
    "Update your password, genre selection, and modify your subscription below.": "Update your password, genre selection, and modify your subscription below.",
    "You're currently signed in with a social account, add an email and password to have full access to your account": "You're currently signed in with a social account, add an email and password to have full access to your account",
    "Add New Email": "Add New Email",
    "Contact Information": "Contact Information",
    "Update your contact information to personalize your experience and easily enter iHeart contests and promotions.": "Update your contact information to personalize your experience and easily enter iHeart contests and promotions.",
    "First and Last Name": "First and Last Name",
    "Add your full name": "Add your full name",
    "My Genres": "My Genres",
    "Tell us all your favorite genres so we can make iHeart perfect for you.": "Tell us all your favorite genres so we can make iHeart perfect for you.",
    "View Recommendations": "View Recommendations",
    "Billing History": "Billing History",
    "Subscribe Again": "Subscribe Again",
    "Update Payment": "Update Payment",
    "Unknown": "Unknown",
    "Unknown Plan Description": "Unknown Plan Description",
    "iHeart Family Plan": "iHeart Family Plan",
    "You are enjoying an unlimited music experience with an iHeart Family Plan.": "You are enjoying an unlimited music experience with an iHeart Family Plan.",
    "iHeart All Access": "iHeart All Access",
    "You are enjoying an unlimited music experience by subscribing to iHeart All Access.": "You are enjoying an unlimited music experience by subscribing to iHeart All Access.",
    "iHeart Plus": "iHeart Plus",
    "You are subscribed to iHeart Plus. Switch to iHeart All Access to enjoy an unlimited music experience on your computer.": "You are subscribed to iHeart Plus. Switch to iHeart All Access to enjoy an unlimited music experience on your computer.",
    "iHeart Free": "iHeart Free",
    "Subscribe to enjoy unlimited music.": "Subscribe to enjoy unlimited music.",
    "Your subscription ends on {subscriptionEndsString}.": "Your subscription ends on {subscriptionEndsString}.",
    "Family Members": "Family Members",
    "Subscription": "Subscription",
    "Your Favorite Songs | Log In & See": "Your Favourite Songs | Log In & See",
    "Log in or sign up and find the songs you love here, only on iHeart.": "Log in or sign up and find the songs you love here, only on iHeart.",
    "iHeart Codes Coupons and Special Offers for Unlimited Music": "iHeart Codes Coupons and Special Offers for Unlimited Music",
    "Find iHeart Radio special offers, codes and coupons for unlimited music on demand and all access to iHeart Plus. These special offers provide access to millions of songs, thousands of radio and artists stations with unlimited skips and offline listening!": "Find iHeart Radio special offers, codes and coupons for unlimited music on demand and all access to iHeart Plus. These special offers provide access to millions of songs, thousands of radio and artists stations with unlimited skips and offline listening!",
    "There was an error validating your request.": "There was an error validating your request.",
    "Please enter a valid email address": "Please enter a valid email address",
    "Please fix the following errors:": "Please fix the following errors:",
    "Start Your Free 30 Day Trial": "Start Your Free 30 Day Trial",
    "Start Your Family Plan": "Start Your Family Plan",
    "Sign up for iHeart All Access Annual Plan": "Sign up for iHeart All Access Annual Plan",
    "View": "View",
    "Offer Terms": "Offer Terms",
    "Email Address": "Email Address",
    "Enter email address": "Enter email address",
    "Card Details": "Card Details",
    "Zip / Postal Code": "Zip / Postal Code",
    "Enter Here": "Enter Here",
    "Yes, please automatically renew my subscription annually (subject to {termsLink})": "Yes, please automatically renew my subscription annually (subject to {termsLink})",
    "terms & conditions": "terms & conditions",
    'Charges will appear on your credit card statement as "IHEART BILLING"': 'Charges will appear on your credit card statement as "IHEART BILLING"',
    'You can cancel at any time by going to "Settings" and following the cancellation instructions. By clicking "Subscribe" below, you agree to the conditions above and the iHeart ': 'You can cancel at any time by going to "Settings" and following the cancellation instructions. By clicking "Subscribe" below, you agree to the conditions above and the iHeart ',
    "Processing": "Processing",
    "Enter your email address below to log in by email or reset your password": "",
    "email": "email",
    "Send": "Send",
    "Don\u2019t use common passwords, like \u201CPassword123!\u201D": "",
    "Your password reset link is invalid or expired. Please try": "",
    "resetting your password": "",
    "again.": "",
    "Create a New Password": "Create a New Password",
    "Your password reset link has expired": "",
    "An unknown error occured. Please try again later": "",
    "Your password has been updated": "Your password has been updated",
    "Confirm New Password": "",
    "Create": "Create",
    "Custom radio stations based off your favorite artists and bands.": "Custom radio stations based off your favourite artists and bands.",
    "View More Artists": "View More Artists",
    "Bring iHeart with you anywhere": "Bring iHeart with you anywhere",
    "The free iHeart app is available on over 200 platforms, including Web, iOS, Android, Alexa, automobiles and more.": "The free iHeart app is available on over 200 platforms, including Web, iOS, Android, Alexa, automobiles and more.",
    "Download on the": "Download on the",
    "Download on": "Download on",
    "View All Apps": "View All Apps",
    "Upcoming Events": "Upcoming Events",
    "Listen to Your Favorite Music, Podcasts, and Radio Stations for Free! \u2013 iHeart": "Listen to Your Favorite Music, Podcasts, and Radio Stations for Free! \u2013 iHeart",
    "iHeart. All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "iHeart. All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.",
    "Get Started Free": "Get Started Free",
    "All your favorite music, radio and podcasts, all free.": "All your favourite music, radio and podcasts, all free.",
    "Your browser does not support video playback": "Your browser does not support video playback",
    "The best live stations from around the country, any time, any place.": "The best live stations from around the country, any time, any place.",
    "View More Live Stations": "View More Live Stations",
    "New on iHeart": "New on iHeart",
    "Latest Music News": "Latest Music News",
    "View More Music News": "View More Music News",
    "Popular and exclusive podcasts in a variety of genres and topics.": "Popular and exclusive podcasts in a variety of genres and topics.",
    "View More Podcasts": "View More Podcasts",
    "{count} song{plural}": "{count} song{plural}",
    "Browse Artists": "Browse Artists",
    "Need to find a great new album?": "Need to find a great new album?",
    "Any albums you save will show up here": "Any albums you save will show up here",
    "Need to find an artist you love?": "Need to find an artist you love?",
    "Any artists you follow will show up here": "Any artists you follow will show up here",
    "Access your music library and create unlimited playlists with iHeart All Access": "Access your music library and create unlimited playlists with iHeart All Access",
    "song{pluralSongs}": "song{pluralSongs}",
    "by": "by",
    "Browse Playlists": "Browse Playlists",
    "Need a playlist to fit your mood?": "Need a playlist to fit your mood?",
    "Any playlists you follow will show up here": "Any playlists you follow will show up here",
    "Browse Podcasts": "Browse Podcasts",
    "Need a great new podcast to start?": "Need a great new podcast to start?",
    "Any podcasts you follow will show up here": "Any podcasts you follow will show up here",
    "Any radio, music, or podcasts you listen to will show up here": "Any radio, music, or podcasts you listen to will show up here",
    "Browse Stations For You": "Browse Stations For You",
    "Any podcasts you listen to will show up here": "Any podcasts you listen to will show up here",
    "Need help finding something new?": "Need help finding something new?",
    "Remove station": "Remove station",
    "{name} removed from Your Library": "{name} removed from Your Library",
    "Followed Stations": "Followed Stations",
    "Browse Live Radio": "Browse Live Radio",
    "Browse Artist Radio": "Browse Artist Radio",
    "Need help finding stations to save?": "Need help finding stations to save?",
    "Your followed live and artist radio stations will show up here": "Your followed live and artist radio stations will show up here",
    "{albumName} removed from Your Library": "{albumName} removed from Your Library",
    "Remove": "Remove",
    "{artistName} removed from Your Library": "{artistName} removed from Your Library",
    "ARTIST IN YOUR LIBRARY": "ARTIST IN YOUR LIBRARY",
    "Add to playlist": "Add to playlist",
    "Play Now": "Play Now",
    "{songTitle} removed from Your Library": "{songTitle} removed from Your Library",
    "Need to find a new song?": "Need to find a new song?",
    "Any song you save will show up here": "Any song you save will show up here",
    "Playlist Radio": "Playlist Radio",
    "View All": "View All",
    "Copied": "Copied",
    "Read more on iHeartRadio": "Read more on iHeartRadio",
    "Link Copied!": "Link Copied!",
    "Copy Link": "Copy Link",
    "Code Copied!": "Code Copied!",
    "Embed": "Embed",
    "Follow on iHeartRadio": "Follow on iHeartRadio",
    "Playback not supported by device or browser.": "Playback not supported by device or browser.",
    "Method {method} not supported.": "Method {method} not supported.",
    "View iHeart.com": "View iHeart.com",
    "Oops, that wasn't supposed to happen.": "Oops, that wasn't supposed to happen.",
    "Oops, this feature isn't supported yet.": "Oops, this feature isn't supported yet.",
    "Oops! We had problems playing this stream.": "Oops! We had problems playing this stream.",
    "This station is not currently available in your country.": "This station is not currently available in your country.",
    "Retry": "Retry",
    "Report this issue": "Report this issue",
    "View Troubleshooting": "View Troubleshooting",
    "hello": "hello",
    "my friend": "my friend",
    "Share this live station": "Share this live station",
    "Create your own on iHeart": "Create your own on iHeart",
    "We're sorry! This playlist is not available in your country.": "We're sorry! This playlist is not available in your country.",
    "Playlist Not Available": "Playlist Not Available",
    "This playlist is unsupported in your current country.": "This playlist is unsupported in your current country.",
    "Playback Unsupported In Current Country": "Playback Unsupported In Current Country",
    "Featured artists in this playlist": "Featured artists in this playlist",
    "View Playlist": "View Playlist",
    "Share this episode": "Share this episode",
    "Listen to more episodes": "Listen to more episodes",
    "Share this podcast": "Share this podcast"
  },
  "en_NZ": {
    "Facebook": "Facebook",
    "Google": "Google",
    "Region Not Supported": "Region Not Supported",
    "Do not sell or share my personal information": "",
    "Log In": "Log In",
    "Sorry, an error occurred. Please try again later.": "Sorry, an error occurred. Please try again later.",
    "Don't have an account?": "Don't have an account?",
    "Sign up": "Sign up",
    "Forgot Password?": "Forgot Password?",
    "Email": "Email",
    "Password": "Password",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "Sorry for the inconvenience, but we do not allow account sign-up for your current location.",
    "Visit our Help Center": "Visit our Help Center",
    "Return to Log In": "Return to Log In",
    "Male": "Male",
    "Female": "Female",
    "Prefer not to say": "Prefer not to say",
    "Other": "Other",
    "8 to 32 characters": "",
    "an upper case and lower case letter": "",
    "a number (0-9)": "",
    "Error": "",
    "Success": "",
    "Password must have eight to thiry two characters": "",
    "Password doesn't have eight to thirty two characters": "",
    "Password has eight to thirty two characters": "",
    "Password must have an uppercase and lower case letter": "",
    "Password doesn't have an upper case and lower case letter": "",
    "Password has an upper case and lower case letter": "",
    "Password must have a number between zero and nine": "",
    "Password doesn't have a number between zero and nine": "",
    "password has a number between zero and nine": "",
    "Please fill out all form fields": "Please fill out all form fields",
    "Password shouldn't have common words or passwords": "",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "",
    "Invalid Email Address": "Invalid Email Address",
    "Birth Year": "Birth Year",
    "Terms of Service": "Terms of Service",
    "Privacy Policy": "Privacy Policy",
    "Sign Up": "Sign Up",
    "Postal Code": "Postal Code",
    "Invalid Postal Code": "Invalid Postal Code",
    "Invalid ZIP Code": "Invalid ZIP Code",
    "Have an account?": "Have an account?",
    "Login unsuccessful. Please try again later.": "Login unsuccessful. Please try again later.",
    "Update successful.": "Update successful.",
    "Your account has been linked to {provider}.": "Your account has been linked to {provider}.",
    "This {accountType} account is already linked to an iHeartRadio account": "This {accountType} account is already linked to an iHeartRadio account",
    "{accountType} account linking failed. Please try again later.": "{accountType} account linking failed. Please try again later.",
    "Your account has been unlinked from {provider}.": "Your account has been unlinked from {provider}.",
    "{accountType} account unlinking failed. Please try again later.": "{accountType} account unlinking failed. Please try again later.",
    "Login unsuccessful. Window closed before completion. Please try again.": "Login unsuccessful. Window closed before completion. Please try again.",
    "Do You Have a Popup Blocker?": "Do You Have a Popup Blocker?",
    "To log in with your Facebook or Google account, ensure you've allowed popups from www.iheart.com, refresh, and then try again.": "To log in with your Facebook or Google account, ensure you've allowed popups from www.iheart.com, refresh, and then try again.",
    "Feat. {artistNames} and more": "Feat. {artistNames} and more",
    "iHeart": "iHeart",
    "For You": "For You",
    "Add to Playlist": "Add to Playlist",
    "Episode Info": "Episode Info",
    "Lyrics": "Lyrics",
    "Rename your Favorites Radio station now.": "Rename your Favourites Radio station now.",
    "This song is not available to start your station.": "This song is not available to start your station.",
    "Play this on web with All Access": "Play this on web with All Access",
    "Subscribe today for unlimited access to playlists": "Subscribe today for unlimited access to playlists",
    "Play the whole album with iHeart All Access.": "Play the whole album with iHeart All Access.",
    "Listen History": "Listen History",
    "Custom Stations Limit Exceeded": "Custom Stations Limit Exceeded",
    "Please delete some stations from your account under {listenHistoryLink} before creating new stations.": "Please delete some stations from your account under {listenHistoryLink} before creating new stations.",
    "Sorry, this station has run out of songs to play.": "Sorry, this station has run out of songs to play.",
    "Oops": "Oops",
    "We don't have enough info to create a custom station right now. We'll let our DJs know.": "We don't have enough info to create a custom station right now. We'll let our DJs know.",
    "Replay failed": "Replay failed",
    "An unknown error occurred. Please try again later.": "An unknown error occurred. Please try again later.",
    "Update Account": "Update Account",
    "Please enter a valid email": "Please enter a valid email",
    "New Email": "New Email",
    "Please enter the same email again": "Please enter the same email again",
    "Confirm New Email": "Confirm New Email",
    "Password must be 6 - 32 characters": "Password must be 6 - 32 characters",
    "New Password (6-32 Characters)": "New Password (6-32 Characters)",
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "Cannot add duplicate tracks to a playlist": "Cannot add duplicate tracks to a playlist",
    "Added {contentType} to {playlistName}": "Added {contentType} to {playlistName}",
    "Added song to {playlistName}": "Added song to {playlistName}",
    "Ok": "Ok",
    "Success!": "Success!",
    "Your email and password have been added to your account.": "Your email and password have been added to your account.",
    "Your email has been saved.": "Your email has been saved.",
    "Your contact information has been saved.": "Your contact information has been saved.",
    "Try Again": "Try Again",
    "For assistance, please visit our {helplink}.": "For assistance, please visit our {helplink}.",
    "Help Link": "Help Link",
    "Oops!": "Oops!",
    "Get Started": "Get Started",
    "You can now enjoy the full benefits of iHeart All Access for Family.": "You can now enjoy the full benefits of iHeart All Access for Family.",
    "Welcome to the Family!": "Welcome to the Family!",
    "Your password has been saved.": "Your password has been saved.",
    "Station Not Available": "Station Not Available",
    "We're sorry! This station is not available in your country.": "We're sorry! This station is not available in your country.",
    "Updated {updateDateAndTime}": "Updated {updateDateAndTime}",
    "Please complete the CAPTCHA": "Please complete the CAPTCHA",
    "Check Your Email": "",
    "Forgot Password": "Forgot Password",
    "Enter your email address below to log in by email or reset your password.": "Enter your email address below to log in by email or reset your password.",
    "Enter your email address below to reset your password.": "Enter your email address below to reset your password.",
    "If an account exists, you'll receive a password reset link shortly. Check your spam folder if it takes more than a minute or two.": "",
    "Okay": "",
    "Back to login": "Back to login",
    "Submit": "Submit",
    "Or, {backToLoginLink}": "Or, {backToLoginLink}",
    "Gender": "Gender",
    "Music and radio on demand": "Music and radio on demand",
    "Please log in first.": "Please log in first.",
    "Login": "Login",
    "To listen to thousands of live radio and artist stations, create a free account.": "To listen to thousands of live radio and artist stations, create a free account.",
    "To listen to thousands of live radio stations, create a free account.": "To listen to thousands of live radio stations, create a free account.",
    "Connect with your favorites": "Connect with your favourites",
    "To easily find your favorite and recently listened to stations, create a free account.": "To easily find your favourite and recently listened to stations, create a free account.",
    "Access your stations": "Access your stations",
    "To view recently listened to stations and songs, create a free account.": "To view recently listened to stations and songs, create a free account.",
    "See what you've been listening to": "See what you've been listening to",
    "To access your favorites anytime, anywhere, create a free account.": "To access your favourites anytime, anywhere, create a free account.",
    "Save stations you love": "Save stations you love",
    "To hear more music you like, create a free account.": "To hear more music you like, create a free account.",
    "Personalize your listening": "Personalize your listening",
    "To listen to this artist and more, without interruption, create your free account.": "To listen to this artist and more, without interruption, create your free account.",
    "Listen to {stationName}": "Listen to {stationName}",
    "Listen to Artist Stations": "Listen to Artist Stations",
    "To listen to music based on this song, create your free account.": "To listen to music based on this song, create your free account.",
    "Listen to songs like {stationName}": "Listen to songs like {stationName}",
    "Listen to songs like this": "Listen to songs like this",
    "To listen to this podcast and more, create your free account.": "To listen to this podcast and more, create your free account.",
    "Listen to Podcasts": "Listen to Podcasts",
    "To hear all your favorite songs and artists on your own personal station, create a free account.": "To hear all your favourite songs and artists on your own personal station, create a free account.",
    "Listen to {stationName}!": "Listen to {stationName}!",
    "Listen to Your Favorites Radio!": "Listen to Your Favourites Radio!",
    "To listen, create a free account.": "To listen, create a free account.",
    "Listen to Favorites Radio!": "Listen to Favourites Radio!",
    "All your favorite music. All your favorite stations. All free.": "All your favourite music. All your favourite stations. All free.",
    "Create Your iHeart Account": "Create Your iHeart Account",
    "Please create a free account.": "Please create a free account.",
    "Register first": "Register first",
    "Create a FREE account to add songs and albums to your playlist": "Create a FREE account to add songs and albums to your playlist",
    "Welcome to the All Access FREE Preview Weekend. Create your FREE account and listen to millions of songs, live radio, playlists, and podcasts \u2013 enjoy All Access, FREE this weekend only.": "Welcome to the All Access FREE Preview Weekend. Create your FREE account and listen to millions of songs, live radio, playlists, and podcasts \u2013 enjoy All Access, FREE this weekend only.",
    "Your Halloween treat is here": "Your Halloween treat is here",
    "To join the Family Plan you've been invited to, please create a free account": "To join the Family Plan you've been invited to, please create a free account",
    "Create a free account to join your Family Plan": "Create a free account to join your Family Plan",
    "Please correct all password errors": "",
    "Sorry, you are not eligible to register for iHeart": "Sorry, you are not eligible to register for iHeart",
    "Zip Code": "Zip Code",
    "Please enter a valid birth year": "Please enter a valid birth year",
    "Receive email updates on stations I listen to and more from iHeart.": "Receive email updates on stations I listen to and more from iHeart.",
    "By creating an account, you also agree to our {termsOfServiceLink} and {privacyPolicyLink}.": "By creating an account, you also agree to our {termsOfServiceLink} and {privacyPolicyLink}.",
    "Or Connect With": "Or Connect With",
    "Login with Facebook": "Login with Facebook",
    "Login with Google": "Login with Google",
    "Added By iHeart": "Added By iHeart",
    "Suggestions based on the songs you added.": "Suggestions based on the songs you added.",
    "You have All Access": "You have All Access",
    "Upgrade to All Access": "Upgrade to All Access",
    "Want to keep enjoying these perks after the weekend?": "Want to keep enjoying these perks after the weekend?",
    "Listen offline, unlimited skips, save and play songs from the radio.": "Listen offline, unlimited skips, save and play songs from the radio.",
    "Learn More": "Learn More",
    "Start 30 Day Free Trial": "Start 30 Day Free Trial",
    "You will lose unlimited skips, replay, and access to your playlist": "You will lose unlimited skips, replay, and access to your playlist",
    "You will lose offline listening, unlimited playlists, and replay": "You will lose offline listening, unlimited playlists, and replay",
    "Are you sure you want to cancel?": "Are you sure you want to cancel?",
    "Your subscription ends on {date}": "Your subscription ends on {date}",
    "Your playlists will be waiting for you should you decide to subscribe again.": "Your playlists will be waiting for you should you decide to subscribe again.",
    "Keep Current Plan": "Keep Current Plan",
    "Got It": "Got It",
    "Cancel Plan": "Cancel Plan",
    "Trending - Just Now": "Trending - Just Now",
    "Help Center": "Help Center",
    "There was an error updating your email": "There was an error updating your email",
    "Update Contact Information": "Update Contact Information",
    "Please enter your first name": "Please enter your first name",
    "Add your first name": "Add your first name",
    "First Name": "First Name",
    "Please enter your last name": "Please enter your last name",
    "Add your last name": "Add your last name",
    "Last Name": "Last Name",
    "Please enter a valid phone number": "Please enter a valid phone number",
    "Phone Number": "Phone Number",
    "Visit Our {helpCenterLink}": "Visit Our {helpCenterLink}",
    "This email address is already associated with an iHeart account": "This email address is already associated with an iHeart account",
    "Emails must match": "Emails must match",
    "Change Email": "Change Email",
    "Please enter the same value again": "Please enter the same value again",
    "Please enter your password": "Please enter your password",
    "Or, Visit Our {helpCenterLink}": "Or, Visit Our {helpCenterLink}",
    "Password doesn't match our records": "",
    "Uh-oh passwords don't match": "",
    "Your new password cannot be the same as your current password": "",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign": "",
    "Update Password": "",
    "Old Password": "Old Password",
    "New Password": "New Password",
    "Confirm Password": "Confirm Password",
    "Update": "",
    "Are you sure you want to continue?": "Are you sure you want to continue?",
    "Signed Out": "Signed Out",
    "You have been signed out. Please log back in.": "You have been signed out. Please log back in.",
    "\xA9 {fourDigitYear} iHeartMedia, Inc.": "\xA9 {fourDigitYear} iHeartMedia, Inc.",
    "Help": "Help",
    "Terms of Use": "Terms of Use",
    'Playlist "{playlistName}" created': 'Playlist "{playlistName}" created',
    "Create unlimited playlists with iHeart All Access.": "Create unlimited playlists with iHeart All Access.",
    "There was an error creating your playlist": "There was an error creating your playlist",
    "Device Limit": "Device Limit",
    "This stream stopped because you're listening on another device.": "This stream stopped because you're listening on another device.",
    "Listen on this device": "Listen on this device",
    "Got it": "Got it",
    "Album saved to Your Library": "Album saved to Your Library",
    "Save Album": "Save Album",
    "Saved {name} to Your Library": "Saved {name} to Your Library",
    "Removed {name} from Your Library": "Removed {name} from Your Library",
    "Follow Artist": "Follow Artist",
    "Remove Artist": "Remove Artist",
    "Not for Me": "Not for Me",
    "Delete": "Delete",
    "Follow station": "Follow station",
    "Unfollow station": "Unfollow station",
    "Connect": "Connect",
    "Call ": "Call ",
    "Text ": "Text ",
    "Edit Playlist": "Edit Playlist",
    "Delete Playlist": "Delete Playlist",
    "Unfollow Playlist": "Unfollow Playlist",
    "Follow Playlist": "Follow Playlist",
    "Followed {title}": "Followed {title}",
    "Unfollowed {title}": "Unfollowed {title}",
    "Follow Podcast": "Follow Podcast",
    "Unfollow Podcast": "Unfollow Podcast",
    "No added songs yet": "No added songs yet",
    "Tap ": "Tap ",
    "Save": "Save",
    " on the player to add a song to My Playlist": " on the player to add a song to My Playlist",
    "Click on the": "Click on the",
    "button next to a song": "button next to a song",
    "and select Add to Playlist.": "and select Add to Playlist.",
    "Find Music": "Find Music",
    "Uh oh, we can\u2019t find the page you\u2019re looking for.": "Uh oh, we can\u2019t find the page you\u2019re looking for.",
    "How about this page instead: ": "How about this page instead: ",
    "Read more": "Read more",
    "Explicit": "Explicit",
    "E": "",
    "Invite sent to {email}": "Invite sent to {email}",
    "Add family member...": "Add family member...",
    "email@example.com": "email@example.com",
    "Send Invite": "Send Invite",
    "You": "You",
    "Active": "Active",
    "{email} has been removed.": "{email} has been removed.",
    "Remove Member": "Remove Member",
    "Cancel Invite": "Cancel Invite",
    "Resend Invite": "Resend Invite",
    "Invite was sent on ": "Invite was sent on ",
    "Active \u2713": "Active \u2713",
    "Pending...": "Pending...",
    "Invitees must be 14 years or older": "Invitees must be 14 years or older",
    "Owner": "Owner",
    "Following": "Following",
    "Follow": "Follow",
    "Music, radio and podcasts, all free. Listen online or download the iHeart App.": "Music, radio and podcasts, all free. Listen online or download the iHeart App.",
    "Connect with Facebook": "Connect with Facebook",
    "Connect with Twitter": "Connect with Twitter",
    "iHeart Instagram": "iHeart Instagram",
    "iHeart Youtube": "iHeart Youtube",
    "Explore": "Explore",
    "Live Radio": "Live Radio",
    "Podcasts": "Podcasts",
    "On Demand Podcasts": "On Demand Podcasts",
    "Artist Radio": "Artist Radio",
    "Playlists": "Playlists",
    "Genres": "Genres",
    "Browse by Genre": "Browse by Genre",
    "Exclusives": "Exclusives",
    "News": "News",
    "iHeart News": "iHeart News",
    "Features": "Features",
    "Featured Exclusives on iHeart": "Featured Exclusives on iHeart",
    "Events": "Events",
    "iHeart Events": "iHeart Events",
    "Contests": "Win",
    "iHeart Contests": "iHeart Contests",
    "Photos": "Photos",
    "iHeart Photos": "iHeart Photos",
    "Information": "Information",
    "About": "About",
    "About iHeart": "About iHeart",
    "Advertise": "Advertise",
    "Advertise on iHeart": "Advertise on iHeart",
    "Blog": "Blog",
    "iHeart Blog": "iHeart Blog",
    "Brand Guidelines": "Brand Guidelines",
    "iHeart Logo and Guidelines": "iHeart Logo and Guidelines",
    "Contest Guidelines": "Contest Guidelines",
    "iHeart Contest Rules": "iHeart Contest Rules",
    "Subscription Offers": "Subscription Offers",
    "Jobs": "Jobs",
    "iHeart Jobs": "iHeart Jobs",
    "Get the App": "Get the App",
    "Automotive": "Automotive",
    "iHeart in your house": "iHeart in your house",
    "Home": "Home",
    "iHeart in your car": "iHeart in your car",
    "Mobile": "Mobile",
    "iHeart on your phone or tablet": "iHeart on your phone or tablet",
    "Wearables": "Wearables",
    "iHeart wearables": "iHeart wearables",
    "Your Library": "Your Library",
    "Saved {name} to {savedStationsLink}": "Saved {name} to {savedStationsLink}",
    "Removed {name} from {savedStationsLink}": "Removed {name} from {savedStationsLink}",
    "Followed {podcastName}": "Followed {podcastName}",
    "Unfollowed {podcastName}": "Unfollowed {podcastName}",
    "We won't play this song again on this station.": "We won't play this song again on this station.",
    "Thanks for your feedback.": "Thanks for your feedback.",
    "favorite songs": "favourite songs",
    "We'll play more like it. Check out your {favoriteSongsLink} to see everything you've liked.": "We'll play more like it. Check out your {favoriteSongsLink} to see everything you've liked.",
    "We'll let our DJs know you've heard enough of this song.": "We'll let our DJs know you've heard enough of this song.",
    "Check out your {favoriteSongsLink} to see everything you've liked.": "Check out your {favoriteSongsLink} to see everything you've liked.",
    "Glad you like it. We'll let our DJs know.": "Glad you like it. We'll let our DJs know.",
    "OK, we'll adjust your music mix.": "OK, we'll adjust your music mix.",
    "Favorites Radio": "Favourites Radio",
    "Great, we\u2019ll add this song to your own {favoritesRadioLink}!": "Great, we\u2019ll add this song to your own {favoritesRadioLink}!",
    "Great, we\u2019ll play you more songs like this": "Great, we\u2019ll play you more songs like this",
    "We appreciate you letting us know.": "We appreciate you letting us know.",
    "Nice! You\u2019ll hear this song more often.": "Nice! You\u2019ll hear this song more often.",
    "You've reached your skip limit.": "You've reached your skip limit.",
    "We're sorry, you can't skip any more songs right now. You can still thumb down a song. Want to know more? Visit {helpLink}": "We're sorry, you can't skip any more songs right now. You can still thumb down a song. Want to know more? Visit {helpLink}",
    "Report this issue.": "Report this issue.",
    "There's an error with episodes for this show. {reportLink}": "There's an error with episodes for this show. {reportLink}",
    "There's an error with this content. {reportLink}": "There's an error with this content. {reportLink}",
    "Playlist followed and saved to {link}": "Playlist followed and saved to {link}",
    "Playlist unfollowed and removed from {link}": "Playlist unfollowed and removed from {link}",
    "Click here": "Click here",
    "Having trouble logging into iHeart with your Facebook or Google account? {clickHereLink} for help.": "Having trouble logging into iHeart with your Facebook or Google account? {clickHereLink} for help.",
    "More": "More",
    "Subscribe": "Subscribe",
    "Upgrade": "Upgrade",
    "Upgrade Now": "Upgrade Now",
    "Settings": "Settings",
    "Log Out": "Log Out",
    "Account": "Account",
    "Sponsor Content": "Sponsor Content",
    "Mark As Unplayed": "Mark As Unplayed",
    "Mark as Played": "Mark as Played",
    "This station is not currently available": "This station is not currently available",
    "Please pick a different station or listen to this station using our free iHeart app": "Please pick a different station or listen to this station using our free iHeart app",
    "Listen in App": "Listen in App",
    "You haven't thumbed up any songs yet.": "You haven't thumbed up any songs yet.",
    "Favorite Songs": "Favourite Songs",
    "NEW": "NEW",
    "Welcome to": "Welcome to",
    "Your Favorites Radio!": "Your Favourites Radio!",
    "All your favorites and thumbs up in one station. The more you interact with iHeart, the better it gets.": "All your favorites and thumbs up in one station. The more you interact with iHeart, the better it gets.",
    "Please name your station now:": "Please name your station now:",
    "Refresh": "Refresh",
    "On Air": "On Air",
    "Share": "Share",
    "Go To Album": "Go To Album",
    "Go To Artist": "Go To Artist",
    "Go To Station": "Go To Station",
    "Unfollow Station": "Unfollow Station",
    "Follow Station": "Follow Station",
    "Go To Your Library": "Go To Your Library",
    "Go To Playlist": "Go To Playlist",
    "Share Episode": "",
    "Share from": "",
    "Pause": "Pause",
    "Stop": "Stop",
    "Play": "Play",
    "Play Newest": "Play Newest",
    "Create unlimited playlists. Try iHeart All Access.": "Create unlimited playlists. Try iHeart All Access.",
    "My Music": "My Music",
    "Theme Radio": "Theme Radio",
    "Playlist": "Playlist",
    "Playlist by": "Playlist by",
    "Podcast": "Podcast",
    "Thanks for listening!": "Thanks for listening!",
    "Rename": "Rename",
    "Edit": "Edit",
    "Add to Another Playlist": "Add to Another Playlist",
    "Shuffle": "Shuffle",
    "Added By You": "Added By You",
    "Recently Played": "Recently Played",
    "You like {station} on Facebook": "You like {station} on Facebook",
    "You listened to {station}": "You listened to {station}",
    "You are near {city}": "You are near {city}",
    "You like {genre}": "You like {genre}",
    "Just For You": "Just For You",
    "Popular On {iHeart}": "Popular On {iHeart}",
    "Discover how you can save and replay music on your favorite radio stations, or download and listen offline to millions of songs!": "Discover how you can save and replay music on your favourite radio stations, or download and listen offline to millions of songs!",
    "iHeart Plus & All Access - Upgrade to a Free Trial": "iHeart Plus & All Access - Upgrade to a Free Trial",
    "Playlist deleted": "Playlist deleted",
    "Select a song to replay": "Select a song to replay",
    "Save Playlist": "Save Playlist",
    "All": "All",
    "Live Stations": "Live Stations",
    "Artists": "Artists",
    "Albums": "Albums",
    "Songs": "Songs",
    "artists, stations or podcasts": "artists, stations or podcasts",
    "stations or podcasts": "stations or podcasts",
    "podcasts": "podcasts",
    "search": "search",
    "Album{bulletSeparator}{artistName}": "Album{bulletSeparator}{artistName}",
    "Top Result": "Top Result",
    "Search Results": "Search Results",
    "Show More Results": "Show More Results",
    "Search iHeart for artists, stations or podcasts.": "Search iHeart for artists, stations or podcasts.",
    "Search iHeart for stations or podcasts.": "Search iHeart for stations or podcasts.",
    "Search iHeart for podcasts.": "Search iHeart for podcasts.",
    'There are no results for "{searchQuery}"': 'There are no results for "{searchQuery}"',
    "Check your spelling or try another search": "Check your spelling or try another search",
    "Show all Live Stations": "Show all Live Stations",
    "Show all Artists": "Show all Artists",
    "Show all Albums": "Show all Albums",
    "Show all Songs": "Show all Songs",
    "Show all Playlists": "Show all Playlists",
    "Show all Podcasts": "Show all Podcasts",
    "Show all {title}": "Show all {title}",
    "Embed Widget": "Embed Widget",
    "Twitter": "Twitter",
    "See {moreTiles} of {itemCount}": "See {moreTiles} of {itemCount}",
    "See All": "See All",
    "See Less": "See Less",
    "Get The App": "Get The App",
    "Connect with ": "Connect with ",
    "on your favorite social network ": "on your favourite social network ",
    " Song": " Song",
    "Keep Thumbing!": "Keep Thumbing!",
    "Thumbing up songs personalizes the stations you listen to and adds them to Your Favorites Radio.": "Thumbing up songs personalizes the stations you listen to and adds them to Your Favourites Radio.",
    "1 song": "1 song",
    "All your favorite songs and artists.": "All your favourite songs and artists.",
    "Show Less": "Show Less",
    "Show More": "Show More",
    "Schedule": "Schedule",
    "Listen offline": "Listen offline",
    "Unlimited skips": "Unlimited skips",
    "Save songs from radio to playlists": "Save songs from radio to playlists",
    "Instantly replay songs from radio": "Instantly replay songs from radio",
    "Create unlimited playlists": "Create unlimited playlists",
    "Play millions of songs on demand": "Play millions of songs on demand",
    "Now you can create your own playlists with All Access!": "Now you can create your own playlists with All Access!",
    "Start Free 30 Day Trial": "Start Free 30 Day Trial",
    "Subscribe to All Access": "Subscribe to All Access",
    "is now better than ever!": "is now better than ever!",
    "All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "All your favourite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favourite artists and bands.",
    "Stream thousands of the best live radio stations and custom artist stations for FREE - all in one app.": "Stream thousands of the best live radio stations and custom artist stations for FREE - all in one app.",
    "Stream thousands of the best live radio stations for FREE, plus unlimited music on demand - all in one app.": "Stream thousands of the best live radio stations for FREE, plus unlimited music on demand - all in one app.",
    "Stream thousands of the best live radio stations for FREE - all in one app.": "Stream thousands of the best live radio stations for FREE - all in one app.",
    "All Genres": "All Genres",
    "Featured": "Featured",
    "Popular": "Popular",
    "You are now logged in as {profileName}": "You are now logged in as {profileName}",
    "Artist": "Artist",
    "Song by": "",
    "Song": "Song",
    "Live Station": "",
    "Album by": "",
    "Album": "",
    "Email or password is invalid. Please try again.": "Email or password is invalid. Please try again.",
    "There was an issue playing the audio, please check your connection and try again.": "There was an issue playing the audio, please check your connection and try again.",
    "There was a connection problem. Please reconnect and try again.": "There was a connection problem. Please reconnect and try again.",
    "See More": "See More",
    "all access": "all access",
    "Best Playlists": "Best Playlists",
    "concert pictures": "concert pictures",
    "create playlists": "create playlists",
    "custom radio station": "custom radio station",
    "event pictures": "event pictures",
    "favorite music": "favourite music",
    "Music Playlists": "Music Playlists",
    "my music": "my music",
    "Now Playing": "Now Playing",
    "On Demand": "On Demand",
    "Online Playlists": "Online Playlists",
    "paid music": "paid music",
    "paid songs": "paid songs",
    "personal radio station": "personal radio station",
    "personalized radio station": "personalized radio station",
    "play songs": "play songs",
    "Top Playlists": "Top Playlists",
    "recent photos": "recent photos",
    "recent pictures": "recent pictures",
    "saved music": "saved music",
    "saved songs": "saved songs",
    "top playlists": "top playlists",
    "App": "App",
    "Bands": "Bands",
    "Best": "Best",
    "Discover": "Discover",
    "Download": "Download",
    "Free": "Free",
    "Influencers": "Influencers",
    "Influences": "Influences",
    "Internet": "Internet",
    "Listen": "Listen",
    "Live": "Live",
    "Music": "Music",
    "Online": "Online",
    "Personalized": "Personalized",
    "photos": "photos",
    "pictures": "pictures",
    "Radio": "Radio",
    "Related": "Related",
    "Similar": "Similar",
    "Station": "Station",
    "Stations": "Stations",
    "stream": "stream",
    "Streaming": "Streaming",
    "Talk": "Talk",
    "Top": "Top",
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dec",
    "Password must have": "",
    "iHeart: Listen to Free Radio Stations & Music Online | iHeart": "iHeart: Listen to Free Radio Stations & Music Online | iHeart",
    "1 Song": "1 Song",
    "Listen to music you love! Create a custom radio station based on your favorite album by {artistName} on iHeartRadio!": "Listen to music you love! Create a custom radio station based on your favourite album by {artistName} on iHeartRadio!",
    "Stream Free Music from Albums by {artistName}": "Stream Free Music from Albums by {artistName}",
    "Create Artist Radio Stations": "Create Artist Radio Stations",
    "Popular {genre} Artists": "Popular {genre} Artists",
    "Artist Radio gives you the power to create custom stations from your favorite songs, albums or musical artists. Listen for free on iHeart!": "Artist Radio gives you the power to create custom stations from your favorite songs, albums or musical artists. Listen for free on iHeart!",
    "Create a personalized custom music station from thousands of {name} artists you love, only on iHeart!": "Create a personalized custom music station from thousands of {name} artists you love, only on iHeart!",
    "Create Custom Radio Stations on Artist Radio!": "Create Custom Radio Stations on Artist Radio!",
    "Listen to the Best {name} Music for Free on iHeart": "Listen to the Best {name} Music for Free on iHeart",
    "{artistName}": "{artistName}",
    "{name}, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, News, Music, Headlines, iHeartRadio, iHeart, Radio",
    "Latest {name} news from iHeart": "Latest {name} news from iHeart",
    "Read the latest News on {name} Online": "Read the latest News on {name} Online",
    "Biography": "Biography",
    "Similar Artists": "Similar Artists",
    "Latest Release": "Latest Release",
    "Popular On": "Popular On",
    "This artist doesn't have any top songs.": "This artist doesn't have any top songs.",
    "Top Songs": "Top Songs",
    "Stream Music from Artists Like {artistName}": "Stream Music from Artists Like {artistName}",
    "Listen to music you'll love! Create a custom radio station from your favorite songs by {artistName} on iHeart.": "Listen to music you'll love! Create a custom radio station from your favorite songs by {artistName} on iHeart.",
    "Stream Free Songs by {artistName} & Similar Artists": "Stream Free Songs by {artistName} & Similar Artists",
    "Almost there! Verify your zipcode to unlock your spot on the Family Plan": "Almost there! Verify your zipcode to unlock your spot on the Family Plan",
    "In order to add you to the plan, we need to make sure that you live at the same address as the plan owner. Please input your zipcode below to verify and unlock your account.": "In order to add you to the plan, we need to make sure that you live at the same address as the plan owner. Please input your zipcode below to verify and unlock your account.",
    "Household Zipcode": "Household Zipcode",
    "e.g 90210...": "e.g 90210...",
    "help site": "help site",
    "It looks like you're already subscribed": "It looks like you're already subscribed",
    "You must cancel your active subscription before you can continue. You can find out how to cancel your subscription at {supportLink}. Once you've cancelled your current subscription plan you will need to wait until your current subscription plan ends.": "You must cancel your active subscription before you can continue. You can find out how to cancel your subscription at {supportLink}. Once you've cancelled your current subscription plan you will need to wait until your current subscription plan ends.",
    "If you have any questions, please {helplink} contact us.": "If you have any questions, please {helplink} contact us.",
    "Please create a free account, or sign in": "Please create a free account, or sign in",
    "To accept the Family Plan invitation, you must be logged in.": "To accept the Family Plan invitation, you must be logged in.",
    "Welcome to Your Favorites Radio, a personalized station containing your favorite songs and artists. The more you thumb up and save stations on iHeart, the better your listening experience will be.": "Welcome to Your Favorites Radio, a personalized station containing your favorite songs and artists. The more you thumb up and save stations on iHeart, the better your listening experience will be.",
    "Listen to {title}. Thumb up songs to add them to your own Your Favorites Radio station. Find it under My Stations.": "Listen to {title}. Thumb up songs to add them to your own Your Favorites Radio station. Find it under My Stations.",
    "Featured Artists On This Station": "Featured Artists On This Station",
    "{name}'s Favorites Radio": "{name}'s Favourites Radio",
    "iHeartRadio Mobile Apps": "iHeartRadio Mobile Apps",
    "Made for You": "Made for You",
    "Listen to Stations For You": "Listen to Stations For You",
    "Change genre preferences {prefLink}": "Change genre preferences {prefLink}",
    "here": "here",
    "iHeart: Listen to Free Radio Stations & Music Online": "iHeart: Listen to Free Radio Stations & Music Online",
    "All Your Favorite Music. All Your Favorite Stations. All FREE. Listen to thousands of live stations or create your own artist stations. Let the music play!": "All Your Favourite Music. All Your Favourite Stations. All FREE. Listen to thousands of live stations or create your own artist stations. Let the music play!",
    "Improve Your Recommendations": "Improve Your Recommendations",
    "Change Preferences": "Change Preferences",
    "Change Genre Preferences": "Change Genre Preferences",
    "Find Stations by Genre": "Find Stations by Genre",
    "Finding your ideal station is quick and easy. Search for stations by genre & stream them online for free on iHeart.": "Finding your ideal station is quick and easy. Search for stations by genre & stream them online for free on iHeart.",
    "Discover Music and Radio Stations by Genre on iHeart": "Discover Music and Radio Stations by Genre on iHeart",
    "Pick Genre": "Pick Genre",
    "Tell us all the genres you like.": "Tell us all the genres you like.",
    "We'll suggest stations just For You.": "We'll suggest stations just For You.",
    "Get Stations": "Get Stations",
    "Find and stream {genreName} music stations for free, only on iHeart.": "Find and stream {genreName} music stations for free, only on iHeart.",
    "Listen to {genreName} Radio Stations for Free": "Listen to {genreName} Radio Stations for Free",
    "Find {genreName} Stations": "Find {genreName} Stations",
    "Featured {genreName} Stations": "Featured {genreName} Stations",
    "Top {genreName} Stations": "Top {genreName} Stations",
    "Top {genreName} Artists": "Top {genreName} Artists",
    "More Genres": "More Genres",
    "Latest News": "Latest News",
    "Partner Content": "Partner Content",
    "All Cities": "All Cities",
    "for {currentGenre}": "for {currentGenre}",
    "in {currentMarket}": "in {currentMarket}",
    "near you": "near you",
    "Find top stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})": "Find top stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})",
    "Listen to Live Radio": "Listen to Live Radio",
    "No stations currently available for this filter": "No stations currently available for this filter",
    "Listen to the Best Live Radio Stations in {countryAbbreviation}": "Listen to the Best Live Radio Stations in {countryAbbreviation}",
    "Listen to {genreName} Radio Stations in {city}": "Listen to {genreName} Radio Stations in {city}",
    "Listen to Top Radio Stations in {city}, Free": "Listen to Top Radio Stations in {city}, Free",
    "Live {genreName} Radio Stations in {countryAbbreviation}": "Live {genreName} Radio Stations in {countryAbbreviation}",
    "Listen to hundreds of the best live radio stations{countryName}, for free! Search for stations near you & around the country.": "Listen to hundreds of the best live radio stations{countryName}, for free! Search for stations near you & around the country.",
    "Listen to the Best Live Radio{country} for Free on iHeart.": "Listen to the Best Live Radio{country} for Free on iHeart.",
    "Stream the best live {genreName} radio stations in {city} online for free, only on iHeart!": "Stream the best live {genreName} radio stations in {city} online for free, only on iHeart!",
    "Listen to Top {genreName} Radio Stations in {city}": "Listen to Top {genreName} Radio Stations in {city}",
    "Listen to the best live radio stations in {city}. Stream online for free, only on iHeart!": "Listen to the best live radio stations in {city}. Stream online for free, only on iHeart!",
    "Listen to Top Radio Stations in {city} for Free": "Listen to Top Radio Stations in {city} for Free",
    "Stream the best live {genreName} radio stations in {countryAbbreviation} for free on iHeart.": "Stream the best live {genreName} radio stations in {countryAbbreviation} for free on iHeart.",
    "Listen to Free, Live {genreName} Radio Stations in {countryAbbreviation} on iHeart": "Listen to Free, Live {genreName} Radio Stations in {countryAbbreviation} on iHeart",
    "Contests and Promotions": "Contests and Promotions",
    "If you like {stationName}...": "If you like {stationName}...",
    "Similar Stations": "Similar Stations",
    "{stationName}, {stateAbbreviation}, {city}, {genre}": "{stationName}, {stateAbbreviation}, {city}, {genre}",
    "Genre": "Genre",
    "Location": "Location",
    "On Air Schedule": "On Air Schedule",
    "Share Song": "Share Song",
    "Get the latest music news - rock, pop, hip-hop, rock, alternative, and country music news from iHeart. Get the latest music and trending news, from your favorite artists and bands.": "Get the latest music news - rock, pop, hip-hop, rock, alternative, and country music news from iHeart. Get the latest music and trending news, from your favourite artists and bands.",
    "Breaking Music News, Celeb and Entertainment News and Gossip": "Breaking Music News, Celeb and Entertainment News and Gossip",
    "Advertise With Us": "Advertise With Us",
    "Discover thousands of top playlists with songs handcrafted by your favorite personalities and music experts on iHeartRadio.": "Discover thousands of top playlists with songs handcrafted by your favourite personalities and music experts on iHeartRadio.",
    "Listen to the Best Online Music Playlists": "Listen to the Best Online Music Playlists",
    "Recommended For You": "Recommended For You",
    "Moods & Activities": "Moods & Activities",
    "Decades": "Decades",
    "Featured Playlists": "Featured Playlists",
    "By": "By",
    "Your songs shuffled with songs we think you\u2019ll like. The more songs you add, the better our picks get.": "Your songs shuffled with songs we think you\u2019ll like. The more songs you add, the better our picks get.",
    "Introducing a new playlist experience": "Introducing a new playlist experience",
    "Song saved to Your Library": "Song saved to Your Library",
    "Go to Artist": "Go to Artist",
    "Go to Album": "Go to Album",
    "Remove from Playlist": "Remove from Playlist",
    "SONG": "SONG",
    "ALBUM TITLE": "ALBUM TITLE",
    "ARTIST": "ARTIST",
    "DURATION": "DURATION",
    "Done": "Done",
    "Discover and stream the best {categoryTitle} playlists, handcrafted by the music experts at iHeart.": "Discover and stream the best {categoryTitle} playlists, handcrafted by the music experts at iHeart.",
    "{categoryTitle}, {categoryTitle} Playlists, Stream {categoryTitle} Music, Play {categoryTitle} Songs, Top {categoryTitle} Playlists, Best { categoryTitle} Playlists": "{categoryTitle}, {categoryTitle} Playlists, Stream {categoryTitle} Music, Play {categoryTitle} Songs, Top {categoryTitle} Playlists, Best { categoryTitle} Playlists",
    "Top {categoryTitle} Playlists; Find Your Perfect Music Mix": "Top {categoryTitle} Playlists; Find Your Perfect Music Mix",
    "Host": "Host",
    "iHeart Podcast Networks": "iHeart Podcast Networks",
    "{name}, Blog, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, Blog, News, Music, Headlines, iHeartRadio, iHeart, Radio",
    "{name} Blog, News & Videos": "{name} Blog, News & Videos",
    "Go behind the scenes, get exclusive stories and learn more about the show!": "Go behind the scenes, get exclusive stories and learn more about the show!",
    "Played": "Played",
    "Listen to the best {categoryName} radio shows, free and on demand, only on iHeart.": "Listen to the best {categoryName} radio shows, free and on demand, only on iHeart.",
    "Listen to the Best Free {categoryName} Podcasts": "Listen to the Best Free {categoryName} Podcasts",
    "On Demand, On-Demand, Show, Shows, Personalities, Programs, Listen, iHeartRadio, iHeart": "On Demand, On-Demand, Show, Shows, Personalities, Programs, Listen, iHeartRadio, iHeart",
    "Discover Top Podcasts": "Discover Top Podcasts",
    "Listen to the latest episodes from top podcasts. Get news, sports & lifestyle info from your favorite personalities for free!": "Listen to the latest episodes from top podcasts. Get news, sports & lifestyle info from your favourite personalities for free!",
    "Listen to the Best Podcasts Online for Free on iHeart": "Listen to the Best Podcasts Online for Free on iHeart",
    "Listen to the Best Podcasts & Shows Online, Free": "Listen to the Best Podcasts & Shows Online, Free",
    "Talk, Show, Host, Personality, On Demand, Topic, Category, Health, News, Politics, Comedy, Station, Internet, Online, iHeartRadio, iHeart": "Talk, Show, Host, Personality, On Demand, Topic, Category, Health, News, Politics, Comedy, Station, Internet, Online, iHeartRadio, iHeart",
    "Stream Top Podcasts": "Stream Top Podcasts",
    "All Topics": "All Topics",
    "{name} Podcasts": "{name} Podcasts",
    "Topics": "Topics",
    "All Episodes": "All Episodes",
    "These episodes aren't here yet...": "These episodes aren't here yet...",
    "Follow this podcast to be notified when they're ready": "Follow this podcast to be notified when they're ready",
    "Share Podcast": "",
    "The Latest News": "The Latest News",
    "Listen to {episodeTitle} | {showTitle} | Podcasts": "Listen to {episodeTitle} | {showTitle} | Podcasts",
    "{episodeTitle},{showTitle},Talk,Radio,Listen,On Demand,iHeartRadio,iHeart": "{episodeTitle},{showTitle},Talk,Radio,Listen,On Demand,iHeartRadio,iHeart",
    "{title}, Talk, Radio, Listen, On Demand, iHeartRadio, iHeart": "{title}, Talk, Radio, Listen, On Demand, iHeartRadio, iHeart",
    "Episodes": "Episodes",
    "Popular Podcasts": "Popular Podcasts",
    "Stream the best podcasts from your favorite stations": "Stream the best podcasts from your favourite stations",
    "Follow Us On": "Follow Us On",
    "Show Links": "Show Links",
    "Settings | See Your Music Profile": "Settings | See Your Music Profile",
    "Log in and see which live radio stations and custom artist stations you love. You can also view your listening history. All free.": "Log in and see which live radio stations and custom artist stations you love. You can also view your listening history. All free.",
    "Connections": "Connections",
    "Unlink": "Unlink",
    "Link": "Link",
    "Genre added.": "Genre added.",
    "Genre removed.": "Genre removed.",
    "You've added {genreName} to your genres.": "You've added {genreName} to your genres.",
    "You've removed {genreName} from your genres.": "You've removed {genreName} from your genres.",
    "Your preferences have been changed.": "Your preferences have been changed.",
    "Not provided": "Not provided",
    "Publish my listening activity to my Facebook music dashboard": "Publish my listening activity to my Facebook music dashboard",
    "Update your password, genre selection, and modify your subscription below.": "Update your password, genre selection, and modify your subscription below.",
    "You're currently signed in with a social account, add an email and password to have full access to your account": "You're currently signed in with a social account, add an email and password to have full access to your account",
    "Add New Email": "Add New Email",
    "Contact Information": "Contact Information",
    "Update your contact information to personalize your experience and easily enter iHeart contests and promotions.": "Update your contact information to personalize your experience and easily enter iHeart contests and promotions.",
    "First and Last Name": "First and Last Name",
    "Add your full name": "Add your full name",
    "My Genres": "My Genres",
    "Tell us all your favorite genres so we can make iHeart perfect for you.": "Tell us all your favorite genres so we can make iHeart perfect for you.",
    "View Recommendations": "View Recommendations",
    "Billing History": "Billing History",
    "Subscribe Again": "Subscribe Again",
    "Update Payment": "Update Payment",
    "Unknown": "Unknown",
    "Unknown Plan Description": "Unknown Plan Description",
    "iHeart Family Plan": "iHeart Family Plan",
    "You are enjoying an unlimited music experience with an iHeart Family Plan.": "You are enjoying an unlimited music experience with an iHeart Family Plan.",
    "iHeart All Access": "iHeart All Access",
    "You are enjoying an unlimited music experience by subscribing to iHeart All Access.": "You are enjoying an unlimited music experience by subscribing to iHeart All Access.",
    "iHeart Plus": "iHeart Plus",
    "You are subscribed to iHeart Plus. Switch to iHeart All Access to enjoy an unlimited music experience on your computer.": "You are subscribed to iHeart Plus. Switch to iHeart All Access to enjoy an unlimited music experience on your computer.",
    "iHeart Free": "iHeart Free",
    "Subscribe to enjoy unlimited music.": "Subscribe to enjoy unlimited music.",
    "Your subscription ends on {subscriptionEndsString}.": "Your subscription ends on {subscriptionEndsString}.",
    "Family Members": "Family Members",
    "Subscription": "Subscription",
    "Your Favorite Songs | Log In & See": "Your Favourite Songs | Log In & See",
    "Log in or sign up and find the songs you love here, only on iHeart.": "Log in or sign up and find the songs you love here, only on iHeart.",
    "iHeart Codes Coupons and Special Offers for Unlimited Music": "iHeart Codes Coupons and Special Offers for Unlimited Music",
    "Find iHeart Radio special offers, codes and coupons for unlimited music on demand and all access to iHeart Plus. These special offers provide access to millions of songs, thousands of radio and artists stations with unlimited skips and offline listening!": "Find iHeart Radio special offers, codes and coupons for unlimited music on demand and all access to iHeart Plus. These special offers provide access to millions of songs, thousands of radio and artists stations with unlimited skips and offline listening!",
    "There was an error validating your request.": "There was an error validating your request.",
    "Please enter a valid email address": "Please enter a valid email address",
    "Please fix the following errors:": "Please fix the following errors:",
    "Start Your Free 30 Day Trial": "Start Your Free 30 Day Trial",
    "Start Your Family Plan": "Start Your Family Plan",
    "Sign up for iHeart All Access Annual Plan": "Sign up for iHeart All Access Annual Plan",
    "View": "View",
    "Offer Terms": "Offer Terms",
    "Email Address": "Email Address",
    "Enter email address": "Enter email address",
    "Card Details": "Card Details",
    "Zip / Postal Code": "Zip / Postal Code",
    "Enter Here": "Enter Here",
    "Yes, please automatically renew my subscription annually (subject to {termsLink})": "Yes, please automatically renew my subscription annually (subject to {termsLink})",
    "terms & conditions": "terms & conditions",
    'Charges will appear on your credit card statement as "IHEART BILLING"': 'Charges will appear on your credit card statement as "IHEART BILLING"',
    'You can cancel at any time by going to "Settings" and following the cancellation instructions. By clicking "Subscribe" below, you agree to the conditions above and the iHeart ': 'You can cancel at any time by going to "Settings" and following the cancellation instructions. By clicking "Subscribe" below, you agree to the conditions above and the iHeart ',
    "Processing": "Processing",
    "Enter your email address below to log in by email or reset your password": "",
    "email": "email",
    "Send": "Send",
    "Don\u2019t use common passwords, like \u201CPassword123!\u201D": "",
    "Your password reset link is invalid or expired. Please try": "",
    "resetting your password": "",
    "again.": "",
    "Create a New Password": "Create a New Password",
    "Your password reset link has expired": "",
    "An unknown error occured. Please try again later": "",
    "Your password has been updated": "Your password has been updated",
    "Confirm New Password": "",
    "Create": "Create",
    "Custom radio stations based off your favorite artists and bands.": "Custom radio stations based off your favourite artists and bands.",
    "View More Artists": "View More Artists",
    "Bring iHeart with you anywhere": "Bring iHeart with you anywhere",
    "The free iHeart app is available on over 200 platforms, including Web, iOS, Android, Alexa, automobiles and more.": "The free iHeart app is available on over 200 platforms, including Web, iOS, Android, Alexa, automobiles and more.",
    "Download on the": "Download on the",
    "Download on": "Download on",
    "View All Apps": "View All Apps",
    "Upcoming Events": "Upcoming Events",
    "Listen to Your Favorite Music, Podcasts, and Radio Stations for Free! \u2013 iHeart": "Listen to Your Favorite Music, Podcasts, and Radio Stations for Free! \u2013 iHeart",
    "iHeart. All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "iHeart. All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.",
    "Get Started Free": "Get Started Free",
    "All your favorite music, radio and podcasts, all free.": "All your favourite music, radio and podcasts, all free.",
    "Your browser does not support video playback": "Your browser does not support video playback",
    "The best live stations from around the country, any time, any place.": "The best live stations from around the country, any time, any place.",
    "View More Live Stations": "View More Live Stations",
    "New on iHeart": "New on iHeart",
    "Latest Music News": "Latest Music News",
    "View More Music News": "View More Music News",
    "Popular and exclusive podcasts in a variety of genres and topics.": "Popular and exclusive podcasts in a variety of genres and topics.",
    "View More Podcasts": "View More Podcasts",
    "{count} song{plural}": "{count} song{plural}",
    "Browse Artists": "Browse Artists",
    "Need to find a great new album?": "Need to find a great new album?",
    "Any albums you save will show up here": "Any albums you save will show up here",
    "Need to find an artist you love?": "Need to find an artist you love?",
    "Any artists you follow will show up here": "Any artists you follow will show up here",
    "Access your music library and create unlimited playlists with iHeart All Access": "Access your music library and create unlimited playlists with iHeart All Access",
    "song{pluralSongs}": "song{pluralSongs}",
    "by": "by",
    "Browse Playlists": "Browse Playlists",
    "Need a playlist to fit your mood?": "Need a playlist to fit your mood?",
    "Any playlists you follow will show up here": "Any playlists you follow will show up here",
    "Browse Podcasts": "Browse Podcasts",
    "Need a great new podcast to start?": "Need a great new podcast to start?",
    "Any podcasts you follow will show up here": "Any podcasts you follow will show up here",
    "Any radio, music, or podcasts you listen to will show up here": "Any radio, music, or podcasts you listen to will show up here",
    "Browse Stations For You": "Browse Stations For You",
    "Any podcasts you listen to will show up here": "Any podcasts you listen to will show up here",
    "Need help finding something new?": "Need help finding something new?",
    "Remove station": "Remove station",
    "{name} removed from Your Library": "{name} removed from Your Library",
    "Followed Stations": "Followed Stations",
    "Browse Live Radio": "Browse Live Radio",
    "Browse Artist Radio": "Browse Artist Radio",
    "Need help finding stations to save?": "Need help finding stations to save?",
    "Your followed live and artist radio stations will show up here": "Your followed live and artist radio stations will show up here",
    "{albumName} removed from Your Library": "{albumName} removed from Your Library",
    "Remove": "Remove",
    "{artistName} removed from Your Library": "{artistName} removed from Your Library",
    "ARTIST IN YOUR LIBRARY": "ARTIST IN YOUR LIBRARY",
    "Add to playlist": "Add to playlist",
    "Play Now": "Play Now",
    "{songTitle} removed from Your Library": "{songTitle} removed from Your Library",
    "Need to find a new song?": "Need to find a new song?",
    "Any song you save will show up here": "Any song you save will show up here",
    "Playlist Radio": "Playlist Radio",
    "View All": "View All",
    "Copied": "Copied",
    "Read more on iHeartRadio": "Read more on iHeartRadio",
    "Link Copied!": "Link Copied!",
    "Copy Link": "Copy Link",
    "Code Copied!": "Code Copied!",
    "Embed": "Embed",
    "Follow on iHeartRadio": "Follow on iHeartRadio",
    "Playback not supported by device or browser.": "Playback not supported by device or browser.",
    "Method {method} not supported.": "Method {method} not supported.",
    "View iHeart.com": "View iHeart.com",
    "Oops, that wasn't supposed to happen.": "Oops, that wasn't supposed to happen.",
    "Oops, this feature isn't supported yet.": "Oops, this feature isn't supported yet.",
    "Oops! We had problems playing this stream.": "Oops! We had problems playing this stream.",
    "This station is not currently available in your country.": "This station is not currently available in your country.",
    "Retry": "Retry",
    "Report this issue": "Report this issue",
    "View Troubleshooting": "View Troubleshooting",
    "hello": "hello",
    "my friend": "my friend",
    "Share this live station": "Share this live station",
    "Create your own on iHeart": "Create your own on iHeart",
    "We're sorry! This playlist is not available in your country.": "We're sorry! This playlist is not available in your country.",
    "Playlist Not Available": "Playlist Not Available",
    "This playlist is unsupported in your current country.": "This playlist is unsupported in your current country.",
    "Playback Unsupported In Current Country": "Playback Unsupported In Current Country",
    "Featured artists in this playlist": "Featured artists in this playlist",
    "View Playlist": "View Playlist",
    "Share this episode": "Share this episode",
    "Listen to more episodes": "Listen to more episodes",
    "Share this podcast": "Share this podcast"
  },
  "es": {
    "Facebook": "Facebook",
    "Google": "Google",
    "Region Not Supported": "Regi\xF3n no soportada",
    "Do not sell or share my personal information": "No vender mi informaci\xF3n personal",
    "Log In": "Iniciar sesi\xF3n",
    "Sorry, an error occurred. Please try again later.": "Lo sentimos, ocurri\xF3 un error. Por favor, int\xE9ntalo de nuevo m\xE1s tarde.",
    "Don't have an account?": "\xBFNo tienes una cuenta?",
    "Sign up": "Reg\xEDstrate",
    "Forgot Password?": "\xBFOlvidaste tu contrase\xF1a?",
    "Email": "Correo electr\xF3nico",
    "Password": "Contrase\xF1a",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "Lamentamos el inconveniente, pero no aceptamos registro de usuario en tu ubicaci\xF3n actual.",
    "Visit our Help Center": "Visita nuestro centro de ayuda",
    "Return to Log In": "Regresar a inicio de sesi\xF3n",
    "Male": "Masculino",
    "Female": "Femenino ",
    "Prefer not to say": "Prefiero no decir",
    "Other": "Otro",
    "8 to 32 characters": "8 a 32 caracteres",
    "an upper case and lower case letter": "una may\xFAscula y una min\xFAscula",
    "a number (0-9)": "un n\xFAmero (0-9)",
    "Error": "Error",
    "Success": "Correcto",
    "Password must have eight to thiry two characters": "La contrase\xF1a debe tener de 8 a 32 caracteres",
    "Password doesn't have eight to thirty two characters": "La contrase\xF1a no tiene de 8 a 32 caracteres",
    "Password has eight to thirty two characters": "La contrase\xF1a tiene de 8 a 32 caracteres",
    "Password must have an uppercase and lower case letter": "La contrase\xF1a debe tener una may\xFAscula y una min\xFAscula",
    "Password doesn't have an upper case and lower case letter": "La contrase\xF1a no tiene una may\xFAscula ni una min\xFAsula",
    "Password has an upper case and lower case letter": "La contrase\xF1a tiene una may\xFAscula y una min\xFAscula",
    "Password must have a number between zero and nine": "La contrase\xF1a debe tener un n\xFAmero entre cero y nuevo.",
    "Password doesn't have a number between zero and nine": "La contrase\xF1a no tiene un n\xFAmero entre cero y nueve. ",
    "password has a number between zero and nine": "La contrase\xF1a tiene un n\xFAmero entre cero y nueve",
    "Please fill out all form fields": "Por favor llena todos los campos del formulario",
    "Password shouldn't have common words or passwords": "La contrase\xF1a no debe tener palabras comunes.",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "La contrase\xF1a solo puede tener letras, n\xFAmeros, espacios y los siguientes caracteres especiales: . ! ? - _ , ; : / ( ) [ ] ~ @ # $ % ^ & * + = \\",
    "Invalid Email Address": "Correo electr\xF3nico no v\xE1lido",
    "Birth Year": "A\xF1o de nac",
    "Terms of Service": "T\xE9rminos de servicio",
    "Privacy Policy": "Pol\xEDtica de Privacidad",
    "Sign Up": "Reg\xEDstrate",
    "Postal Code": "C\xF3digo Postal",
    "Invalid Postal Code": "C\xF3digo postal no v\xE1lido",
    "Invalid ZIP Code": "C\xF3digo postal no v\xE1lido",
    "Have an account?": "\xBFTienes una cuenta?",
    "Login unsuccessful. Please try again later.": "No se pudo iniciar sesi\xF3n. Por favor intenta nuevamente m\xE1s tarde.",
    "Update successful.": "Actualizaci\xF3n exitosa.",
    "Your account has been linked to {provider}.": "Tu cuenta se ha asociado a {provider}.",
    "This {accountType} account is already linked to an iHeartRadio account": "Este cuenta {accountType} ya est\xE1 vinculada a una cuenta de iHeartRadio ",
    "{accountType} account linking failed. Please try again later.": "Error al vincular la cuenta {accountType}. Por favor Int\xE9ntalo m\xE1s tarde.",
    "Your account has been unlinked from {provider}.": "Tu cuenta ya no est\xE1 asociada a {provider}.",
    "{accountType} account unlinking failed. Please try again later.": "{accountType} la desvinculaci\xF3n de cuentas fall\xF3. Por favor Int\xE9ntalo m\xE1s tarde.",
    "Login unsuccessful. Window closed before completion. Please try again.": "No se pudo iniciar sesi\xF3n. Windows se cerr\xF3 antes de terminar. Por favor intenta nuevamente.",
    "Do You Have a Popup Blocker?": "\xBFTienes un bloqueador de ventanas emergentes (popup)?",
    "To log in with your Facebook or Google account, ensure you've allowed popups from www.iheart.com, refresh, and then try again.": "Para iniciar sesi\xF3n con tu cuenta de Facebook o Google, aseg\xFArate de que has permitido ventanas emergentes (popups) de www.iheart.com. Depu\xE9s actualiza y vuelve a intentar.",
    "Feat. {artistNames} and more": "Feat. {artistNames} y m\xE1s",
    "iHeart": "iHeart",
    "For You": "Para Ti",
    "Add to Playlist": "A\xF1adir a Playlist",
    "Episode Info": "Informaci\xF3n del episodio",
    "Lyrics": "Letras",
    "Rename your Favorites Radio station now.": "Cambia el nombre de tu Radio de Favoritos ahora.",
    "This song is not available to start your station.": "Esta canci\xF3n no est\xE1 disponible para iniciar tu estaci\xF3n.",
    "Play this on web with All Access": "Toca esto en web con All Access",
    "Subscribe today for unlimited access to playlists": "Suscr\xEDbete hoy para tener acceso ilimitado a playlists",
    "Play the whole album with iHeart All Access.": "Escucha todo el \xE1lbum con iHeart All Access",
    "Listen History": "Historial de escucha",
    "Custom Stations Limit Exceeded": "Has excedido el l\xEDmite de estaciones personalizadas.",
    "Please delete some stations from your account under {listenHistoryLink} before creating new stations.": "Por favor borra algunas estaciones de tu cuenta {listenHistoryLink} antes de crear nuevas estaciones.",
    "Sorry, this station has run out of songs to play.": "Lo sentimos, esta estaci\xF3n no tiene m\xE1s canciones para tocar.",
    "Oops": "Uy",
    "We don't have enough info to create a custom station right now. We'll let our DJs know.": "No tenemos suficiente informaci\xF3n para crear una estaci\xF3n personalizada en este momento. Avisaremos a nuestros programadores.",
    "Replay failed": "Repetici\xF3n fallida",
    "An unknown error occurred. Please try again later.": "Se produjo un error desconocido. Por favor int\xE9ntalo m\xE1s tarde.",
    "Update Account": "Actualizar cuenta",
    "Please enter a valid email": "Por favor introduce un correo electr\xF3nico v\xE1lido",
    "New Email": "Nuevo correo electr\xF3nico",
    "Please enter the same email again": "Por favor ingresa el mismo correo electr\xF3nico otra vez",
    "Confirm New Email": "Confirma el nuevo correo electr\xF3nico",
    "Password must be 6 - 32 characters": "La contrase\xF1a debe tener de 6 a  32 caracteres",
    "New Password (6-32 Characters)": "Nueva contrase\xF1a (6-32 caracteres)",
    "Confirm": "Confirmar",
    "Cancel": "Cancelar",
    "Cannot add duplicate tracks to a playlist": "No se puede a\xF1adir canciones duplicadas a una playlist.",
    "Added {contentType} to {playlistName}": "Se agreg\xF3 {contentType} a {playlistName}",
    "Added song to {playlistName}": "Canci\xF3n agregada a {playlistName}",
    "Ok": "OK",
    "Success!": "\xA1\xC9xito!",
    "Your email and password have been added to your account.": "Tu correo y password han sido agregados a tu cuenta.",
    "Your email has been saved.": "Tu correo se ha guardado",
    "Your contact information has been saved.": "Tu informaci\xF3n de contacto se ha guardado",
    "Try Again": "Volver a intentar",
    "For assistance, please visit our {helplink}.": "Para asistencia, por favor visita nuestro {helplink}",
    "Help Link": "Enlace de ayuda",
    "Oops!": "\xA1Uy!",
    "Get Started": "Empezar",
    "You can now enjoy the full benefits of iHeart All Access for Family.": "Puedes disfrutar de todos los beneficios de iHeart All Access Familiar",
    "Welcome to the Family!": "Bienvenido a la Familia!",
    "Your password has been saved.": "Tu contrase\xF1a se ha guardado",
    "Station Not Available": "Estaci\xF3n no disponible",
    "We're sorry! This station is not available in your country.": "\xA1Lo sentimos! Esta estaci\xF3n no est\xE1 disponible en tu pa\xEDs.",
    "Updated {updateDateAndTime}": "Actualizado {updateDateAndTime}",
    "Please complete the CAPTCHA": "Por favor completa el CAPTCHA",
    "Check Your Email": "Revisa tu correo electr\xF3nico",
    "Forgot Password": "Contrase\xF1a olvidada",
    "Enter your email address below to log in by email or reset your password.": "Escribe tu direcci\xF3n de correo electr\xF3nico para iniciar sesi\xF3n de esta forma o restablecer su contrase\xF1a.",
    "Enter your email address below to reset your password.": "Escribe tu direcci\xF3n de correo electr\xF3nico para restablecer tu contrase\xF1a.",
    "If an account exists, you'll receive a password reset link shortly. Check your spam folder if it takes more than a minute or two.": "Si una cuenta existe, recibir\xE1s una liga para restablecer la contrase\xF1a. Revisa tu carpeta de correo no deseado si tarda m\xE1s de dos minutos en llegar.",
    "Okay": "Ok",
    "Back to login": "Volver a inicio de sesi\xF3n",
    "Submit": "Enviar",
    "Or, {backToLoginLink}": "O, {backToLoginLink}",
    "Gender": "G\xE9nero",
    "Music and radio on demand": "M\xFAsica y radio en demanda",
    "Please log in first.": "Por favor inicia sesi\xF3n primero.",
    "Login": "Iniciar sesi\xF3n",
    "To listen to thousands of live radio and artist stations, create a free account.": "Para escuchar miles de estaciones en vivo y estaciones de artistas crea una cuenta gratuita",
    "To listen to thousands of live radio stations, create a free account.": "Para escuchar miles de estaciones en vivo, crea una cuenta gratuita.",
    "Connect with your favorites": "Con\xE9ctate con tu m\xFAsica favorita",
    "To easily find your favorite and recently listened to stations, create a free account.": "Para encontrar f\xE1cilmente tus favoritos y lo que has escuchado recientemente, crea una cuenta gratuita.",
    "Access your stations": "Accede a tus estaciones",
    "To view recently listened to stations and songs, create a free account.": "Para ver las estaciones recientemente escuchadas, crea una cuenta gratuita.",
    "See what you've been listening to": "Mira lo que has estado escuchando.",
    "To access your favorites anytime, anywhere, create a free account.": "Para acceder a tus favoritos en cualquier momento, en cualquier lugar, crear una cuenta gratuita.",
    "Save stations you love": "Guardar estaciones que te encantan. ",
    "To hear more music you like, create a free account.": "Para escuchar m\xE1s m\xFAsica que te gusta, crea una cuenta gratuita.",
    "Personalize your listening": "Personaliza lo que escuchas",
    "To listen to this artist and more, without interruption, create your free account.": "Para escuchar a este artista y m\xE1s, sin interrupci\xF3n, crea tu cuenta gratuita.",
    "Listen to {stationName}": "Escuchar {stationName}",
    "Listen to Artist Stations": "Escuchar Estaciones de Artistas",
    "To listen to music based on this song, create your free account.": "Para escuchar m\xFAsica basada en esta canci\xF3n, crea tu cuenta gratuita.",
    "Listen to songs like {stationName}": "Escuchar canciones como {stationName}",
    "Listen to songs like this": "Escuchar canciones como esta",
    "To listen to this podcast and more, create your free account.": "Para escuchar este podcast y m\xE1s, crea tu cuenta gratuita.",
    "Listen to Podcasts": "Escuchar Podcasts",
    "To hear all your favorite songs and artists on your own personal station, create a free account.": "Para escuchar todas tus canciones y artistas favoritos en tu propia estaci\xF3n personal, crea una cuenta gratuita.",
    "Listen to {stationName}!": "Escuchar {stationName}",
    "Listen to Your Favorites Radio!": "\xA1Escucha tus estaciones favoritas!",
    "To listen, create a free account.": "Para escuchar, crear una cuenta gratuita.",
    "Listen to Favorites Radio!": "\xA1Escuchar mis estaciones favoritas!",
    "All your favorite music. All your favorite stations. All free.": "Toda tu m\xFAsica favorita. Todas sus estaciones favoritas. Todo gratis.",
    "Create Your iHeart Account": "Crea tu cuenta de iHeart",
    "Please create a free account.": "Por favor crea una cuenta gratuita.",
    "Register first": "Reg\xEDstrate primero",
    "Create a FREE account to add songs and albums to your playlist": "Crea una cuenta GRATUITA para a\xF1adir canciones y \xE1lbumes a tu playlist",
    "Welcome to the All Access FREE Preview Weekend. Create your FREE account and listen to millions of songs, live radio, playlists, and podcasts \u2013 enjoy All Access, FREE this weekend only.": "Bienvenido a All Access FREE Preview Weedend.  \xA1Crea una cuenta gratuita y escucha millones de canciones, estaciones en vivo, playlists, y podcasts \u2013 Disfruta gratis de All Access solo este fin de semana.",
    "Your Halloween treat is here": "Tu promoci\xF3n de Halloween est\xE1 aqu\xED",
    "To join the Family Plan you've been invited to, please create a free account": "Para unirte al Plan Familiar que te han invitado, por favor crea una cuenta.",
    "Create a free account to join your Family Plan": "Crea una cuenta gratuita para unirte al Plan Familiar",
    "Please correct all password errors": "Por favor corrige los errores en la contrase\xF1a",
    "Sorry, you are not eligible to register for iHeart": "Lo sentimos, no eres elegible para registrarte en iHeart.",
    "Zip Code": "C\xF3digo Postal",
    "Please enter a valid birth year": "Por favor introduzca un a\xF1o de nacimiento v\xE1lido",
    "Receive email updates on stations I listen to and more from iHeart.": "Recibe correos de iHeart con noticias de las estaciones que escuchas.",
    "By creating an account, you also agree to our {termsOfServiceLink} and {privacyPolicyLink}.": "Al crear una cuenta tambi\xE9n est\xE1 de acuerdo con nuestros {termsOfServiceLink} y {privacyPolicyLink}.",
    "Or Connect With": "O conectar con",
    "Login with Facebook": "Con\xE9ctate con Facebook",
    "Login with Google": "Con\xE9ctate con Google",
    "Added By iHeart": "Agregado por iHeart",
    "Suggestions based on the songs you added.": "Sugrencias con base en las canciones agregadas.",
    "You have All Access": "Tienes All Access",
    "Upgrade to All Access": "Mejora a All Access",
    "Want to keep enjoying these perks after the weekend?": "\xBFQuieres mantener estos beneficios despu\xE9s del fin de semana?",
    "Listen offline, unlimited skips, save and play songs from the radio.": "Escucha sin conexi\xF3n, saltos ilimitados, guarda y reproduce canciones de la radio",
    "Learn More": "Aprender m\xE1s",
    "Start 30 Day Free Trial": "Inicia la prueba gratis de30 d\xEDas.",
    "You will lose unlimited skips, replay, and access to your playlist": "Perder\xE1s los saltos ilimitados, replay y acceso a tu playlist.",
    "You will lose offline listening, unlimited playlists, and replay": "Perder\xE1s la escucha sin conexi\xF3n, playlists ilimitados y replay.",
    "Are you sure you want to cancel?": "\xBFSeguro que quieres cancelar?",
    "Your subscription ends on {date}": "Tu suscripci\xF3n termina en {date}",
    "Your playlists will be waiting for you should you decide to subscribe again.": "Tus playlists te estar\xE1n esperando si decides suscribirte otra vez",
    "Keep Current Plan": "Mantener el plan actual.",
    "Got It": "Lo tengo!",
    "Cancel Plan": "Cancelar plan",
    "Trending - Just Now": "Tendencias - Ahora mismo",
    "Help Center": "Centro de ayuda",
    "There was an error updating your email": "Ocurri\xF3 un error actualizando tu correo",
    "Update Contact Information": "Actualizar informaci\xF3n de contacto",
    "Please enter your first name": "Por favor ingresa tu nombre",
    "Add your first name": "Agrega tu nombre",
    "First Name": "Nombre",
    "Please enter your last name": "Por favor ingresa tu apellido",
    "Add your last name": "Agrega tu apellido",
    "Last Name": "Apellido",
    "Please enter a valid phone number": "Por favor ingresa un c\xF3digo postal v\xE1lido",
    "Phone Number": "N\xFAmero de tel\xE9fono",
    "Visit Our {helpCenterLink}": "Visita nuestro {helpCenterLink}",
    "This email address is already associated with an iHeart account": "Este correo electr\xF3nico ya est\xE1 asociado a una cuenta de iHeart",
    "Emails must match": "Los correos electr\xF3nicos deben coincidir",
    "Change Email": "Cambiar correo electr\xF3nico",
    "Please enter the same value again": "Por favor introduce el mismo valor nuevamente",
    "Please enter your password": "Por favor ingresa tu contrase\xF1a",
    "Or, Visit Our {helpCenterLink}": "O visita nuestro {helpCenterLink}",
    "Password doesn't match our records": "La contrase\xF1a no coincide con nuestros registros",
    "Uh-oh passwords don't match": "Las contrase\xF1as no coinciden",
    "Your new password cannot be the same as your current password": "Tu nueva contrase\xF1a no puede ser la misma que la actual",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign": "La contrase\xF1a solo puede tener letras, n\xFAmeros, espacios y los siguientes caracteres especiales: punto, signo de exclamaci\xF3n, signo de interrogaci\xF3n, guion, guion bajo, coma, punto y coma, dos puntos, barra oblicua, barra invertida, apertura de par\xE9ntesis, cierre de par\xE9ntesis, tilde, arroba, signo de n\xFAmero, signo de moneda, signo de porcentaje, intercalaci\xF3n, ampersand, asterisco, signo de m\xE1s, signo de igual, ap\xF3strofe, comillas, acento grave, barra vertical, apertura de corchete, cierre de corchete, signo menor que y signo mayor que.",
    "Update Password": "Actualizar contrase\xF1a",
    "Old Password": "Contrase\xF1a anterior",
    "New Password": "Nueva contrase\xF1a",
    "Confirm Password": "Confirmar contrase\xF1a ",
    "Update": "Actualizar",
    "Are you sure you want to continue?": "\xBFEst\xE1s seguro que deseas continuar?",
    "Signed Out": "Sesi\xF3n concluida",
    "You have been signed out. Please log back in.": "Has cerrado sesi\xF3n. Por favor vuelve a iniciar sesi\xF3n.",
    "\xA9 {fourDigitYear} iHeartMedia, Inc.": "\xA9 {fourDigitYear} iHeartMedia, Inc.",
    "Help": "Ayuda",
    "Terms of Use": "T\xE9rminos de Uso",
    'Playlist "{playlistName}" created': 'Playlist "{playlistName}" creada',
    "Create unlimited playlists with iHeart All Access.": "Crea playlists ilimitadas con iHeart All Access",
    "There was an error creating your playlist": "Ocurri\xF3 un error al crear tu playlist",
    "Device Limit": "L\xEDmite de dispositivos",
    "This stream stopped because you're listening on another device.": "Esta reproducci\xF3n se detuvo porque est\xE1s escuchando en otro dispositivo.",
    "Listen on this device": "Escuchar en este dispositivo",
    "Got it": "\xA1Entendido!",
    "Album saved to Your Library": "\xC1lbum salvado a Tu Colecci\xF3n",
    "Save Album": "Guardar \xE1lbum",
    "Saved {name} to Your Library": "{name} se ha salvado en Tu Colecci\xF3n",
    "Removed {name} from Your Library": "Se elimin\xF3 {name} de Tu Colecci\xF3n",
    "Follow Artist": "Seguir Artista",
    "Remove Artist": "Eliminar Artista",
    "Not for Me": "No es para m\xED",
    "Delete": "Borrar",
    "Follow station": "Seguir estaci\xF3n",
    "Unfollow station": "Dejar de seguir estaci\xF3n",
    "Connect": " Conectar",
    "Call ": "Llamada",
    "Text ": "Texto",
    "Edit Playlist": "Editar Playlist",
    "Delete Playlist": "Borrar Playlist",
    "Unfollow Playlist": "Dejar de seguir Playlist",
    "Follow Playlist": "Seguir Playlist",
    "Followed {title}": "Has seguido {title}",
    "Unfollowed {title}": "Has dejado de seguir {title}",
    "Follow Podcast": "Seguir Podcast",
    "Unfollow Podcast": "Dejar de seguir Podcast",
    "No added songs yet": "No has agregado canciones todav\xEDa",
    "Tap ": "Haz clic",
    "Save": "Guardar",
    " on the player to add a song to My Playlist": "en el reproductor para a\xF1adir la canci\xF3n a Mi Playlist",
    "Click on the": "Haz click en",
    "button next to a song": "el bot\xF3n al lado de una canci\xF3n",
    "and select Add to Playlist.": "y selecciona A\xF1adir a Playlist",
    "Find Music": "Encuentra m\xFAsica",
    "Uh oh, we can\u2019t find the page you\u2019re looking for.": "Uy, no podemos encontrar la p\xE1gina que buscas.",
    "How about this page instead: ": "Qu\xE9 tal esta p\xE1gina en su lugar: ",
    "Read more": " Leer m\xE1s ",
    "Explicit": "Expl\xEDcito",
    "E": "E",
    "Invite sent to {email}": "Invitaci\xF3n enviada a {email}",
    "Add family member...": "Agregar miembro de la familia...",
    "email@example.com": "email@example.com",
    "Send Invite": "Enviar invitaci\xF3n",
    "You": "T\xFA ",
    "Active": "Activo",
    "{email} has been removed.": "{email} ha sido eliminado.",
    "Remove Member": "Quitar miembro",
    "Cancel Invite": "Cancelar invitaci\xF3n",
    "Resend Invite": "Reenviar invitaci\xF3n",
    "Invite was sent on ": "La invitaci\xF3n fue enviada en",
    "Active \u2713": "Activo \u2713",
    "Pending...": "Pendiente...",
    "Invitees must be 14 years or older": "Los invitados deben tener 14 a\xF1os o m\xE1s",
    "Owner": "Due\xF1o",
    "Following": "Siguiendo",
    "Follow": "Seguir",
    "Music, radio and podcasts, all free. Listen online or download the iHeart App.": "M\xFAsica, radio y podcasts, todo gratis. Escucha en l\xEDnea o descarga la aplicaci\xF3n iHeart.",
    "Connect with Facebook": "Con\xE9ctate con Facebook",
    "Connect with Twitter": "Con\xE9ctate con Twitter",
    "iHeart Instagram": "iHeart Instagram",
    "iHeart Youtube": "iHeart Youtube",
    "Explore": "Explorar",
    "Live Radio": "Estaciones en Vivo",
    "Podcasts": "Podcasts",
    "On Demand Podcasts": "Podcasts en demanda",
    "Artist Radio": "Estaci\xF3n de Artista",
    "Playlists": "Playlists",
    "Genres": "G\xE9nero",
    "Browse by Genre": "Buscar por g\xE9nero",
    "Exclusives": "Exclusivo ",
    "News": "Noticias",
    "iHeart News": "Noticias de iHeart",
    "Features": "Presenta",
    "Featured Exclusives on iHeart": "Exclusivas presentadas en iHeart",
    "Events": "Eventos",
    "iHeart Events": "Eventos de iHeart",
    "Contests": "Concursos",
    "iHeart Contests": "Concursos de iHeart",
    "Photos": "Fotos",
    "iHeart Photos": "Fotos de iHeart",
    "Information": "Informaci\xF3n",
    "About": "Acerca de ",
    "About iHeart": "Acerca de iHeart",
    "Advertise": "Anunciarse",
    "Advertise on iHeart": "An\xFAnciate en iHeart",
    "Blog": "Blog",
    "iHeart Blog": "Blog de iHeart",
    "Brand Guidelines": "Lineamientos de la marca",
    "iHeart Logo and Guidelines": "Logotipo de iHeart y Lineamientos",
    "Contest Guidelines": "Reglas del concurso",
    "iHeart Contest Rules": "Reglas de concurso de iHeart",
    "Subscription Offers": "Ofertas de suscripci\xF3n",
    "Jobs": "Trabajos",
    "iHeart Jobs": "Trabajos en iHeart",
    "Get the App": "Obtener la aplicaci\xF3n",
    "Automotive": "Automotor",
    "iHeart in your house": "iHeart en tu casa",
    "Home": "P\xE1gina Principal",
    "iHeart in your car": "iHeart en tu autom\xF3vil.",
    "Mobile": "M\xF3vil",
    "iHeart on your phone or tablet": "iHeart en tu tel\xE9fono o tableta",
    "Wearables": "Wearables",
    "iHeart wearables": "Wearables de iHeart",
    "Your Library": "Tu Colecci\xF3n",
    "Saved {name} to {savedStationsLink}": "Se guard\xF3 {name} en {savedStationsLink}",
    "Removed {name} from {savedStationsLink}": "Se elimin\xF3 {name} de {savedStationsLink}",
    "Followed {podcastName}": "Has seguido {podcastName}",
    "Unfollowed {podcastName}": "Has dejado de seguir {podcastName}",
    "We won't play this song again on this station.": "No volveremos a tocar esta canci\xF3n en esta estaci\xF3n.",
    "Thanks for your feedback.": "Gracias por tus comentarios.",
    "favorite songs": "canciones favoritas",
    "We'll play more like it. Check out your {favoriteSongsLink} to see everything you've liked.": "Tocaremos m\xE1s como esto. Echa un vistazo a tu {favoriteSongsLink} para ver todo lo que te ha gustado.",
    "We'll let our DJs know you've heard enough of this song.": "Le avisaremos a nuestros programadores que ya has escuchado mucho esta canci\xF3n.",
    "Check out your {favoriteSongsLink} to see everything you've liked.": "Echa un vistazo a tu {favoriteSongsLink} para ver todo lo que te ha gustado.",
    "Glad you like it. We'll let our DJs know.": "Nos alegra que te guste. Le informaremos a nuestros programadores.",
    "OK, we'll adjust your music mix.": "Bien, ajustaremos tu mezcla de m\xFAsica.",
    "Favorites Radio": "Estaciones Favoritas",
    "Great, we\u2019ll add this song to your own {favoritesRadioLink}!": "Genial, vamos a a\xF1adir esta canci\xF3n a su {favoritesRadioLink}!",
    "Great, we\u2019ll play you more songs like this": "Genial, tocaremos m\xE1s canciones como \xE9sta",
    "We appreciate you letting us know.": "Agradecemos que nos avises.",
    "Nice! You\u2019ll hear this song more often.": "\xA1Excelente! Escuchar\xE1s est\xE1 canci\xF3n m\xE1s seguido.",
    "You've reached your skip limit.": "Has alcanzado tu l\xEDmite de saltos.",
    "We're sorry, you can't skip any more songs right now. You can still thumb down a song. Want to know more? Visit {helpLink}": "Lo sentimos, no puedes saltarte m\xE1s canciones ahora. Puedes seguir indicando que te gustan las canciones. \xBFQuieres saber m\xE1s? Visita {helpLink}",
    "Report this issue.": "Reporta este problema",
    "There's an error with episodes for this show. {reportLink}": "Hay un error con los episodios en este podcast {reportLink}",
    "There's an error with this content. {reportLink}": "Hay un error con este contenido {reportLink}",
    "Playlist followed and saved to {link}": "Playlists seguidas y guardadas en {link}",
    "Playlist unfollowed and removed from {link}": "Playlists no seguidas y eliminadas de {link}",
    "Click here": "hacer clic aqu\xED ",
    "Having trouble logging into iHeart with your Facebook or Google account? {clickHereLink} for help.": "\xBFTienes problemas para iniciar sesi\xF3n en iHeart con tu cuenta de Facebook o Google? {clickHereLink} para obtener ayuda.",
    "More": "M\xE1s",
    "Subscribe": "Suscr\xEDbete",
    "Upgrade": "Mejorar",
    "Upgrade Now": "Mejora ahora",
    "Settings": "Configuraci\xF3n.",
    "Log Out": "Cerrar sesi\xF3n",
    "Account": "Cuenta",
    "Sponsor Content": "Contenido del patrocinador",
    "Mark As Unplayed": "Marcar como no reproducido",
    "Mark as Played": "Marcar como reproducido",
    "This station is not currently available": "Esta estaci\xF3n no est\xE1 disponible actualmente",
    "Please pick a different station or listen to this station using our free iHeart app": "Por favor escoge una estaci\xF3n diferente o escucha esta estaci\xF3n usando nuestra aplicaci\xF3n gratuita iHeart",
    "Listen in App": "Escuchar en la aplicaci\xF3n",
    "You haven't thumbed up any songs yet.": " A\xFAn no has indicado que te gusta alguna canci\xF3n.",
    "Favorite Songs": "Canciones Favoritas",
    "NEW": "NUEVO",
    "Welcome to": "Bienvenido a",
    "Your Favorites Radio!": "\xA1Tus estaciones favoritas!",
    "All your favorites and thumbs up in one station. The more you interact with iHeart, the better it gets.": "Todas las canciones que te gustaron y tus favoritos en una estaci\xF3n. Cuanto m\xE1s interact\xFAes con iHeart, mejor lo har\xE1.",
    "Please name your station now:": "Por favor, da un nombre a tu estaci\xF3n:",
    "Refresh": "Refrescar",
    "On Air": "Al Aire",
    "Share": "Compartir",
    "Go To Album": "Ir a \xC1lbum",
    "Go To Artist": "Ir a Artista",
    "Go To Station": "Ir a la estaci\xF3n",
    "Unfollow Station": "Dejar de seguir Estac\xED\xF3n",
    "Follow Station": "Seguir Estaci\xF3n",
    "Go To Your Library": "Ir a Tu Colecci\xF3n",
    "Go To Playlist": "Ir a Playlist",
    "Share Episode": "Compartir episodio",
    "Share from": "Compartir desde",
    "Pause": "Pausa",
    "Stop": "Parar",
    "Play": "Tocar",
    "Play Newest": "M\xE1s reciente",
    "Create unlimited playlists. Try iHeart All Access.": "Crea playlists ilimitadas. Prueba iHeart All Access",
    "My Music": "Mi M\xFAsica",
    "Theme Radio": "Tema de Radio",
    "Playlist": "Playlist",
    "Playlist by": "Playlist por",
    "Podcast": "Podcast",
    "Thanks for listening!": "\xA1Gracias por escuchar!",
    "Rename": "Renombrar",
    "Edit": "Editar",
    "Add to Another Playlist": "Agregar a otro Playlist",
    "Shuffle": "Aleatorio",
    "Added By You": "Agregada por Ti",
    "Recently Played": "Tocado Recientemente",
    "You like {station} on Facebook": "Te gusta {station} en Facebook",
    "You listened to {station}": "Escuchaste {station}",
    "You are near {city}": "Est\xE1s cerca de {city}",
    "You like {genre}": "Te gusta {genre}",
    "Just For You": "S\xF3lo Para Ti.",
    "Popular On {iHeart}": "Popular en {iHeart}",
    "Discover how you can save and replay music on your favorite radio stations, or download and listen offline to millions of songs!": "Descubre c\xF3mo puedes guardar y volver a escuchar m\xFAsica en tus estaciones de radio favoritas, o descargar y escuchar millones de canciones sin conexi\xF3n!",
    "iHeart Plus & All Access - Upgrade to a Free Trial": "IHeart Plus y All Access - Mejora a una prueba gratuita",
    "Playlist deleted": "Playlist ha sido borrado ",
    "Select a song to replay": "Seleccione una canci\xF3n para repetirla",
    "Save Playlist": "Guardar Playlist",
    "All": "Todos",
    "Live Stations": "Estaciones en vivo",
    "Artists": "Artistas",
    "Albums": "\xC1lbumes",
    "Songs": "Canciones",
    "artists, stations or podcasts": "artistas, estaciones o podcasts",
    "stations or podcasts": "estaciones o podcasts",
    "podcasts": "podcasts",
    "search": "buscar",
    "Album{bulletSeparator}{artistName}": "Album{bulletSeparator}{artistName}",
    "Top Result": "Mejor resultado",
    "Search Results": "Resultados de la b\xFAsqueda",
    "Show More Results": "Mostrar m\xE1s resultados",
    "Search iHeart for artists, stations or podcasts.": "Busca artistas, estaciones o podcasts en iHeart.",
    "Search iHeart for stations or podcasts.": "Busca estaciones o podcasts en iHeart.",
    "Search iHeart for podcasts.": "  Busca podcasts en iHeart",
    'There are no results for "{searchQuery}"': 'No hay resultados para "{searchQuery}"',
    "Check your spelling or try another search": "Revisa la ortograf\xEDa o intenta otra b\xFAsqueda",
    "Show all Live Stations": "Mostrar todas las Estaciones en Vivo",
    "Show all Artists": "Mostrar todos los Artistas",
    "Show all Albums": "Mostrar todos los \xC1lbumes",
    "Show all Songs": "Mostrar toda las Canciones",
    "Show all Playlists": "Mostrar todas las Playlists",
    "Show all Podcasts": "Mostrar todos los Podcasts",
    "Show all {title}": "Mostrar todo {title}",
    "Embed Widget": "Incrustar widget",
    "Twitter": "Twitter",
    "See {moreTiles} of {itemCount}": "Ver {moreTiles} de {itemCount}",
    "See All": "Ve todo",
    "See Less": "Ver menos",
    "Get The App": "Obtener la aplicaci\xF3n",
    "Connect with ": "Conectar con",
    "on your favorite social network ": "en tu red social favorita",
    " Song": "Canci\xF3n",
    "Keep Thumbing!": "\xA1Sige indicando que te gusta! ",
    "Thumbing up songs personalizes the stations you listen to and adds them to Your Favorites Radio.": "Indicar que te gustan las canciones, personaliza las estaciones que escuchas y las a\xF1ade a tu Radio de Favoritos",
    "1 song": "1 canci\xF3n",
    "All your favorite songs and artists.": "Todas tus canciones y artistas favoritos.",
    "Show Less": "Mostrar menos",
    "Show More": "Mostrar m\xE1s",
    "Schedule": " Programaci\xF3n ",
    "Listen offline": "Escuchar sin conexi\xF3n",
    "Unlimited skips": "Saltos ilimitados",
    "Save songs from radio to playlists": "Guarda canciones de la radio en playlists",
    "Instantly replay songs from radio": "Vuelve a escuchar canciones de la radio",
    "Create unlimited playlists": "Crea playlists ilimitados",
    "Play millions of songs on demand": "Toca millones de canciones en demanda",
    "Now you can create your own playlists with All Access!": "\xA1Ahora puedes crear tus propias playlists con All Access!",
    "Start Free 30 Day Trial": "Iniciar prueba gratuita de 30 d\xEDas",
    "Subscribe to All Access": "Suscr\xEDbete a All Access",
    "is now better than ever!": "\xA1ahora es mejor que nunca!",
    "All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "Toda tu m\xFAsica favorita, podcasts, y estaciones disponibles de forma gratuita. Escucha tus estaciones favoritas en vivo o crea tus propias estaciones de artistas y playlists. Obt\xE9n las \xFAltimas noticias de m\xFAsica y tendencias de tus artistas y grupos favoritos.",
    "Stream thousands of the best live radio stations and custom artist stations for FREE - all in one app.": "Escucha miles de las mejores estaciones en vivo y estaciones de artistas personalizados de forma GRATUITA-todo en una aplicaci\xF3n.",
    "Stream thousands of the best live radio stations for FREE, plus unlimited music on demand - all in one app.": "Escucha miles de las mejores estaciones en vivo GRATIS, adem\xE1s de m\xFAsica ilimitada a petici\xF3n-todo en una aplicaci\xF3n.",
    "Stream thousands of the best live radio stations for FREE - all in one app.": "Escucha miles de las mejores estaciones en vivo GRATIS-todo en una aplicaci\xF3n.",
    "All Genres": "Todos los g\xE9neros",
    "Featured": "Destacados",
    "Popular": "Popular",
    "You are now logged in as {profileName}": "Ahora est\xE1s conectado como {profileName}",
    "Artist": "Artista",
    "Song by": "Canci\xF3n de",
    "Song": "Canci\xF3n",
    "Live Station": "Estaci\xF3n en vivo",
    "Album by": "\xC1lbum de",
    "Album": "\xC1lbum",
    "Email or password is invalid. Please try again.": "El correo electr\xF3nico o la contrase\xF1a no son v\xE1lidos. Por favor int\xE9ntalo de nuevo.",
    "There was an issue playing the audio, please check your connection and try again.": "Hubo un problema al reproducir el audio, por favor revisa tu conexi\xF3n e intenta nuevamente.",
    "There was a connection problem. Please reconnect and try again.": "Hubo un problema en la conexi\xF3n. Por favor con\xE9ctate e intenta nuevamente. ",
    "See More": "Ver m\xE1s",
    "all access": "All Access",
    "Best Playlists": "Mejores Playlists",
    "concert pictures": "Fotos del concierto",
    "create playlists": "Crear playlists",
    "custom radio station": "Estaci\xF3n de radio personalizada",
    "event pictures": "Fotos del evento",
    "favorite music": "M\xFAsica favorita",
    "Music Playlists": "Playlist de m\xFAsica ",
    "my music": "Mi M\xFAsica",
    "Now Playing": "Tocando Ahora",
    "On Demand": "En Demanda",
    "Online Playlists": "Playlist en l\xEDnea",
    "paid music": "M\xFAsica pagada",
    "paid songs": "Canciones pagadas",
    "personal radio station": "Estaci\xF3n de radio personal",
    "personalized radio station": "Estaci\xF3n de radio personalizada",
    "play songs": "Tocar canciones",
    "Top Playlists": "Top Playlists",
    "recent photos": "Fotos recientes",
    "recent pictures": "Fotos recientes",
    "saved music": "m\xFAsica guardada",
    "saved songs": "canciones guardadas",
    "top playlists": "Los mejores playlists",
    "App": "App",
    "Bands": "La Banda",
    "Best": "Mejor",
    "Discover": "Descubrir",
    "Download": "Descargar",
    "Free": "Gratis",
    "Influencers": "Influencers",
    "Influences": "Influencias",
    "Internet": "Internet",
    "Listen": "Escuchar",
    "Live": "En vivo ",
    "Music": "M\xFAsica",
    "Online": "En l\xEDnea",
    "Personalized": "Personalizado",
    "photos": "Fotos",
    "pictures": "Fotos",
    "Radio": "Radio",
    "Related": "Relacionado",
    "Similar": "Similar",
    "Station": "Estaci\xF3n",
    "Stations": "Estaciones",
    "stream": "Transmitir",
    "Streaming": "Transmitiendo",
    "Talk": "Hablar",
    "Top": "Mejores",
    "January": "Enero",
    "February": "Febrero",
    "March": "Marzo",
    "April": "Abril",
    "May": "Mayo",
    "June": "Junio",
    "July": "Julio",
    "August": "Agosto",
    "September": "Septiembre",
    "October": "Octubre",
    "November": "Noviembre",
    "December": "Diciembre",
    "Jan": "Ene",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Abr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Ago",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dic",
    "Password must have": "La contrase\xF1a debe tener",
    "iHeart: Listen to Free Radio Stations & Music Online | iHeart": "iHeart: escucha estaciones de radio gratuitas y m\xFAsica en l\xEDnea | iHeart",
    "1 Song": "1 Canci\xF3n",
    "Listen to music you love! Create a custom radio station based on your favorite album by {artistName} on iHeartRadio!": "\xA1Escucha la m\xFAsica que amas! \xA1Crea una estaci\xF3n de radio personalizada basada en tu \xE1lbum favorito de {artistName} en iHeartRadio!",
    "Stream Free Music from Albums by {artistName}": "Escucha m\xFAsica gratis basada en \xE1lbumes de {artistName}",
    "Create Artist Radio Stations": "Crea estaciones de Radio de Artistas",
    "Popular {genre} Artists": "Artistas populares de {genre}",
    "Artist Radio gives you the power to create custom stations from your favorite songs, albums or musical artists. Listen for free on iHeart!": "Radio de Artista te da el poder para crear estaciones personalizadas con base en tus canciones favoritas, \xE1lbumes o artistas . Escucha de forma gratuita en iHeart!",
    "Create a personalized custom music station from thousands of {name} artists you love, only on iHeart!": "Crea una estaci\xF3n de m\xFAsica personalizada a partir de miles de {name} artistas que amas, solo en iHeart!",
    "Create Custom Radio Stations on Artist Radio!": "Crea estaciones de radio personalizadas en Radio de Artista!",
    "Listen to the Best {name} Music for Free on iHeart": "Escucha la mejor {name} m\xFAsica gratuitamente en iHeart",
    "{artistName}": "{artistName}",
    "{name}, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, Noticias, M\xFAsica, Titulares, iHeartRadio, iHeart, Radio",
    "Latest {name} news from iHeart": "\xDAltimas {name} noticias de iHeart",
    "Read the latest News on {name} Online": "Lea las \xFAltimas noticias de {name} en l\xEDnea",
    "Biography": "Biograf\xEDa",
    "Similar Artists": "Artistas similares",
    "Latest Release": "\xDAltimo lanzamiento ",
    "Popular On": "Popular en",
    "This artist doesn't have any top songs.": "Este artista no tiene mejores canciones.",
    "Top Songs": "Mejores canciones",
    "Stream Music from Artists Like {artistName}": "Escucha m\xFAsica de artistas como {artistName}",
    "Listen to music you'll love! Create a custom radio station from your favorite songs by {artistName} on iHeart.": "Escucha la m\xFAsica que amar\xE1s! Crea una estaci\xF3n de radio personalizada a partir de tus canciones favoritas por {artistName} en iHeart.",
    "Stream Free Songs by {artistName} & Similar Artists": "Escucha canciones gratis de {artistName} y artistas similares ",
    "Almost there! Verify your zipcode to unlock your spot on the Family Plan": "\xA1Ya casi! Verifica tu c\xF3digo postal para desbloquear tu lugar en el plan familiar",
    "In order to add you to the plan, we need to make sure that you live at the same address as the plan owner. Please input your zipcode below to verify and unlock your account.": "Para agregarte al plan, necesitamos asegurarnos de que vives en la misma direcci\xF3n que el propietario del plan. Por favor, ingresa tu c\xF3digo postal para verificar y desbloquear tu cuenta.",
    "Household Zipcode": "C\xF3digo postal del hogar",
    "e.g 90210...": "ej. 90210",
    "help site": "Sitio de ayuda",
    "It looks like you're already subscribed": "Parece que ya est\xE1s suscrito",
    "You must cancel your active subscription before you can continue. You can find out how to cancel your subscription at {supportLink}. Once you've cancelled your current subscription plan you will need to wait until your current subscription plan ends.": "Debes cancelar tu suscripci\xF3n activa antes de poder continuar. Puedes averiguar c\xF3mo cancelar tu suscripci\xF3n en {supportLink}. Una vez que hayas cancelado tu plan de suscripci\xF3n actual, deber\xE1s esperar hasta que finalice el plan de suscripci\xF3n actual.",
    "If you have any questions, please {helplink} contact us.": "Si tiene alguna pregunta, por favor {helplink} p\xF3ngase en contacto con nosotros.",
    "Please create a free account, or sign in": "Por favor crea una cuenta gratuita o inicia sesi\xF3n.",
    "To accept the Family Plan invitation, you must be logged in.": "Para aceptar la invitaci\xF3n al plan familiar debes tener sesi\xF3n iniciada.",
    "Welcome to Your Favorites Radio, a personalized station containing your favorite songs and artists. The more you thumb up and save stations on iHeart, the better your listening experience will be.": "Bienvenido a tu Radio de Favoritos, una estaci\xF3n personalizada con tus canciones y artistas favoritos. Entre m\xE1s indiques que te gustan canciones o sigas estaciones en iHeart, mejor ser\xE1 tu experiencia de escucha. ",
    "Listen to {title}. Thumb up songs to add them to your own Your Favorites Radio station. Find it under My Stations.": "Escucha {title}. Indica que te gustan canciones para agregarlas a tu Radio de Favoritos. Encu\xE9ntrala en Estaciones Seguidas.",
    "Featured Artists On This Station": "Artistas destacados en esta estaci\xF3n.",
    "{name}'s Favorites Radio": "Radio de Favoritos de {name}",
    "iHeartRadio Mobile Apps": "Aplicaciones m\xF3viles de iHeartRadio",
    "Made for You": "Hecho para ti",
    "Listen to Stations For You": "Escucha estaciones Para Ti",
    "Change genre preferences {prefLink}": "Cambiar preferencias de g\xE9nero {prefLink}",
    "here": "aqu\xED",
    "iHeart: Listen to Free Radio Stations & Music Online": "iHeart: escucha estaciones de radio y m\xFAsica gratis en l\xEDnea",
    "All Your Favorite Music. All Your Favorite Stations. All FREE. Listen to thousands of live stations or create your own artist stations. Let the music play!": "Toda tu M\xFAsica Favorita. Todas tus Estaciones Favoritas. TODO GRATIS. Escucha miles de  estaciones en vivo o crea tu propia estaci\xF3n de artista. Deja que suene la m\xFAsica!",
    "Improve Your Recommendations": "Mejorar tus recomendaciones",
    "Change Preferences": "Cambiar preferencias",
    "Change Genre Preferences": "Cambiar preferencias de g\xE9nero",
    "Find Stations by Genre": "Buscar estaciones por g\xE9nero",
    "Finding your ideal station is quick and easy. Search for stations by genre & stream them online for free on iHeart.": "Encontrar tu estaci\xF3n ideal es r\xE1pido y f\xE1cil. Busca estaciones por g\xE9nero y esc\xFAchalas en l\xEDnea gratis en iHeart.",
    "Discover Music and Radio Stations by Genre on iHeart": "Descubre m\xFAsica y estaciones de radio por g\xE9nero en iHeart",
    "Pick Genre": "Selecci\xF3n de g\xE9neros",
    "Tell us all the genres you like.": "Dinos todos los g\xE9neros que te gustan.",
    "We'll suggest stations just For You.": "Te sugeriremos estaciones solo Para Ti.",
    "Get Stations": "Obtener estaciones",
    "Find and stream {genreName} music stations for free, only on iHeart.": "Busca y escucha estaciones de {genreName} de forma gratuita, s\xF3lo en iHeart.",
    "Listen to {genreName} Radio Stations for Free": "Escuchar estaciones de radio de  {genreName} gratis",
    "Find {genreName} Stations": "Encontrar estaciones de {genreName} ",
    "Featured {genreName} Stations": "Estaciones de {genreName} destacadas",
    "Top {genreName} Stations": "Mejores estaciones de {genreName}",
    "Top {genreName} Artists": "Mejores Arstistas de {genreName}",
    "More Genres": "M\xE1s g\xE9neros",
    "Latest News": "\xDAltimas Noticias",
    "Partner Content": "Contenido de afiliado",
    "All Cities": "Todas las ciudades",
    "for {currentGenre}": "para {currentGenre}",
    "in {currentMarket}": "en {currentMarket}",
    "near you": "cerca de ti",
    "Find top stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})": "Buscar mejores estaciones {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})",
    "Listen to Live Radio": "Escuchar estaciones en vivo",
    "No stations currently available for this filter": "No hay estaciones disponibles actualmente para este filtro",
    "Listen to the Best Live Radio Stations in {countryAbbreviation}": "Escucha las mejores estaciones de radio en vivo en {countryAbbreviation}",
    "Listen to {genreName} Radio Stations in {city}": "Escucha {genreName} estaciones de radio en {ciudad}",
    "Listen to Top Radio Stations in {city}, Free": "Escucha las mejores estaciones de radio en {City}, gratis",
    "Live {genreName} Radio Stations in {countryAbbreviation}": "Estaciones de radio en vivo de {genreName} en {countryAbbreviation}",
    "Listen to hundreds of the best live radio stations{countryName}, for free! Search for stations near you & around the country.": "Escucha cientos de las mejores estaciones de radio en vivo de{countryName}, gratis! Busca estaciones cercanas y de todo el pa\xEDs.",
    "Listen to the Best Live Radio{country} for Free on iHeart.": "Escucha la mejor radio en vivo de {country} gratis en iHeart.",
    "Stream the best live {genreName} radio stations in {city} online for free, only on iHeart!": "Escucha las mejores estaciones de radio de {genreName} en {city} en l\xEDnea gratuitamente, solo en iHeart!",
    "Listen to Top {genreName} Radio Stations in {city}": "Escucha las mejores estaciones de {genreName} en {city}",
    "Listen to the best live radio stations in {city}. Stream online for free, only on iHeart!": "Escucha las mejores estaciones de radio en vivo en {city}. Con\xE9ctate en l\xEDnea gratuitamente, solo en iHeart!",
    "Listen to Top Radio Stations in {city} for Free": "Escucha las mejores estaciones de radio en {City}, gratis",
    "Stream the best live {genreName} radio stations in {countryAbbreviation} for free on iHeart.": "Escucha las mejores estaciones de radio en vivo de {genreName} en {countryAbbreviation} gratuitamente en iHeart",
    "Listen to Free, Live {genreName} Radio Stations in {countryAbbreviation} on iHeart": "Escucha gratuitamente, estaciones de radio en vivo de {genreName} en {countryAbbreviation} en iHeart",
    "Contests and Promotions": "Concursos y Promociones",
    "If you like {stationName}...": "Si te gusta {stationName}...",
    "Similar Stations": "Estaciones similiares",
    "{stationName}, {stateAbbreviation}, {city}, {genre}": "{stationName}, {stateAbbreviation}, {city}, {genre}",
    "Genre": "G\xE9nero",
    "Location": "Ubicaci\xF3n",
    "On Air Schedule": "Programaci\xF3n al aire",
    "Share Song": "Compartir canci\xF3n.",
    "Get the latest music news - rock, pop, hip-hop, rock, alternative, and country music news from iHeart. Get the latest music and trending news, from your favorite artists and bands.": "Recibe las \xFAltimas noticias de m\xFAsica: rock, pop, hip-hop, alternativa y m\xFAsica country en iHeart. Obt\xE9n las \xFAltimas noticias de m\xFAsica y tendencias de tus artistas y grupos favoritos.",
    "Breaking Music News, Celeb and Entertainment News and Gossip": "Noticias de \xFAltima hora, celebridades y espect\xE1culos.",
    "Advertise With Us": "An\xFAnciate con nosotros",
    "Discover thousands of top playlists with songs handcrafted by your favorite personalities and music experts on iHeartRadio.": "Descubre miles de playlists hechos a mano por tus personalidades y expertos en m\xFAsica de iHeartRadio.",
    "Listen to the Best Online Music Playlists": "Escucha los mejores Playlists de m\xFAsica en l\xEDnea",
    "Recommended For You": "Recomendado Para Ti",
    "Moods & Activities": "Estados de \xE1nimo y actividades",
    "Decades": "D\xE9cadas",
    "Featured Playlists": "Playlists destacadas",
    "By": "Por",
    "Your songs shuffled with songs we think you\u2019ll like. The more songs you add, the better our picks get.": "Tus canciones mezcladas con canciones que creemos que te gustar\xE1n. Entre m\xE1s canciones agregues, mejores selecciones haremos.",
    "Introducing a new playlist experience": "Presentando una experiencia nueva de playlist",
    "Song saved to Your Library": "Canci\xF3n guardada en Tu Colecci\xF3n",
    "Go to Artist": "Ir al Artista",
    "Go to Album": "Ir al \xC1lbum",
    "Remove from Playlist": "Eliminar del Playlist",
    "SONG": "CANCI\xD3N",
    "ALBUM TITLE": "T\xCDTULO DEL \xC1LBUM",
    "ARTIST": "ARTISTA",
    "DURATION": "DURACI\xD3N",
    "Done": "Hecho",
    "Discover and stream the best {categoryTitle} playlists, handcrafted by the music experts at iHeart.": "Descubre y escucha las mejores playlists de {categoryTitle} hechas a mano por expertos en iHeart.",
    "{categoryTitle}, {categoryTitle} Playlists, Stream {categoryTitle} Music, Play {categoryTitle} Songs, Top {categoryTitle} Playlists, Best { categoryTitle} Playlists": "{categoryTitle}, {categoryTitle} playlists, escucha m\xFAsica de {categoryTitle}, oye canciones de {categoryTitle}, los top playlists de {categoryTitle}, los mejores playlists de { categoryTitle}",
    "Top {categoryTitle} Playlists; Find Your Perfect Music Mix": "Mejores playlists de {categoryTitle}; encuentra tu mezcla de m\xFAsica perfecta",
    "Host": "Locutor",
    "iHeart Podcast Networks": "iHeart Podcast Networks",
    "{name}, Blog, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, Blog, Noticias, M\xFAsica, Titulares, iHeartRadio, iHeart, Radio",
    "{name} Blog, News & Videos": "{name} Blog, Noticias y Videos",
    "Go behind the scenes, get exclusive stories and learn more about the show!": "Mira detr\xE1s del escenario, lee historias exclusivas y aprende m\xE1s sobre el espect\xE1culo!",
    "Played": "Reproducido",
    "Listen to the best {categoryName} radio shows, free and on demand, only on iHeart.": "Escucha los mejores programas de radio de {categoryName}, gratuitamente y en demanda, solo en iHeart.",
    "Listen to the Best Free {categoryName} Podcasts": "Escucha los mejores podcasts de {categoryName} gratis",
    "On Demand, On-Demand, Show, Shows, Personalities, Programs, Listen, iHeartRadio, iHeart": "On Demand, En Demanda, Espect\xE1culo, Espect\xE1culos, Personalidades, Programas, Escucha, iHeartRadio, iHeart",
    "Discover Top Podcasts": "Descubre los mejores podcasts",
    "Listen to the latest episodes from top podcasts. Get news, sports & lifestyle info from your favorite personalities for free!": "Escucha los \xFAltimos episodios de los mejores podcasts. \xA1Obt\xE9n noticias, deportes y estilo de vida de tus personalidades favoritas gratis!",
    "Listen to the Best Podcasts Online for Free on iHeart": "Escucha los mejores podcasts en l\xEDnea de forma gratuita en iHeart",
    "Listen to the Best Podcasts & Shows Online, Free": "Escucha los mejores podcasts y programas en l\xEDnea, gratis",
    "Talk, Show, Host, Personality, On Demand, Topic, Category, Health, News, Politics, Comedy, Station, Internet, Online, iHeartRadio, iHeart": "Hablada, Show, locutor, personalidad, en demanda, tema, categor\xEDa, salud, noticias, pol\xEDtica, comedia, estaci\xF3n, Internet, en l\xEDnea, iHeartRadio, iHeart",
    "Stream Top Podcasts": "Escucha los mejores podcasts",
    "All Topics": "Todos los temas",
    "{name} Podcasts": "{name} Podcasts",
    "Topics": "Temas",
    "All Episodes": "Todos los episodios",
    "These episodes aren't here yet...": "Estos episodios todav\xEDa no est\xE1n aqu\xED",
    "Follow this podcast to be notified when they're ready": "Sigue este podcast para recibir una notificaci\xF3n cuando est\xE9n disponibles",
    "Share Podcast": "Compartir podcast",
    "The Latest News": "Noticias recientes",
    "Listen to {episodeTitle} | {showTitle} | Podcasts": "Escuchar {episodeTitle} | {showTitle} | Podcasts",
    "{episodeTitle},{showTitle},Talk,Radio,Listen,On Demand,iHeartRadio,iHeart": "{episodeTitle},{showTitle},Habla,Radio,Escucha, En demanda,iHeartRadio,iHeart",
    "{title}, Talk, Radio, Listen, On Demand, iHeartRadio, iHeart": "{t\xEDtulo}, Hablar, Radio, Escuchar,  a Petici\xF3n, iHeartRadio, iHeart",
    "Episodes": "Episodios",
    "Popular Podcasts": "Podcasts Populares",
    "Stream the best podcasts from your favorite stations": "Escucha los mejores podcasts de tus estaciones favoritas",
    "Follow Us On": "S\xEDguenos en ",
    "Show Links": "Muestra las ligas",
    "Settings | See Your Music Profile": "Configuraci\xF3n | Ver tu perfil musical",
    "Log in and see which live radio stations and custom artist stations you love. You can also view your listening history. All free.": "Inicia sesi\xF3n y escucha las estaciones de radio o de artista que te encantan. Tambi\xE9n puedes ver la historia de lo que has escuchado. Todo gratis. ",
    "Connections": "Conexiones",
    "Unlink": "Desconectar",
    "Link": "Conectar",
    "Genre added.": "G\xE9nero agregado",
    "Genre removed.": "G\xE9nero eliminado.",
    "You've added {genreName} to your genres.": "Has agregado {genreName} a tus g\xE9neros.",
    "You've removed {genreName} from your genres.": "Has eliminado {genreName} de tus g\xE9neros.",
    "Your preferences have been changed.": "Tus preferencias han sido cambiadas.",
    "Not provided": "No proporcionado",
    "Publish my listening activity to my Facebook music dashboard": "Publicar mi actividad de escucha en mi panel de m\xFAsica de Facebook",
    "Update your password, genre selection, and modify your subscription below.": "Actualizar tu contrase\xF1a, selecci\xF3n de g\xE9nero y modificaci\xF3n de suscripci\xF3n a continuaci\xF3n.",
    "You're currently signed in with a social account, add an email and password to have full access to your account": "Actualmente tienes sesi\xF3n iniciada con una cuenta de redes sociales. Agrega un correo y contrase\xF1a para tener acceso completo a tu cuenta.",
    "Add New Email": "Agrega nuevo correo",
    "Contact Information": "Informaci\xF3n de contacto",
    "Update your contact information to personalize your experience and easily enter iHeart contests and promotions.": "Actualiza tu informaci\xF3n de contacto para personalizar tu experiencia y participar en concursos y promociones de iHeart.",
    "First and Last Name": "Nombre y apellido",
    "Add your full name": "Ingresa tu nombre completo",
    "My Genres": "Mis g\xE9neros",
    "Tell us all your favorite genres so we can make iHeart perfect for you.": "Cu\xE9ntanos todos tus g\xE9neros favoritos de modo que podamos hacer iHeart perfecto para ti",
    "View Recommendations": "Ver recomendaciones",
    "Billing History": "Historial de facturaci\xF3n",
    "Subscribe Again": "Suscribirse de nuevo",
    "Update Payment": "Actualizar pago",
    "Unknown": "Desconocido",
    "Unknown Plan Description": "Descripci\xF3n del plan desconocida",
    "iHeart Family Plan": "Plan Familiar iHeart",
    "You are enjoying an unlimited music experience with an iHeart Family Plan.": "Est\xE1s disfrutando de una experiencia musical ilimitada con un plan familiar de iHeart.",
    "iHeart All Access": "iHeart All Access",
    "You are enjoying an unlimited music experience by subscribing to iHeart All Access.": "Est\xE1s disfrutando de una experiencia musical ilimitada al estar suscrito a iHeart All Access.",
    "iHeart Plus": "iHeart Plus",
    "You are subscribed to iHeart Plus. Switch to iHeart All Access to enjoy an unlimited music experience on your computer.": "Est\xE1s suscrito a iHeart Plus. C\xE1mbiate a iHeart All Access para disfrutar de una experienica de m\xFAsica ilimitada en tu computadora.",
    "iHeart Free": "iHeart gratuito",
    "Subscribe to enjoy unlimited music.": "Suscr\xEDbete para disfrutar de m\xFAsica ilimitada.",
    "Your subscription ends on {subscriptionEndsString}.": "Tu suscripci\xF3n termina en {subscriptionEndsString}.",
    "Family Members": "Miembros de la familia",
    "Subscription": "Suscripci\xF3n",
    "Your Favorite Songs | Log In & See": "Tus canciones favoritas | Inicia sesi\xF3n y ve",
    "Log in or sign up and find the songs you love here, only on iHeart.": "Inicia sesi\xF3n o reg\xEDstrate y encuentra las canciones que amas aqu\xED, s\xF3lo en iHeart.",
    "iHeart Codes Coupons and Special Offers for Unlimited Music": "Cupones de c\xF3digos iHeart y ofertas especiales para m\xFAsica ilimitada.",
    "Find iHeart Radio special offers, codes and coupons for unlimited music on demand and all access to iHeart Plus. These special offers provide access to millions of songs, thousands of radio and artists stations with unlimited skips and offline listening!": "Encuentra ofertas especiales de iHeart, c\xF3digos y cupones para m\xFAsica ilimitada en demanda y acceso a iHeart Plus. Estas ofertas especiales proporcionan acceso a millones de canciones, miles de etaciones de radio y estaciones de artistas, con saltos ilimitados y disponibilidad sin conexi\xF3n.",
    "There was an error validating your request.": "Ocurri\xF3 un error validando tu petici\xF3n",
    "Please enter a valid email address": "Por favor ingresa un correo electr\xF3nico v\xE1lido",
    "Please fix the following errors:": "Por favor corrige los siguientes errores:",
    "Start Your Free 30 Day Trial": "Inicia tu prueba gratuita de 30 d\xEDas.",
    "Start Your Family Plan": "Inicia tu Plan Familiar",
    "Sign up for iHeart All Access Annual Plan": "Reg\xEDstrate para el plan anual de iHeart All Access",
    "View": "Ver",
    "Offer Terms": "T\xE9rminos de la oferta",
    "Email Address": "Correo electr\xF3nico",
    "Enter email address": "Ingresa correo electr\xF3nico",
    "Card Details": "Detalles de tarjeta",
    "Zip / Postal Code": "C\xF3digo postal",
    "Enter Here": "Ingresa aqu\xED",
    "Yes, please automatically renew my subscription annually (subject to {termsLink})": "S\xED, por favor renueva mi suscripci\xF3n anual autom\xE1ticamente (sujeto a {termsLink})",
    "terms & conditions": "t\xE9rminos y condiciones",
    'Charges will appear on your credit card statement as "IHEART BILLING"': 'Los cargos en tu tarjeta de cr\xE9dito aparecer\xE1n como "IHEART BILLING"',
    'You can cancel at any time by going to "Settings" and following the cancellation instructions. By clicking "Subscribe" below, you agree to the conditions above and the iHeart ': 'Puedes cancelar en cualquier momento ingresando a "Configuraci\xF3n" y siguiendo las instrucciones de cancelaci\xF3n. Al dar clic en "Suscribir" abajo, est\xE1s aceptando las condiciones de iHeart y las arriba indicadas.',
    "Processing": "Procesando",
    "Enter your email address below to log in by email or reset your password": "Ingresa tu correo electr\xF3nico abajo para iniciar sesi\xF3n o restablecer tu contrase\xF1a.",
    "email": "Correo electr\xF3nico",
    "Send": "Enviar",
    "Don\u2019t use common passwords, like \u201CPassword123!\u201D": 'No uses contrase\xF1as comunes como "Password123"',
    "Your password reset link is invalid or expired. Please try": "La liga para restablecer la contrase\xF1a es inv\xE1lida o ha expirado. Por favor intenta",
    "resetting your password": "restablecer tu contrase\xF1a",
    "again.": "otra vez.",
    "Create a New Password": "Crear una nueva contrase\xF1a",
    "Your password reset link has expired": "La liga para restablecer la contrase\xF1a ha expirado",
    "An unknown error occured. Please try again later": "Ocurri\xF3 un error inesperado. Por favor intenta m\xE1s tarde",
    "Your password has been updated": "Tu contrase\xF1a ha sido actualizada",
    "Confirm New Password": "Confirmar nueva contrase\xF1a",
    "Create": "Crear",
    "Custom radio stations based off your favorite artists and bands.": "Estaciones de radio personalizadas en base a tus artistas y bandas favoritos.",
    "View More Artists": "Ver m\xE1s artistas",
    "Bring iHeart with you anywhere": "Lleva iHeart contigo a cualquier lugar",
    "The free iHeart app is available on over 200 platforms, including Web, iOS, Android, Alexa, automobiles and more.": "La aplicaci\xF3n gratuita iHeart est\xE1 disponible en m\xE1s de 200 plataformas, incluyendo Web, iOS, Android, Alexa, autom\xF3viles y mucho m\xE1s.",
    "Download on the": "Descargar en el",
    "Download on": "Descargar en",
    "View All Apps": "Ver todas las apps",
    "Upcoming Events": "Pr\xF3ximos Eventos",
    "Listen to Your Favorite Music, Podcasts, and Radio Stations for Free! \u2013 iHeart": "Escucha tu m\xFAsica favorita, podcasts y estaciones de radio gratis! - iHeart",
    "iHeart. All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "iHeart. Toda tu m\xFAsica favorita, estaciones de radio y podcasts de forma gratuita.. Escucha miles de estaciones o crea tus estaciones de artistas y playlists. Recibe las noticias de tus artistas y bandas favoritas. ",
    "Get Started Free": "Empieza gratis",
    "All your favorite music, radio and podcasts, all free.": "Toda tu m\xFAsica favorita, radio y podcasts, todo gratis.",
    "Your browser does not support video playback": "Tu navegador no soporta la reproducci\xF3n de video",
    "The best live stations from around the country, any time, any place.": "Las mejores estaciones en vivo de todo el pa\xEDs, en cualquier momento y en cualquier lugar.",
    "View More Live Stations": "Ver m\xE1s estaciones en vivo",
    "New on iHeart": "Nuevo en iHeart",
    "Latest Music News": "\xDAltimas noticias de la m\xFAsica",
    "View More Music News": "Ver m\xE1s noticias de m\xFAsica",
    "Popular and exclusive podcasts in a variety of genres and topics.": "Podcasts populares y exclusivos en una variedad de g\xE9neros y temas",
    "View More Podcasts": "Ver m\xE1s Podcasts",
    "{count} song{plural}": "{count}canci\xF3n{plural}",
    "Browse Artists": "Explora Artistas",
    "Need to find a great new album?": "\xBFNecesitas encontrar un nuevo \xE1lbum?",
    "Any albums you save will show up here": "Los \xE1lbumes que salves aparecer\xE1n aqu\xED",
    "Need to find an artist you love?": "\xBFNecesitas encontrar un artista que te encanta?",
    "Any artists you follow will show up here": "Los artistas que sigas aparecer\xE1n aqu\xED",
    "Access your music library and create unlimited playlists with iHeart All Access": "Accede a tu Colecci\xF3n de m\xFAsica y crea playlists ilimitados con iHeart All Access.",
    "song{pluralSongs}": "canci\xF3n{pluralSongs}",
    "by": "por",
    "Browse Playlists": "Explora las Playlists",
    "Need a playlist to fit your mood?": "\xBFNecesitas una playlist para tu estado de \xE1nimo?",
    "Any playlists you follow will show up here": "Las playlists que sigas aparecer\xE1n aqu\xED",
    "Browse Podcasts": "Explora los Podcasts",
    "Need a great new podcast to start?": "\xBFNecesitas un podcast nuevo para empezar?",
    "Any podcasts you follow will show up here": "Los podcasts que sigas aparecer\xE1n aqu\xED",
    "Any radio, music, or podcasts you listen to will show up here": "Cualquier estaci\xF3n, m\xFAsica o podcast que escuches aparecer\xE1 aqu\xED",
    "Browse Stations For You": "Explora estaciones Para Ti",
    "Any podcasts you listen to will show up here": "Cualquier podcast que escuches aparecer\xE1 aqu\xED",
    "Need help finding something new?": "\xBFNecesitas ayuda para encontrar algo nuevo?",
    "Remove station": "Eliminar estaci\xF3n",
    "{name} removed from Your Library": "{name} se ha eliminado de Tu Colecci\xF3n",
    "Followed Stations": "Estaciones seguidas",
    "Browse Live Radio": "Explora Radio en Vivo",
    "Browse Artist Radio": "Explora Radio de Artistas",
    "Need help finding stations to save?": "\xBFNecesitas ayuda para encontrar estaciones que quieras guardar?",
    "Your followed live and artist radio stations will show up here": "Las estaciones en vivo y de artista que sigues, aparecer\xE1n aqu\xED.",
    "{albumName} removed from Your Library": "{albumName}se ha eliminado de Tu Colecci\xF3n",
    "Remove": "Eliminar",
    "{artistName} removed from Your Library": "{artistName} se ha eliminado de Tu Colecci\xF3n",
    "ARTIST IN YOUR LIBRARY": "ARTISTA EN TU COLECCI\xD3N",
    "Add to playlist": "A\xF1adir a playlist",
    "Play Now": "Reproducir ahora",
    "{songTitle} removed from Your Library": "{songTitle} se ha eliminado de Tu Colecci\xF3n",
    "Need to find a new song?": "\xBFNecesitas encontrar una nueva canci\xF3n?",
    "Any song you save will show up here": "Cualquier canci\xF3n que guardes aparecer\xE1 aqu\xED",
    "Playlist Radio": "Radio de Playlist",
    "View All": "Ver todo",
    "Copied": "Copiado",
    "Read more on iHeartRadio": "Lee m\xE1s en iHeartRadio",
    "Link Copied!": "\xA1Liga copiada!",
    "Copy Link": "Copiar liga",
    "Code Copied!": "\xA1C\xF3digo copiado!",
    "Embed": "Incrustar",
    "Follow on iHeartRadio": "Seguir en iHeartRadio",
    "Playback not supported by device or browser.": "No se puede reproducir en este dispositivo o navegador.",
    "Method {method} not supported.": "Method {method} not supported.",
    "View iHeart.com": "Ver iHeart.com",
    "Oops, that wasn't supposed to happen.": "Uy, eso no debi\xF3 haber pasado.",
    "Oops, this feature isn't supported yet.": "Uy, esta funci\xF3n a\xFAn no est\xE1 disponible",
    "Oops! We had problems playing this stream.": "\xA1Uy! Tuvimos problemas para tocar eso.",
    "This station is not currently available in your country.": "Esta estaci\xF3n no est\xE1 disponible en tu pa\xEDs.",
    "Retry": "Reintentar",
    "Report this issue": "Reportar este problema",
    "View Troubleshooting": "Ver soluci\xF3n de problemas",
    "hello": "hola",
    "my friend": "mi amigo",
    "Share this live station": "Comparte esta estaci\xF3n",
    "Create your own on iHeart": "Crea tu propia en iHeart",
    "We're sorry! This playlist is not available in your country.": "\xA1Lo sentimos! Esta playlist no est\xE1 disponible en tu pa\xEDs.",
    "Playlist Not Available": "Playlist no disponible",
    "This playlist is unsupported in your current country.": "Este playlist no est\xE1 disponible en el pa\xEDs actual.",
    "Playback Unsupported In Current Country": "Reproducci\xF3n no disponible en el pa\xEDs actual.",
    "Featured artists in this playlist": "Artistas destacados en esta playlist",
    "View Playlist": "Ver playlist",
    "Share this episode": "Comparte este episodio",
    "Listen to more episodes": "Escucha m\xE1s episodios",
    "Share this podcast": "Compartir podcast"
  },
  "fr": {
    "Facebook": "Facebook",
    "Google": "Google",
    "Region Not Supported": "R\xE9gion non prise en charge",
    "Do not sell or share my personal information": "Ne pas vendre mon information personnelle",
    "Log In": "Connexion",
    "Sorry, an error occurred. Please try again later.": "D\xE9sol\xE9s, une erreur s'est produite. Veuillez r\xE9essayer plus tard.",
    "Don't have an account?": "Vous n'avez pas de compte?",
    "Sign up": "Abonnez-vous",
    "Forgot Password?": "Mot de passe oubli\xE9?",
    "Email": "Adresse courriel",
    "Password": "Mot de passe",
    "Sorry for the inconvenience, but we do not allow account sign-up for your current location.": "D\xE9sol\xE9s de l'inconv\xE9nient, mais nous ne permettons pas la cr\xE9ation de comptes pour votre emplacement. ",
    "Visit our Help Center": "Consulter notre Centre d'aide",
    "Return to Log In": "Revenir \xE0 la connexion",
    "Male": "Homme",
    "Female": "Femme",
    "Prefer not to say": "Je pr\xE9f\xE8re ne pas r\xE9pondre",
    "Other": "Autre",
    "8 to 32 characters": "8 \xE0 32 caract\xE8res",
    "an upper case and lower case letter": "une lettre majuscule et une minuscule",
    "a number (0-9)": "un chiffre (0-9)",
    "Error": "Erreur",
    "Success": "Succ\xE8s",
    "Password must have eight to thiry two characters": "Le mot de passe doit comporter de huit \xE0 trente-deux caract\xE8res",
    "Password doesn't have eight to thirty two characters": "Le mot de passe ne comporte pas de huit \xE0 trente-deux caract\xE8res",
    "Password has eight to thirty two characters": "Le mot de passe comporte de huit \xE0 trente-deux caract\xE8res",
    "Password must have an uppercase and lower case letter": "Le mot de passe doit comprendre une lettre majuscule et une minuscule",
    "Password doesn't have an upper case and lower case letter": "Le mot de passe ne comprend pas une lettre majuscule et une minuscule",
    "Password has an upper case and lower case letter": "Le mot de passe comprend une lettre majuscule et une minuscule",
    "Password must have a number between zero and nine": "Le mot de passe doit comprendre un chiffre entre z\xE9ro et neuf",
    "Password doesn't have a number between zero and nine": "Le mot de passe ne comprend pas un chiffre entre z\xE9ro et neuf",
    "password has a number between zero and nine": "Le mot de passe comprend un chiffre entre z\xE9ro et neuf",
    "Please fill out all form fields": "Veuillez remplir tous les champs du formulaire ",
    "Password shouldn't have common words or passwords": "Le mot de passe ne devrait pas \xEAtre un mot ou un mot de passe commun",
    "Password can only have English letters, numbers, spaces, and special characters from: . ! ? - _ , ; : /  ( ) [ ] ~ @ # $ % ^ & * + = \\": "",
    "Invalid Email Address": "Adresse courriel invalide",
    "Birth Year": "Ann\xE9e de naissance",
    "Terms of Service": "Conditions d'utilisation",
    "Privacy Policy": "Politique de confidentialit\xE9",
    "Sign Up": "Abonnez-vous",
    "Postal Code": "Code postal",
    "Invalid Postal Code": "Code postal invalide",
    "Invalid ZIP Code": "Code postal invalide",
    "Have an account?": "Vous avez d\xE9j\xE0 un compte?",
    "Login unsuccessful. Please try again later.": "\xC9chec de la connexion. Veuillez r\xE9essayer.",
    "Update successful.": "Mise \xE0 jour r\xE9ussie.",
    "Your account has been linked to {provider}.": "Votre compte a \xE9t\xE9 li\xE9 \xE0 {provider}.",
    "This {accountType} account is already linked to an iHeartRadio account": "Ce compte {accountType} est d\xE9j\xE0 li\xE9 \xE0 un compte iHeartRadio",
    "{accountType} account linking failed. Please try again later.": "Connexion du compte {accountType} a \xE9chou\xE9. Veuillez r\xE9essayer plus tard.",
    "Your account has been unlinked from {provider}.": "Votre compte a \xE9t\xE9 d\xE9li\xE9 de {provider}.",
    "{accountType} account unlinking failed. Please try again later.": "D\xE9connexion du compte {accountType} a \xE9chou\xE9. Veuillez r\xE9essayer plus tard.",
    "Login unsuccessful. Window closed before completion. Please try again.": "\xC9chec de la connexion. La fen\xEAtre a \xE9t\xE9 ferm\xE9e avant la fin de l'op\xE9ration. Veuillez r\xE9essayer.",
    "Do You Have a Popup Blocker?": "Avez-vous un bloqueur de pop-ups?",
    "To log in with your Facebook or Google account, ensure you've allowed popups from www.iheart.com, refresh, and then try again.": "Pour vous connecter avec votre compte Facebook ou Google, assurez vous que vous pouvez voir les pop-ups de www.iheart.com, rafra\xEEchissez la page et r\xE9essayer.",
    "Feat. {artistNames} and more": "avec {artistNames} et plus",
    "iHeart": "iHeart",
    "For You": "Pour vous",
    "Add to Playlist": "Ajouter \xE0 la liste d'\xE9coute",
    "Episode Info": "Info de l'\xE9pisode",
    "Lyrics": "Paroles",
    "Rename your Favorites Radio station now.": "Renommez votre station de favoris maintenant.",
    "This song is not available to start your station.": "Cette chanson n'est pas disponible pour d\xE9marrer votre station.",
    "Play this on web with All Access": "Jouez ceci sur le web avec Tout Acc\xE8s",
    "Subscribe today for unlimited access to playlists": "Abonnez-vous aujourd'hui pour un acc\xE8s illimit\xE9 aux listes d'\xE9coute",
    "Play the whole album with iHeart All Access.": "Jouez l'album au complet avec Tout Acc\xE8s iHeartRadio.",
    "Listen History": "Historique d'\xE9coute",
    "Custom Stations Limit Exceeded": "Limite de stations personnalis\xE9es d\xE9pass\xE9e",
    "Please delete some stations from your account under {listenHistoryLink} before creating new stations.": "Veuillez supprimer des stations de votre compte sous {listenHistoryLink} avant d'en cr\xE9er de nouvelles.",
    "Sorry, this station has run out of songs to play.": "D\xE9sol\xE9s, cette station n'a plus de chansons \xE0 jouer.",
    "Oops": "Oups",
    "We don't have enough info to create a custom station right now. We'll let our DJs know.": "Nous n'avons pas assez d'information pour cr\xE9er une station personnalis\xE9e en ce moment. Nous informerons nos animateurs.",
    "Replay failed": "\xC9chec de la r\xE9p\xE9tition",
    "An unknown error occurred. Please try again later.": "Une erreur inattendue s'est produite. Veuillez r\xE9essayer plus tard.",
    "Update Account": "Mettre le compte \xE0 jour",
    "Please enter a valid email": "Veuillez entrer une adresse courriel valide",
    "New Email": "Nouvelle adresse courriel",
    "Please enter the same email again": "Veuillez entrer le m\xEAme courriel de nouveau",
    "Confirm New Email": "Confirmer la nouvelle adresse courriel",
    "Password must be 6 - 32 characters": "Le mot de passe doit avoir entre 6 et 32 caract\xE8res",
    "New Password (6-32 Characters)": "Nouveau mot de passe (6-32 caract\xE8res)",
    "Confirm": "Confirmez",
    "Cancel": "Annuler",
    "Cannot add duplicate tracks to a playlist": "Les chansons ne peuvent \xEAtre ajout\xE9es en double dans une liste d'\xE9coute",
    "Added {contentType} to {playlistName}": "{contentType} ajout\xE9 \xE0 {playlistName}",
    "Added song to {playlistName}": "Chanson ajout\xE9e \xE0 {playlistName}",
    "Ok": "Ok",
    "Success!": "Succ\xE8s!",
    "Your email and password have been added to your account.": "Votre courriel et votre mot de passe ont \xE9t\xE9 ajout\xE9s \xE0 votre compte.",
    "Your email has been saved.": "Votre courriel a \xE9t\xE9 sauvegard\xE9.",
    "Your contact information has been saved.": "Vos coordonn\xE9es ont \xE9t\xE9 sauvegard\xE9es.",
    "Try Again": "R\xE9-essayer",
    "For assistance, please visit our {helplink}.": "Pour de l'aide, allez \xE0 {helplink}.",
    "Help Link": "Lien pour de l'aide",
    "Oops!": "Oups!",
    "Get Started": "D\xE9buter",
    "You can now enjoy the full benefits of iHeart All Access for Family.": "Vous avez maintenant acc\xE8s \xE0 tous les b\xE9n\xE9fices de Tout Acc\xE8s iHeartRadio pour la famille.",
    "Welcome to the Family!": "Bienvenue \xE0 la famille!",
    "Your password has been saved.": "Votre mot de passe a \xE9t\xE9 sauvegard\xE9.",
    "Station Not Available": "Station non disponible",
    "We're sorry! This station is not available in your country.": "D\xE9sol\xE9s, cette station n'est pas disponible dans votre pays!",
    "Updated {updateDateAndTime}": "Mis \xE0 jour le {updateDateAndTime}",
    "Please complete the CAPTCHA": "Veuillez compl\xE9ter le CAPTCHA",
    "Check Your Email": "V\xE9rifier vos courriels",
    "Forgot Password": "Mot de passe oubli\xE9",
    "Enter your email address below to log in by email or reset your password.": "Entrez votre adresse courriel ci-dessous pour vous connecter par courriel ou pour r\xE9initialiser votre mot de passe.",
    "Enter your email address below to reset your password.": "Entrez votre adresse courriel ci-dessous pour r\xE9initialiser votre mot de passe.",
    "If an account exists, you'll receive a password reset link shortly. Check your spam folder if it takes more than a minute or two.": "Si un compte existe, vous recevrez un lien de r\xE9initialisation du mot de passe. V\xE9rifiez votre dossier de pourriel si vous ne le recevez pas d'ici une ou deux minutes.",
    "Okay": "D'accord",
    "Back to login": "Retour \xE0 la page de connection",
    "Submit": "Soumettre",
    "Or, {backToLoginLink}": "Ou, {backToLoginLink}",
    "Gender": "Sexe",
    "Music and radio on demand": "Musique et radio sur demande",
    "Please log in first.": "Veuillez vous connecter d'abord.",
    "Login": "Connexion",
    "To listen to thousands of live radio and artist stations, create a free account.": "Cr\xE9ez un compte gratuit pour \xE9couter des milliers de stations de radio et d'artistes en direct.",
    "To listen to thousands of live radio stations, create a free account.": "Cr\xE9ez un compte gratuit pour \xE9couter des milliers de stations de radio en direct.",
    "Connect with your favorites": "Connectez-vous \xE0 la musique que vous aimez",
    "To easily find your favorite and recently listened to stations, create a free account.": "Pour facilement trouver vos stations pr\xE9f\xE9r\xE9es et celles que vous avez \xE9cout\xE9es r\xE9cemment, cr\xE9ez un compte gratuit.",
    "Access your stations": "Acc\xE9dez \xE0 vos stations",
    "To view recently listened to stations and songs, create a free account.": "Pour voir les stations et les chansons que vous avez \xE9cout\xE9es r\xE9cemment, cr\xE9ez un compte gratuit.",
    "See what you've been listening to": "Voyez ce que vous avez \xE9cout\xE9",
    "To access your favorites anytime, anywhere, create a free account.": "Pour avoir acc\xE8s \xE0 vos favoris n'importe quand, n'importe o\xF9, cr\xE9ez un compte gratuit.",
    "Save stations you love": "Sauvegardez les stations que vous aimez",
    "To hear more music you like, create a free account.": "Pour \xE9couter encore plus de musique que vous aimez, cr\xE9ez un compte gratuit.",
    "Personalize your listening": "Personnalisez votre \xE9coute",
    "To listen to this artist and more, without interruption, create your free account.": "Pour \xE9couter cet artiste et plus, sans interruption, cr\xE9ez votre compte gratuit.",
    "Listen to {stationName}": "\xC9coutez {stationName}",
    "Listen to Artist Stations": "\xC9coutez des stations d'artistes",
    "To listen to music based on this song, create your free account.": "Pour \xE9couter de la musique choisie \xE0 partir de cette chanson, cr\xE9ez un compte gratuit.",
    "Listen to songs like {stationName}": "\xC9coutez des chansons comme {stationName}",
    "Listen to songs like this": "\xC9coutez des chansons comme celle-ci",
    "To listen to this podcast and more, create your free account.": "Pour \xE9couter ce balado et plus, cr\xE9ez ce compte gratuit.",
    "Listen to Podcasts": "\xC9coutez des balados",
    "To hear all your favorite songs and artists on your own personal station, create a free account.": "Pour entendre toutes vos chansons et vos artistes pr\xE9f\xE9r\xE9s sur votre propre station, cr\xE9ez un compte gratuit.",
    "Listen to {stationName}!": "\xC9coutez {stationName}!",
    "Listen to Your Favorites Radio!": "\xC9coutez votre radio de chansons pr\xE9f\xE9r\xE9es!",
    "To listen, create a free account.": "Cr\xE9ez un compte gratuit pour commencer \xE0 \xE9couter de la musique.",
    "Listen to Favorites Radio!": "\xC9coutez votre radio de chansons pr\xE9f\xE9r\xE9es!",
    "All your favorite music. All your favorite stations. All free.": "Toute votre musique pr\xE9f\xE9r\xE9e. Toutes vos stations pr\xE9f\xE9r\xE9es. Tout gratuit.",
    "Create Your iHeart Account": "Cr\xE9ez votre compte iHeartRadio",
    "Please create a free account.": "Veuillez cr\xE9er un compte gratuit.",
    "Register first": "Abonnez-vous d'abord",
    "Create a FREE account to add songs and albums to your playlist": "Cr\xE9ez un compte GRATUIT pour ajouter des chansons et des albums \xE0 votre liste d'\xE9coute",
    "Welcome to the All Access FREE Preview Weekend. Create your FREE account and listen to millions of songs, live radio, playlists, and podcasts \u2013 enjoy All Access, FREE this weekend only.": "Bienvenue \xE0 notre fin de semaine d'essai de Tout Acc\xE8s gratuit. Cr\xE9ez votre compte GRATUIT et \xE9coutez des millions de chansons, de la radio en direct, des listes d'\xE9coute et des balados - tout cela, gratuitement, seulement pour cette fin de semaine.",
    "Your Halloween treat is here": "Votre g\xE2terie d'Halloween est arriv\xE9e",
    "To join the Family Plan you've been invited to, please create a free account": "Pour adh\xE9rer au Plan famille auquel vous avez \xE9t\xE9 invit\xE9, veuillez cr\xE9er un compte gratuit",
    "Create a free account to join your Family Plan": "Cr\xE9ez un compte gratuit pour adh\xE9rer \xE0 votre Plan famille",
    "Please correct all password errors": "Veuillez corriger toutes les erreurs dans le mot de passe",
    "Sorry, you are not eligible to register for iHeart": "D\xE9sol\xE9s, vous n'\xEAtes pas \xE9ligible pour un compte iHeartRadio",
    "Zip Code": "Code postal",
    "Please enter a valid birth year": "Entrez une ann\xE9e de naissance valide",
    "Receive email updates on stations I listen to and more from iHeart.": "Recevoir des nouvelles par courriel de iHeartRadio \xE0 propos des stations que j'\xE9coute et plus encore.",
    "By creating an account, you also agree to our {termsOfServiceLink} and {privacyPolicyLink}.": "En cr\xE9ant un compte, vous acceptez \xE9galement nos {termsOfServiceLink} et {privacyPolicyLink}.",
    "Or Connect With": "Ou connectez-vous avec",
    "Login with Facebook": "Se connecter avec Facebook",
    "Login with Google": "Se connecter avec Google",
    "Added By iHeart": "Ajout\xE9 par iHeartRadio",
    "Suggestions based on the songs you added.": "Des suggestions bas\xE9es sur les chansons que vous avez ajout\xE9es.",
    "You have All Access": "Vous avez Tout Acc\xE8s",
    "Upgrade to All Access": "Passez \xE0 Tout Acc\xE8s",
    "Want to keep enjoying these perks after the weekend?": "Vous voulez continuer de profiter de ces avantages apr\xE8s cette fin de semaine?",
    "Listen offline, unlimited skips, save and play songs from the radio.": "\xC9couter hors ligne, des sauts illimit\xE9s, sauvegarder et jouer des chansons de la radio.",
    "Learn More": "Apprenez-en plus",
    "Start 30 Day Free Trial": "Commencer l'essai gratuit de 30 jours",
    "You will lose unlimited skips, replay, and access to your playlist": "Vous perdrez vos sauts illimit\xE9s, vos r\xE9-\xE9coutes et l'acc\xE8s \xE0 votre liste d'\xE9coute",
    "You will lose offline listening, unlimited playlists, and replay": "Vous perdrez l'\xE9coute hors ligne, les listes d'\xE9coute illimit\xE9es et la possibilit\xE9 de rejouer des chansons",
    "Are you sure you want to cancel?": "\xCAtes-vous s\xFBr de vouloir annuler?",
    "Your subscription ends on {date}": "Your abonnement prend fin le {date}",
    "Your playlists will be waiting for you should you decide to subscribe again.": "Vos listes d'\xE9coute seront encore l\xE0 si vous d\xE9cidez de vous abonner \xE0 nouveau.",
    "Keep Current Plan": "Garder le plan actuel",
    "Got It": "Compris",
    "Cancel Plan": "Annuler le plan",
    "Trending - Just Now": "En vedette - \xE0 l'instant",
    "Help Center": "Centre d'aide",
    "There was an error updating your email": "Il y a eu une erreur lors de la mise \xE0 jour de votre adresse courriel",
    "Update Contact Information": "Mettre \xE0 jour les coordonn\xE9es",
    "Please enter your first name": "Veuillez entrer votre pr\xE9nom",
    "Add your first name": "Ajouter votre pr\xE9nom",
    "First Name": "Pr\xE9nom",
    "Please enter your last name": "Veuillez entrer votre nom de famille",
    "Add your last name": "Ajouter votre nom de famille",
    "Last Name": "Nom de famille",
    "Please enter a valid phone number": "Veuillez entrer un num\xE9ro de t\xE9l\xE9phone valide",
    "Phone Number": "Num\xE9ro de t\xE9l\xE9phone",
    "Visit Our {helpCenterLink}": "Consultez notre {helpCenterLink}",
    "This email address is already associated with an iHeart account": "Cette adresse courriel est d\xE9j\xE0 li\xE9 \xE0 un compte iHeart",
    "Emails must match": "Les courriels doivent concorder",
    "Change Email": "Changer l'adresse courriel",
    "Please enter the same value again": "Veuillez entrer la m\xEAme valeur",
    "Please enter your password": "Veuillez entrer votre mot de passe",
    "Or, Visit Our {helpCenterLink}": "Ou, visitez notre {helpCenterLink}",
    "Password doesn't match our records": "Le mot de passe ne correspond pas \xE0 celui dans nos dossiers",
    "Uh-oh passwords don't match": "Oups, les mots de passe ne correspondent pas",
    "Your new password cannot be the same as your current password": "Votre nouveau mot de passe ne peut pas \xEAtre le m\xEAme que votre mot de passe actuel",
    "Password can only have English letters, numbers, spaces, and special characters from: dot, exclamation point, question mark, dash, underscore, comma, semicolon, colon, forward slash, backslash, open parenthesis, close parenthesis, open bracket, close bracket, tilde, at sign, number sign, dollar sign, percent sign, caret, ampersand, asterisk, plus sign, equal sign, apostrophe, quotation mark, grave accent, vertical bar, open curly bracket, close curly bracket, less than sign, and greater than sign": "",
    "Update Password": "Mise \xE0 jour du mot de passe",
    "Old Password": "Ancien mot de passe ",
    "New Password": "Nouveau mot de passe",
    "Confirm Password": "Confirmez le mot de passe",
    "Update": "Mise \xE0 jour",
    "Are you sure you want to continue?": "\xCAtes-vous s\xFBr de vouloir continuer?",
    "Signed Out": "D\xE9connexion",
    "You have been signed out. Please log back in.": "Vous avez \xE9t\xE9 d\xE9connect\xE9. Veuillez vous reconnecter.",
    "\xA9 {fourDigitYear} iHeartMedia, Inc.": "\xA9 {fourDigitYear} iHeartMedia, Inc.",
    "Help": "Aide",
    "Terms of Use": "Conditions d'utilisation",
    'Playlist "{playlistName}" created': `Liste d'\xE9coute "{playlistName}" cr\xE9\xE9e`,
    "Create unlimited playlists with iHeart All Access.": "Cr\xE9ez des listes d'\xE9coute illimit\xE9es avec Tout Acc\xE8s iHeart.",
    "There was an error creating your playlist": "Il y a eu une erreur lors de la cr\xE9ation de votre liste d'\xE9coute",
    "Device Limit": "Limite d'appareils",
    "This stream stopped because you're listening on another device.": "Cette diffusion s'est arr\xEAt\xE9e parce que vous \xE9coutez aussi sur un autre appareil.",
    "Listen on this device": "\xC9couter sur cet appareil",
    "Got it": "D'accord",
    "Album saved to Your Library": "Album sauvegard\xE9 \xE0 votre librairie",
    "Save Album": "Sauvegarder l'album",
    "Saved {name} to Your Library": " {name} sauvegard\xE9 dans votre librairie",
    "Removed {name} from Your Library": " {name} effac\xE9 de votre librairie",
    "Follow Artist": "Suivre l'artiste",
    "Remove Artist": "Supprimer cet artiste",
    "Not for Me": "Pas pour moi",
    "Delete": "Supprimer",
    "Follow station": "Suivre la station",
    "Unfollow station": "Ne plus suivre la station",
    "Connect": "Se connecter",
    "Call ": "Appeler",
    "Text ": "Texter",
    "Edit Playlist": "\xC9diter la liste d'\xE9coute",
    "Delete Playlist": "Supprimer la liste d'\xE9coute",
    "Unfollow Playlist": "Ne plus suivre cette liste d'\xE9coute",
    "Follow Playlist": "Suivre cette liste d'\xE9coute",
    "Followed {title}": " {title} suivi",
    "Unfollowed {title}": " {title} n'est plus suivi",
    "Follow Podcast": "Suivre ce balado",
    "Unfollow Podcast": "Ne plus suivre ce balado",
    "No added songs yet": "Aucune chanson sauvegard\xE9e",
    "Tap ": "Appuyez",
    "Save": "Sauvegarder",
    " on the player to add a song to My Playlist": "sur le lecteur pour ajouter une chanson \xE0 votre liste d'\xE9coute",
    "Click on the": "Cliquez sur le",
    "button next to a song": "bouton \xE0 c\xF4t\xE9 d'une chanson",
    "and select Add to Playlist.": "et choisissez Ajouter \xE0 la liste d'\xE9coute.",
    "Find Music": "Trouver de la musique",
    "Uh oh, we can\u2019t find the page you\u2019re looking for.": "Oups, nous ne pouvons trouver la page que vous cherchez.",
    "How about this page instead: ": "Peut-\xEAtre cette page \xE0 la place :",
    "Read more": "Lire plus",
    "Explicit": "Explicite",
    "E": "E",
    "Invite sent to {email}": "Invitation envoy\xE9e \xE0 {email}",
    "Add family member...": "Ajouter un membre de famille...",
    "email@example.com": "courriel@exemple.com",
    "Send Invite": "Envoyer des invitations",
    "You": "Vous",
    "Active": "Actif",
    "{email} has been removed.": "{email} a \xE9t\xE9 enlev\xE9.",
    "Remove Member": "Retirer un membre",
    "Cancel Invite": "Annuler l'invitation",
    "Resend Invite": "Renvoyer l'invitation",
    "Invite was sent on ": "Invitation envoy\xE9e",
    "Active \u2713": "Actif \u2713",
    "Pending...": "En attente...",
    "Invitees must be 14 years or older": "Les invit\xE9s doivent avoir 14 ans ou plus",
    "Owner": "Propri\xE9taire",
    "Following": "Vous suivez",
    "Follow": "Suivre",
    "Music, radio and podcasts, all free. Listen online or download the iHeart App.": "Musique, radio et balados, tout cela gratuitement. \xC9coutez-nous en ligne ou t\xE9l\xE9chargez l'appli iHeart.",
    "Connect with Facebook": "Se connecter avec Facebook",
    "Connect with Twitter": "Se connecter avec Twitter",
    "iHeart Instagram": "Instagram iHeart",
    "iHeart Youtube": "Youtube iHeart",
    "Explore": "Explorer",
    "Live Radio": "Radio en direct",
    "Podcasts": "Balados",
    "On Demand Podcasts": "Balados sur demande",
    "Artist Radio": "Radio artiste",
    "Playlists": "Listes d'\xE9coute",
    "Genres": "Genres",
    "Browse by Genre": "Chercher par genre",
    "Exclusives": "Exclusifs",
    "News": "Nouvelles",
    "iHeart News": "Nouvelles iHeart",
    "Features": "En vedette",
    "Featured Exclusives on iHeart": "Exclusifs en vedette sur iHeart",
    "Events": "\xC9v\xE9nements",
    "iHeart Events": "\xC9v\xE9nements iHeart",
    "Contests": "Concours",
    "iHeart Contests": "Concours iHeart",
    "Photos": "Photos",
    "iHeart Photos": "Photos iHeart",
    "Information": "Information",
    "About": "\xC0 propos",
    "About iHeart": "\xC0 propos de iHeart",
    "Advertise": "Publicit\xE9",
    "Advertise on iHeart": "Faire de la publicit\xE9 sur iHeart",
    "Blog": "Blogue",
    "iHeart Blog": "Blogue iHeart",
    "Brand Guidelines": "Directives de marque",
    "iHeart Logo and Guidelines": "Logo et directives iHeart",
    "Contest Guidelines": "Directives de concours",
    "iHeart Contest Rules": "R\xE8gles des concours iHeart",
    "Subscription Offers": "Offres d'abonnement",
    "Jobs": "Emplois",
    "iHeart Jobs": "Emplois iHeart",
    "Get the App": "T\xE9l\xE9charger l'appli",
    "Automotive": "Auto",
    "iHeart in your house": "iHeart chez vous",
    "Home": "Page principale",
    "iHeart in your car": "iHeart dans votre auto",
    "Mobile": "Mobile",
    "iHeart on your phone or tablet": "iHeart sur votre t\xE9l\xE9phone ou votre tablette",
    "Wearables": "Portables",
    "iHeart wearables": "Portables iHeart",
    "Your Library": "Ma librairie",
    "Saved {name} to {savedStationsLink}": " {name} sauvegard\xE9 \xE0 {savedStationsLink}",
    "Removed {name} from {savedStationsLink}": " {name} retir\xE9 de {savedStationsLink}",
    "Followed {podcastName}": "{podcastName} suivi",
    "Unfollowed {podcastName}": "{podcastName} n'est plus suivi",
    "We won't play this song again on this station.": "On ne jouera plus cette chanson sur cette radio.",
    "Thanks for your feedback.": "Merci pour vos r\xE9actions",
    "favorite songs": "chansons pr\xE9f\xE9r\xE9es",
    "We'll play more like it. Check out your {favoriteSongsLink} to see everything you've liked.": "On jouera plus de chansons comme \xE7a. Allez \xE0 {favoriteSongsLink} pour voir ce que vous avez aim\xE9.",
    "We'll let our DJs know you've heard enough of this song.": "Nous laisserons nos animateurs savoir que vous avez assez entendu cette chanson.",
    "Check out your {favoriteSongsLink} to see everything you've liked.": "Allez \xE0 votre {favoriteSongsLink} pour voir tout ce que vous avez aim\xE9.",
    "Glad you like it. We'll let our DJs know.": "Contents que vous aimiez. Nous en informerons nos animateurs.",
    "OK, we'll adjust your music mix.": "D'accord, nous ajusterons votre mix de musique.",
    "Favorites Radio": "Radio de chansons pr\xE9f\xE9r\xE9es",
    "Great, we\u2019ll add this song to your own {favoritesRadioLink}!": "Super, nous ajouterons cette chanson \xE0 votre propre {favoritesRadioLink}!",
    "Great, we\u2019ll play you more songs like this": "Super, on vous jouera plus de chansons comme celle-l\xE0",
    "We appreciate you letting us know.": "Merci de nous l'avoir fait savoir.",
    "Nice! You\u2019ll hear this song more often.": "Super! Vous entendrez cette chanson plus souvent.",
    "You've reached your skip limit.": "Vous avez atteint votre limite de sauts.",
    "We're sorry, you can't skip any more songs right now. You can still thumb down a song. Want to know more? Visit {helpLink}": "D\xE9sol\xE9s, vous ne pouvez sauter d'autres chansons pour le moment. Vous pouvez encore donner un pouce vers le bas. Vous voulez en savoir plus? Visitez {helpLink}",
    "Report this issue.": "Signaler ce probl\xE8me.",
    "There's an error with episodes for this show. {reportLink}": "Une erreur est survenue avec les \xE9pisodes de cette \xE9mission. {reportLink}",
    "There's an error with this content. {reportLink}": "Une erreur est survenue avec ce contenu. {reportLink}",
    "Playlist followed and saved to {link}": "Liste d'\xE9coute suivie sauvegard\xE9e \xE0 {link}",
    "Playlist unfollowed and removed from {link}": "Liste d'\xE9coute non suivie et retir\xE9e de {link}",
    "Click here": "Cliquez ici",
    "Having trouble logging into iHeart with your Facebook or Google account? {clickHereLink} for help.": "De la difficult\xE9 \xE0 vous connecter \xE0 iHeart par votre compte Facebook ou Google? {clickHereLink} pour de l'aide.",
    "More": "Plus",
    "Subscribe": "S'abonner",
    "Upgrade": "Mise \xE0 jour",
    "Upgrade Now": "Am\xE9liorer l'exp\xE9rience maintenant",
    "Settings": "R\xE9glages",
    "Log Out": "D\xE9connexion",
    "Account": "Compte",
    "Sponsor Content": "Contenu commandit\xE9",
    "Mark As Unplayed": "Marquer comme non jou\xE9",
    "Mark as Played": "Marquer comme jou\xE9",
    "This station is not currently available": "Cette station n'est pas disponible en ce moment",
    "Please pick a different station or listen to this station using our free iHeart app": "Choisissez une autre station ou \xE9coutez celle-ci avec notre appli gratuite iHeart",
    "Listen in App": "\xC9couter avec l'appli",
    "You haven't thumbed up any songs yet.": "Vous n'avez pas encore donn\xE9 de pouces en l'air.",
    "Favorite Songs": "Chansons pr\xE9f\xE9r\xE9es",
    "NEW": "NOUVEAU",
    "Welcome to": "Bienvenue \xE0",
    "Your Favorites Radio!": "Votre radio de chansons pr\xE9f\xE9r\xE9es!",
    "All your favorites and thumbs up in one station. The more you interact with iHeart, the better it gets.": "Tous ce que vous aimez dans une seule station. Plus vous interagissez avec iHeart, plus la plateforme r\xE9pond \xE0 vos go\xFBts.",
    "Please name your station now:": "Veuillez maintenant nommer votre station:",
    "Refresh": "Rafra\xEEchir",
    "On Air": "En diffusion",
    "Share": "Partager",
    "Go To Album": "Aller \xE0 l'album",
    "Go To Artist": "Aller \xE0 l'artiste",
    "Go To Station": "Aller \xE0 la station",
    "Unfollow Station": "Ne plus suivre la station",
    "Follow Station": "Suivre la station",
    "Go To Your Library": "Aller \xE0 votre librairie",
    "Go To Playlist": "Aller \xE0 la liste d'\xE9coute",
    "Share Episode": "Partager l'\xE9pisode",
    "Share from": "Partager de",
    "Pause": "Pause",
    "Stop": "Arr\xEAt",
    "Play": "Jouer",
    "Play Newest": "Jouer les plus r\xE9cents \xE9pisodes",
    "Create unlimited playlists. Try iHeart All Access.": "Cr\xE9ez des listes d'\xE9coute illimit\xE9es. Essayez Tout Acc\xE8s iHeart.",
    "My Music": "Ma musique",
    "Theme Radio": "Radio th\xE9matique",
    "Playlist": "Liste d'\xE9coute",
    "Playlist by": "Liste d'\xE9coute par",
    "Podcast": "Balado",
    "Thanks for listening!": "Merci de nous \xE9couter!",
    "Rename": "Renommer",
    "Edit": "\xC9diter",
    "Add to Another Playlist": "Ajouter \xE0 une autre playlist",
    "Shuffle": "Lecture al\xE9atoire",
    "Added By You": "Ajout\xE9e par vous",
    "Recently Played": "R\xE9cemment \xE9cout\xE9es",
    "You like {station} on Facebook": "Vous aimez {station} sur Facebook",
    "You listened to {station}": "Vous avez \xE9cout\xE9 {station}",
    "You are near {city}": "Vous \xEAtes pr\xE8s de {city}",
    "You like {genre}": "Vous aimez le {genre}",
    "Just For You": "Juste pour vous",
    "Popular On {iHeart}": "Populaire sur {iHeart}",
    "Discover how you can save and replay music on your favorite radio stations, or download and listen offline to millions of songs!": "D\xE9couvrez comment sauvegarder et rejouer de la musique de vos stations radio pr\xE9f\xE9r\xE9es, ou t\xE9l\xE9chargez et \xE9coutez des millions de chansons hors ligne!",
    "iHeart Plus & All Access - Upgrade to a Free Trial": "iHeart Plus et Tout Acc\xE8s - Passer \xE0 un essai gratuit",
    "Playlist deleted": "Liste d'\xE9coute supprim\xE9e",
    "Select a song to replay": "Choisissez une chanson \xE0 rejouer",
    "Save Playlist": "Sauvegarder la liste d'\xE9coute",
    "All": "Tous",
    "Live Stations": "Stations en direct",
    "Artists": "Artistes",
    "Albums": "Albums",
    "Songs": "Chansons",
    "artists, stations or podcasts": "artistes, stations, et balados",
    "stations or podcasts": "stations et balados",
    "podcasts": "balados",
    "search": "chercher",
    "Album{bulletSeparator}{artistName}": "Album{bulletSeparator}{artistName}",
    "Top Result": "Meilleur r\xE9sultat",
    "Search Results": "R\xE9sultats de recherche",
    "Show More Results": "Afficher plus de r\xE9sultats",
    "Search iHeart for artists, stations or podcasts.": "Cherchez iHeart pour des artistes, stations, et balados.",
    "Search iHeart for stations or podcasts.": "Cherchez iHeart pour des stations et balados.",
    "Search iHeart for podcasts.": "Chercher sur iHeart pour des balados.",
    'There are no results for "{searchQuery}"': `Il n'y a pas de r\xE9sultats pour  "{searchQuery}"`,
    "Check your spelling or try another search": "V\xE9rifiez votre orthographe ou essayez une autre recherche",
    "Show all Live Stations": "Montrer toutes les stations en direct",
    "Show all Artists": "Montrer tous les artistes",
    "Show all Albums": "Montrer tous les albums",
    "Show all Songs": "Montrer toutes les chansons",
    "Show all Playlists": "Montrer toutes les listes d'\xE9coute",
    "Show all Podcasts": "Montrer tous les balados",
    "Show all {title}": "Montrer tous {title}",
    "Embed Widget": "Int\xE9grer le widget",
    "Twitter": "Twitter",
    "See {moreTiles} of {itemCount}": "Afficher {moreTiles} de {itemCount}",
    "See All": "Tout afficher",
    "See Less": "Afficher moins",
    "Get The App": "T\xE9l\xE9chargez l'appli",
    "Connect with ": "Connectez-vous \xE0 ",
    "on your favorite social network ": "sur votre r\xE9seau social pr\xE9f\xE9r\xE9",
    " Song": "Chanson",
    "Keep Thumbing!": "Continuez de nous donner votre opinion!",
    "Thumbing up songs personalizes the stations you listen to and adds them to Your Favorites Radio.": "Donner un pouce en l'air personnalise les stations que vous \xE9coutez et les ajoute \xE0 votre radio de chansons pr\xE9f\xE9r\xE9es.",
    "1 song": "1 chanson",
    "All your favorite songs and artists.": "Toutes vos chansons et vos artistes pr\xE9f\xE9r\xE9s.",
    "Show Less": "Afficher moins",
    "Show More": "En voir plus",
    "Schedule": "Horaire",
    "Listen offline": "\xC9couter hors ligne",
    "Unlimited skips": "Sauts illimit\xE9s",
    "Save songs from radio to playlists": "Sauvegarder des chansons de radio dans des listes d'\xE9coute",
    "Instantly replay songs from radio": "Rejouer instantan\xE9ment des chansons de la radio",
    "Create unlimited playlists": "Cr\xE9ez autant de listes d'\xE9coute que vous voulez",
    "Play millions of songs on demand": "Jouez des millions de chansons sur demande",
    "Now you can create your own playlists with All Access!": "Maintenant vous pouvez cr\xE9er vos propres listes d'\xE9coute avec Tout Acc\xE8s!",
    "Start Free 30 Day Trial": "Essayez une p\xE9riode d'essai gratuite de 30 jours",
    "Subscribe to All Access": "Inscrivez-vous \xE0 Tout Acc\xE8s",
    "is now better than ever!": "est maintenant meilleur que jamais!",
    "All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "Tous vos balados, votre musique et vos stations radio disponibles gratuitement. \xC9coutez des milliers de stations en direct ou cr\xE9ez votre propre station artiste. Trouvez les derni\xE8res nouvelles et tendances musicales, de vos artistes et groupes pr\xE9f\xE9r\xE9s. ",
    "Stream thousands of the best live radio stations and custom artist stations for FREE - all in one app.": "\xC9coutez des milliers de stations de radio en diffusion continue gratuitement - tout dans une appli.",
    "Stream thousands of the best live radio stations for FREE, plus unlimited music on demand - all in one app.": "\xC9coutez des milliers de stations de radio gratuitement, en plus de musique illimit\xE9e sur demande - tout dans une appli.",
    "Stream thousands of the best live radio stations for FREE - all in one app.": "\xC9coutez des milliers de stations de radio gratuitement - tout dans une appli.",
    "All Genres": "Tous les genres",
    "Featured": "En vedette",
    "Popular": "Populaire",
    "You are now logged in as {profileName}": "Vous \xEAtes connect\xE9 en tant que {profileName}",
    "Artist": "Artiste",
    "Song by": "Chanson par",
    "Song": "Chanson",
    "Live Station": "Station en direct",
    "Album by": "Album par",
    "Album": "Album",
    "Email or password is invalid. Please try again.": "Courriel ou mot de passe invalide. Veuillez r\xE9essayer.",
    "There was an issue playing the audio, please check your connection and try again.": "Il y a eu un probl\xE8me lors de la lecture de votre musique, v\xE9rifiez votre connection et r\xE9-essayez",
    "There was a connection problem. Please reconnect and try again.": "Il y a eu un probl\xE8me de connexion. Veuillez vous reconnecter et r\xE9essayer.",
    "See More": "Plus",
    "all access": "tout acc\xE8s",
    "Best Playlists": "Meilleures listes d'\xE9coute",
    "concert pictures": "photos de concerts",
    "create playlists": "cr\xE9er des listes d'\xE9coute",
    "custom radio station": "station radio personnalis\xE9e",
    "event pictures": "photos d'\xE9v\xE9nements",
    "favorite music": "musique pr\xE9f\xE9r\xE9e",
    "Music Playlists": "Listes d'\xE9coute musicales",
    "my music": "ma musique",
    "Now Playing": "Vous \xE9coutez",
    "On Demand": "Sur demande",
    "Online Playlists": "Listes d'\xE9coute en ligne",
    "paid music": "musique achet\xE9e",
    "paid songs": "chansons achet\xE9es",
    "personal radio station": "station radio personnalis\xE9e",
    "personalized radio station": "station radio personnalis\xE9e",
    "play songs": "jouer des chansons",
    "Top Playlists": "Listes d'\xE9coute les plus populaires",
    "recent photos": "photos r\xE9centes",
    "recent pictures": "photos r\xE9centes",
    "saved music": "musique sauvegard\xE9e",
    "saved songs": "chansons sauvegard\xE9es",
    "top playlists": "meilleures listes d'\xE9coute",
    "App": "Appli",
    "Bands": "Groupes",
    "Best": "Meilleur",
    "Discover": "D\xE9couvrir",
    "Download": "T\xE9l\xE9charger",
    "Free": "Gratuit",
    "Influencers": "Influenceurs",
    "Influences": "Influences",
    "Internet": "Internet",
    "Listen": "\xC9couter",
    "Live": "En direct",
    "Music": "Musique",
    "Online": "En ligne",
    "Personalized": "Personnalis\xE9",
    "photos": "photos",
    "pictures": "photos",
    "Radio": "Radio",
    "Related": "Connexe",
    "Similar": "Similaire",
    "Station": "Station",
    "Stations": "Stations",
    "stream": "diffusion",
    "Streaming": "En diffusion",
    "Talk": "Parler",
    "Top": "Meilleur",
    "January": "Janvier",
    "February": "F\xE9vrier",
    "March": "Mars",
    "April": "Avril",
    "May": "Mai",
    "June": "Juin",
    "July": "Juillet",
    "August": "Ao\xFBt",
    "September": "Septembre",
    "October": "Octobre",
    "November": "Novembre",
    "December": "D\xE9cembre",
    "Jan": "Jan",
    "Feb": "Fev",
    "Mar": "Mar",
    "Apr": "Avr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Ao\xFBt",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "D\xE9c",
    "Password must have": "Le mot de passe doit comprendre",
    "iHeart: Listen to Free Radio Stations & Music Online | iHeart": "iHeart : \xC9coutez des stations de radio et de la musique en ligne gratuitement | iHeart",
    "1 Song": "1 chanson",
    "Listen to music you love! Create a custom radio station based on your favorite album by {artistName} on iHeartRadio!": "\xC9coutez la musique que vous aimez! Cr\xE9ez une station de radio personnalis\xE9e avec votre album pr\xE9f\xE9r\xE9 de {artistName} sur iHeartRadio!",
    "Stream Free Music from Albums by {artistName}": "\xC9coutez de la musique gratuite en difussion d'albums par {artistName}",
    "Create Artist Radio Stations": "Cr\xE9ez des stations radio d'artistes",
    "Popular {genre} Artists": "Artistes populaires de {genre}",
    "Artist Radio gives you the power to create custom stations from your favorite songs, albums or musical artists. Listen for free on iHeart!": "La radio d'artiste vous donne le pouvoir de cr\xE9er des stations personnalis\xE9es \xE0 partir de vos chansons, albums ou artistes pr\xE9f\xE9r\xE9s. \xC9coutez gratuitement sur iHeart!",
    "Create a personalized custom music station from thousands of {name} artists you love, only on iHeart!": "Cr\xE9ez une station de musique personnalis\xE9e avec des milliers d'artistes {name} que vous aimez, seulement sur iHeart!",
    "Create Custom Radio Stations on Artist Radio!": "Cr\xE9ez des stations personnalis\xE9es dans Radio artiste",
    "Listen to the Best {name} Music for Free on iHeart": "\xC9coutez la meilleure musique  {name} gratuitement sur iHeart",
    "{artistName}": "{artistName}",
    "{name}, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, Nouvelless, Musique, Manchettes, iHeartRadio, iHeart, Radio",
    "Latest {name} news from iHeart": "Les derni\xE8res nouvelles {name} de iHeart",
    "Read the latest News on {name} Online": "Lisez les derni\xE8res nouvelles sur  {name} en ligne",
    "Biography": "Biographie",
    "Similar Artists": "Artistes similaires",
    "Latest Release": "Derni\xE8res sorties",
    "Popular On": "Populaire sur",
    "This artist doesn't have any top songs.": "Cet artiste n'a pas de chansons sur les palmar\xE8s.",
    "Top Songs": "Les meilleures chansons",
    "Stream Music from Artists Like {artistName}": "\xC9coutez de la musique en diffusion d'artistes comme {artistName}",
    "Listen to music you'll love! Create a custom radio station from your favorite songs by {artistName} on iHeart.": "\xC9coutez la musique que vous aimez! Cr\xE9ez une station de radio personnalis\xE9e avec vos chansons pr\xE9f\xE9r\xE9es de {artistName} sur iHeart.",
    "Stream Free Songs by {artistName} & Similar Artists": "\xC9coutez des chansons de {artistName} gratuitement en diffusion et des artistes similaires",
    "Almost there! Verify your zipcode to unlock your spot on the Family Plan": "Presque arriv\xE9! V\xE9rifier votre code postal pour prendre votre place sur le plan familial",
    "In order to add you to the plan, we need to make sure that you live at the same address as the plan owner. Please input your zipcode below to verify and unlock your account.": "Pour vous ajouter au plan, nous devons nous assurer que vous vivez \xE0 la m\xEAme adresse que l'abonn\xE9 principal du plan. Veuillez entrer votre code postal ci-dessous pour v\xE9rifier et d\xE9barrer votre compte.",
    "Household Zipcode": "Code postal de la maison",
    "e.g 90210...": "ex : H1H 1H1...",
    "help site": "site de soutien",
    "It looks like you're already subscribed": "Il semble que vous soyez d\xE9j\xE0 abonn\xE9s",
    "You must cancel your active subscription before you can continue. You can find out how to cancel your subscription at {supportLink}. Once you've cancelled your current subscription plan you will need to wait until your current subscription plan ends.": "Vous devez annuler votre abonnement actif avant de continuer. Vous pouvez aller \xE0 {supportLink} pour apprendre comment annuler votre abonnement. Une fois , votre plan d'abonnement pr\xE9sent devra expirer avant de le changer.",
    "If you have any questions, please {helplink} contact us.": "Si vous avez des questions, vous pouvnez nous contacter \xE0 :  {helplink} .",
    "Please create a free account, or sign in": "Veuillez cr\xE9er un compte gratuit ou vous connecter",
    "To accept the Family Plan invitation, you must be logged in.": "Pour accepter l'invitation au Plan familial, vous devez \xEAtre connect\xE9.",
    "Welcome to Your Favorites Radio, a personalized station containing your favorite songs and artists. The more you thumb up and save stations on iHeart, the better your listening experience will be.": "Bienvenue \xE0 votre station de chansons pr\xE9f\xE9r\xE9es, une station personnalis\xE9e avec vos chansons et artistes pr\xE9f\xE9r\xE9s. Plus vous sauvegardez des stations sur iHeart, plus plaisante sera votre exp\xE9rience d'\xE9coute.",
    "Listen to {title}. Thumb up songs to add them to your own Your Favorites Radio station. Find it under My Stations.": "\xC9coutez {title}. Donnez un pouce en l'air aux chansons que vous voulez ajouter \xE0 votre station de chansons pr\xE9f\xE9r\xE9es. Trouvez-la sous Mes stations.",
    "Featured Artists On This Station": "Artistes en vedette sur cette station",
    "{name}'s Favorites Radio": "La radio des chansons pr\xE9f\xE9r\xE9es de {name}",
    "iHeartRadio Mobile Apps": "Applis mobiles iHeartRadio",
    "Made for You": "Fait pour vous",
    "Listen to Stations For You": "\xC9coutez des stations faites juste pour vous",
    "Change genre preferences {prefLink}": "Changer mes pr\xE9f\xE9rences de genre {prefLink}",
    "here": "ici",
    "iHeart: Listen to Free Radio Stations & Music Online": "iHeart : \xC9coutez des stations de radio et de la musique en ligne gratuitement",
    "All Your Favorite Music. All Your Favorite Stations. All FREE. Listen to thousands of live stations or create your own artist stations. Let the music play!": "Toute votre musique pr\xE9f\xE9r\xE9e. Toutes vos stations pr\xE9f\xE9r\xE9es. Compl\xE9tement gratuit. \xC9coutez des milliers de stations en direct ou cr\xE9ez votre propre station artiste. Que la musique joue!",
    "Improve Your Recommendations": "Am\xE9liorer vos recommendations",
    "Change Preferences": "Changer mes pr\xE9f\xE9rences",
    "Change Genre Preferences": "Changer mes pr\xE9f\xE9rences de genres",
    "Find Stations by Genre": "Trouvez des stations par genre",
    "Finding your ideal station is quick and easy. Search for stations by genre & stream them online for free on iHeart.": "Trouver votre station id\xE9ale est facile et rapide. Cherchez pour des stations par genre et jouez-les en ligne gratuitement sur iHeart.",
    "Discover Music and Radio Stations by Genre on iHeart": "D\xE9couvrez de la musique et des stations de radio par genre sur iHeart",
    "Pick Genre": "Choisissez un genre",
    "Tell us all the genres you like.": "Choisissez vos genres pr\xE9f\xE9r\xE9s.",
    "We'll suggest stations just For You.": "Nous vous sugg\xE9rerons des stations juste pour vous.",
    "Get Stations": "Trouvez-moi des stations",
    "Find and stream {genreName} music stations for free, only on iHeart.": "Trouvez et diffusez des stations de musique  {genreName} gratuitement, seulement sur iHeart.",
    "Listen to {genreName} Radio Stations for Free": "\xC9coutez des stations de {genreName} gratuitement",
    "Find {genreName} Stations": "Trouvez des stations de {genreName}",
    "Featured {genreName} Stations": "Stations de {genreName} en vedette",
    "Top {genreName} Stations": "Meilleures stations de {genreName}",
    "Top {genreName} Artists": "Meilleurs artistes de {genreName}",
    "More Genres": "Plus de genres",
    "Latest News": "Derni\xE8res nouvelles",
    "Partner Content": "Contenu partenaire",
    "All Cities": "Toutes les villes",
    "for {currentGenre}": "pour {currentGenre}",
    "in {currentMarket}": "\xE0 {currentMarket}",
    "near you": "pr\xE8s de vous",
    "Find top stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})": "Trouvez les meilleures stations {genreFilterDescription} {marketFilterDescription} {noFiltersMessage} ({numStations})",
    "Listen to Live Radio": "\xC9coutez la radio en direct",
    "No stations currently available for this filter": "Aucune station disponible en ce moment avec ce filtre",
    "Listen to the Best Live Radio Stations in {countryAbbreviation}": "\xC9coutez les meilleures stations en direct au {countryAbbreviation}",
    "Listen to {genreName} Radio Stations in {city}": "\xC9coutez des stations {genreName} \xE0 {city}",
    "Listen to Top Radio Stations in {city}, Free": "\xC9coutez les meilleures stations radio \xE0 {city}, gratuitement",
    "Live {genreName} Radio Stations in {countryAbbreviation}": "Stations radio de {genreName} en direct au {countryAbbreviation}",
    "Listen to hundreds of the best live radio stations{countryName}, for free! Search for stations near you & around the country.": "\xC9coutez des centaines des meilleures stations en direct \xE0 travers le {countryName}, gratuitement! Cherchez pour des stations pr\xE8s de vous et \xE0 travers le pays.",
    "Listen to the Best Live Radio{country} for Free on iHeart.": "\xC9coutez les meilleures stations en direct au {country}, gratuitement sur iHeart.",
    "Stream the best live {genreName} radio stations in {city} online for free, only on iHeart!": "Faites jouer les meilleures stations en direct de {genreName} \xE0 {city} en ligne gratuitement, seulement sur iHeart!",
    "Listen to Top {genreName} Radio Stations in {city}": "\xC9coutez les meilleures stations de {genreName} \xE0 {city}",
    "Listen to the best live radio stations in {city}. Stream online for free, only on iHeart!": "\xC9coutez les meilleures stations radio en direct \xE0 {city}, faites les jouer gratuitement, seulement sur iHeart!",
    "Listen to Top Radio Stations in {city} for Free": "\xC9coutez les meilleures stations radio \xE0 {city} gratuitement",
    "Stream the best live {genreName} radio stations in {countryAbbreviation} for free on iHeart.": "Faites jouer la station radio de {genreName} en direct au {countryAbbreviation} gratuitement sur iHeart.",
    "Listen to Free, Live {genreName} Radio Stations in {countryAbbreviation} on iHeart": "\xC9coutez gratuitement les stations de {genreName} en direct au {countryAbbreviation} sur iHeart",
    "Contests and Promotions": "Concours et promotions",
    "If you like {stationName}...": "Si vous aimez {stationName}...",
    "Similar Stations": "Stations similaires",
    "{stationName}, {stateAbbreviation}, {city}, {genre}": "{stationName}, {stateAbbreviation}, {city}, {genre}",
    "Genre": "Genre",
    "Location": "Emplacement",
    "On Air Schedule": "Horaire de diffusion en direct",
    "Share Song": "Partager la chanson",
    "Get the latest music news - rock, pop, hip-hop, rock, alternative, and country music news from iHeart. Get the latest music and trending news, from your favorite artists and bands.": "Recevez les derni\xE8res nouvelles musicales - sur le rock, pop, hip-hop, rock, alternatif et le country d'iHeartRadio. Recevez les derni\xE8res nouvelles, sur vos artistes et vos groupes pr\xE9f\xE9r\xE9s.",
    "Breaking Music News, Celeb and Entertainment News and Gossip": "Les nouvelles de l'heure sur la musique, les c\xE9l\xE9brit\xE9s, le divertissement et les potins",
    "Advertise With Us": "Vous aimeriez de l'espace de publicit\xE9?",
    "Discover thousands of top playlists with songs handcrafted by your favorite personalities and music experts on iHeartRadio.": "D\xE9couvrez des milliers de listes d'\xE9coute avec des chansons sp\xE9cialement choisies par vos personnalit\xE9es pr\xE9f\xE9r\xE9s et des experts musicaux sur iHeartRadio.",
    "Listen to the Best Online Music Playlists": "\xC9coutez les meilleures listes d'\xE9coute musicales en ligne",
    "Recommended For You": "Recommand\xE9s pour vous",
    "Moods & Activities": "Ambiance et activit\xE9s",
    "Decades": "D\xE9cennies",
    "Featured Playlists": "Listes d'\xE9coute en vedette",
    "By": "Par",
    "Your songs shuffled with songs we think you\u2019ll like. The more songs you add, the better our picks get.": "Vos chansons sont m\xE9lang\xE9es \xE0 des chansons que nous pensons que vous aimerez. Plus vous ajoutez de chansons, plus nos choix s'am\xE9lioreront.",
    "Introducing a new playlist experience": "Introduction d'une nouvelle exp\xE9rience de liste d'\xE9coute",
    "Song saved to Your Library": "Chanson sauvegard\xE9e \xE0 votre librairie",
    "Go to Artist": "Allez \xE0 l'artiste",
    "Go to Album": "Allez aux albums",
    "Remove from Playlist": "Supprimer de mes listes d'\xE9coute",
    "SONG": "CHANSON",
    "ALBUM TITLE": "TITRE DE L\u2019ALBUM",
    "ARTIST": "ARTISTE",
    "DURATION": "DUR\xC9E",
    "Done": "Termin\xE9",
    "Discover and stream the best {categoryTitle} playlists, handcrafted by the music experts at iHeart.": "D\xE9couvrez et \xE9coutez les meilleures listes d'\xE9coute de {categoryTitle}, cr\xE9\xE9es par des experts musicaux \xE0 iHeart.",
    "{categoryTitle}, {categoryTitle} Playlists, Stream {categoryTitle} Music, Play {categoryTitle} Songs, Top {categoryTitle} Playlists, Best { categoryTitle} Playlists": "{categoryTitle}, Listes d'\xE9coute de {categoryTitle}, \xC9couter de la musique {categoryTitle} , Jouer des chansons {categoryTitle}, Meilleures listes d'\xE9coute {categoryTitle}, Top listes d'\xE9coute { categoryTitle}",
    "Top {categoryTitle} Playlists; Find Your Perfect Music Mix": "Meilleures listes d'\xE9coute {categoryTitle}; Trouvez votre mix musical parfait",
    "Host": "Animateur et cr\xE9ateur",
    "iHeart Podcast Networks": "R\xE9seaux de balados iHeart",
    "{name}, Blog, News, Music, Headlines, iHeartRadio, iHeart, Radio": "{name}, Nouvelles, Musique, Manchettes, iHeartRadio, iHeart, Radio",
    "{name} Blog, News & Videos": "Blogs, nouvelles et vid\xE9os de {name} ",
    "Go behind the scenes, get exclusive stories and learn more about the show!": "Allez dans les coulisses, recevez des nouvelles exclusives et apprenez-en plus sur l'\xE9mission!",
    "Played": "Jou\xE9",
    "Listen to the best {categoryName} radio shows, free and on demand, only on iHeart.": "\xC9coutez les meilleures \xE9mission de radio {categoryName}, gratuitement et sur demande, seulement sur iHeart.",
    "Listen to the Best Free {categoryName} Podcasts": "\xC9coutez les meilleurs balados gratuits {categoryName}",
    "On Demand, On-Demand, Show, Shows, Personalities, Programs, Listen, iHeartRadio, iHeart": "Sur demande, Sur-demande, \xC9mission, \xC9missions, Personnalit\xE9s, Programmes, \xC9couter, iHeartRadio, iHeart",
    "Discover Top Podcasts": "D\xE9couvrez les balados les plus populaires",
    "Listen to the latest episodes from top podcasts. Get news, sports & lifestyle info from your favorite personalities for free!": "\xC9coutez les derniers \xE9pisodes des meilleurs balados. Recevez des nouvelles et de l'information sur les sports et de lifestyle de vos personnalit\xE9s pr\xE9f\xE9r\xE9es gratuitement!",
    "Listen to the Best Podcasts Online for Free on iHeart": "\xC9coutez les meilleurs balados en ligne gratuitement sur iHeart",
    "Listen to the Best Podcasts & Shows Online, Free": "\xC9coutez les meilleurs balados et \xE9missions en ligne, gratuitement",
    "Talk, Show, Host, Personality, On Demand, Topic, Category, Health, News, Politics, Comedy, Station, Internet, Online, iHeartRadio, iHeart": "Parl\xE9, \xC9mission, H\xF4te, Personnalit\xE9, Sur demande, Sujet, Cat\xE9gorie, Sant\xE9, Nouvelles, Politique, Com\xE9die, Station, Internet, En ligne, iHeartRadio, iHeart",
    "Stream Top Podcasts": "\xC9coutez les meilleurs balados",
    "All Topics": "Tous les sujets",
    "{name} Podcasts": "Balados {name} ",
    "Topics": "Sujets",
    "All Episodes": "Tous les \xE9pisodes",
    "These episodes aren't here yet...": "Ces \xE9pisodes ne sont pas encore arriv\xE9s...",
    "Follow this podcast to be notified when they're ready": "Suivez ce balado pour recevoir des notifications lorsqu'ils sont pr\xEAts",
    "Share Podcast": "Partager le balado",
    "The Latest News": "Derni\xE8res nouvelles",
    "Listen to {episodeTitle} | {showTitle} | Podcasts": "\xC9coutez le balado {episodeTitle} | {showTitle}",
    "{episodeTitle},{showTitle},Talk,Radio,Listen,On Demand,iHeartRadio,iHeart": "{episodeTitle},{showTitle},Parler,Radio,\xC9couter,Sur demande,iHeartRadio,iHeart",
    "{title}, Talk, Radio, Listen, On Demand, iHeartRadio, iHeart": "{title}, Parler, Radio, \xC9couter, Sur demande, iHeartRadio, iHeart",
    "Episodes": "\xC9pisodes",
    "Popular Podcasts": "Balados populaires",
    "Stream the best podcasts from your favorite stations": "\xC9coutez les meilleurs balados en diffusion directe de vos stations pr\xE9f\xE9r\xE9es",
    "Follow Us On": "Suivez-nous sur ",
    "Show Links": "Montrer les liens",
    "Settings | See Your Music Profile": "R\xE9glages | Voyez votre profil musical",
    "Log in and see which live radio stations and custom artist stations you love. You can also view your listening history. All free.": "Connectez-vous et venez voir quelles stations de radio en direct ou d'artistes que vous aimez. Vous pouvez aussi voir votre historique musicale. Tout gratuitement.",
    "Connections": "Connexions",
    "Unlink": "D\xE9lier",
    "Link": "Lier",
    "Genre added.": "Genre ajout\xE9.",
    "Genre removed.": "Genre supprim\xE9.",
    "You've added {genreName} to your genres.": "Vous avez ajout\xE9 {genreName} \xE0 vos genres.",
    "You've removed {genreName} from your genres.": "Vous avez supprim\xE9 {genreName} de vos genres.",
    "Your preferences have been changed.": "Vos pr\xE9f\xE9rences ont \xE9t\xE9 chang\xE9es.",
    "Not provided": "Non fourni",
    "Publish my listening activity to my Facebook music dashboard": "Publier mes activit\xE9s d'\xE9coute sur mon dashboard musical Facebook",
    "Update your password, genre selection, and modify your subscription below.": "Ci-dessous vous pourrez mettre votre mot de passe et votre s\xE9lection de genre \xE0 jour ou modifiez votre inscription.",
    "You're currently signed in with a social account, add an email and password to have full access to your account": "Vous \xEAtes connect\xE9 par un compte de r\xE9seau social, ajoutez un courriel et un mot de passe pour avoir l'acc\xE8s complet \xE0 votre compte",
    "Add New Email": "Ajouter une nouvelle adresse courriel",
    "Contact Information": "Coordonn\xE9es",
    "Update your contact information to personalize your experience and easily enter iHeart contests and promotions.": "Mettez \xE0 jour vos coordonn\xE9es pour personnaliser votre exp\xE9rience et participez facilement aux concours et aux promotions iHeart",
    "First and Last Name": "Pr\xE9nom et nom de famille",
    "Add your full name": "Ajouter votre nom complet",
    "My Genres": "Mes genres musicaux",
    "Tell us all your favorite genres so we can make iHeart perfect for you.": "Dites-nous quels sont vos genres pr\xE9f\xE9r\xE9s et iHeart s'adaptera parfaitement \xE0 vos go\xFBts.",
    "View Recommendations": "Voir les recommendations",
    "Billing History": "Historique de paiement",
    "Subscribe Again": "S'abonner \xE0 nouveau",
    "Update Payment": "Mettre votre paiement \xE0 jour",
    "Unknown": "Inconnu",
    "Unknown Plan Description": "Description de plan inconnu",
    "iHeart Family Plan": "Plan familial iHeart",
    "You are enjoying an unlimited music experience with an iHeart Family Plan.": "Vous b\xE9n\xE9ficiez d'une exp\xE9rience musicale illimit\xE9e en vous abonnant au plan familial iHeart.",
    "iHeart All Access": "Tout Acc\xE8s iHeart",
    "You are enjoying an unlimited music experience by subscribing to iHeart All Access.": "Vous b\xE9n\xE9ficiez d'une exp\xE9rience musicale illimit\xE9e en vous abonnant \xE0 iHeart Tout Acc\xE8s.",
    "iHeart Plus": "iHeart Plus",
    "You are subscribed to iHeart Plus. Switch to iHeart All Access to enjoy an unlimited music experience on your computer.": "Vous \xEAtes abonn\xE9 \xE0 iHeart Plus. Changer pour iHeart Tout Acc\xE8s pour b\xE9n\xE9ficier d'une exp\xE9rience musicale illimit\xE9e sur votre ordinateur.",
    "iHeart Free": "iHeart gratuit",
    "Subscribe to enjoy unlimited music.": "Abonnez-vous pour b\xE9n\xE9ficier de musique illimit\xE9e.",
    "Your subscription ends on {subscriptionEndsString}.": "Your abonnement finit le {subscriptionEndsString}.",
    "Family Members": "Membres de famille",
    "Subscription": "Abonnement",
    "Your Favorite Songs | Log In & See": "Vos chansons pr\xE9f\xE9r\xE9es | Se connecter pour voir",
    "Log in or sign up and find the songs you love here, only on iHeart.": "Connectez-vous ou inscrivez-vous et trouvez les chansons que vous aimez, seulement sur iHeart.",
    "iHeart Codes Coupons and Special Offers for Unlimited Music": "Coupons et offres sp\xE9ciales iHeart pour de la musique illimit\xE9e",
    "Find iHeart Radio special offers, codes and coupons for unlimited music on demand and all access to iHeart Plus. These special offers provide access to millions of songs, thousands of radio and artists stations with unlimited skips and offline listening!": "Trouver des offres sp\xE9ciales d'iHeart, des codes et des coupons pour de la musique illimit\xE9 et pour l'acc\xE8s complet \xE0 iHeart Plus. Ces offres sp\xE9ciales donnent acc\xE8s \xE0 des millions de chansons, des milliers de stations radio et d'artistes avec des sauts illimiti\xE9s et de l'\xE9coute hors ligne.",
    "There was an error validating your request.": "Il y a eu une erreur lors de la validation de votre requ\xEAte.",
    "Please enter a valid email address": "Veuillez entrer une adresse courriel valide",
    "Please fix the following errors:": "Veuillez corriger les erreurs suivantes :",
    "Start Your Free 30 Day Trial": "Commencez votre p\xE9riode d'essai gratuite de 30 jours",
    "Start Your Family Plan": "Commencez votre plan familial",
    "Sign up for iHeart All Access Annual Plan": "S'abonner au Plan annuel Tout Acc\xE8s iHeart",
    "View": "Afficher",
    "Offer Terms": "Conditions de l'offre",
    "Email Address": "Adresse courriel",
    "Enter email address": "Entrer une adresse courriel",
    "Card Details": "D\xE9tails de la carte",
    "Zip / Postal Code": "Code postal",
    "Enter Here": "Saisir ici",
    "Yes, please automatically renew my subscription annually (subject to {termsLink})": "Oui, veuillez renouveller automatiquement mon abonnement \xE0 chaque ann\xE9e (conform\xE9ment \xE0 {termsLink})",
    "terms & conditions": "conditions",
    'Charges will appear on your credit card statement as "IHEART BILLING"': 'Les frais apparaissent sur votre relev\xE9 de carte de cr\xE9dit comme "IHEART BILLING"',
    'You can cancel at any time by going to "Settings" and following the cancellation instructions. By clicking "Subscribe" below, you agree to the conditions above and the iHeart ': "Vous pouvez annuler en tout temps en allant dans les R\xE9glages en suivant les instructions d'annulation. En cliquant sur \xAB S'abonner \xBB ci-dessous, vous acceptez les conditions ci-dessus",
    "Processing": "En traitement",
    "Enter your email address below to log in by email or reset your password": "Entrez votre adresse courriel ci-dessous pour vous connecter par courriel ou pour r\xE9initialiser votre mot de passe.",
    "email": "courriel",
    "Send": "Envoyer",
    "Don\u2019t use common passwords, like \u201CPassword123!\u201D": "N'utilisez pas de mots de passe communs, comme \u201CPassword123!\u201D",
    "Your password reset link is invalid or expired. Please try": "Votre lien de r\xE9initialisation du mot de passe est invalide ou expir\xE9. Veuillez essayer de",
    "resetting your password": "r\xE9initialiser votre mot de passe",
    "again.": "de nouveau.",
    "Create a New Password": "Cr\xE9er nouveau mot de passe",
    "Your password reset link has expired": "Votre lien de r\xE9initialisation du mot de passe est expir\xE9",
    "An unknown error occured. Please try again later": "Une erreur inattendue s'est produite. Veuillez r\xE9essayer plus tard.",
    "Your password has been updated": "Votre mot de passe a \xE9t\xE9 mis \xE0 jour.",
    "Confirm New Password": "Confirmer le nouveau mot de passe",
    "Create": "Cr\xE9er",
    "Custom radio stations based off your favorite artists and bands.": "Des stations radio personnalis\xE9es cr\xE9\xE9es \xE0 partir de vos artistes et groupes pr\xE9f\xE9r\xE9s.",
    "View More Artists": "Voir plus d'artistes",
    "Bring iHeart with you anywhere": "Amenez iHeart avec vous n'importe o\xF9",
    "The free iHeart app is available on over 200 platforms, including Web, iOS, Android, Alexa, automobiles and more.": "L'appli gratuite iHeart est disponible sur plus de 200 plateformes, incluant Web, iOS, Android, Alexa, les plateformes voiture et plus.",
    "Download on the": "T\xE9l\xE9charger sur le",
    "Download on": "T\xE9l\xE9charger sur",
    "View All Apps": "Voir toutes les applis",
    "Upcoming Events": "\xC9v\xE9nements \xE0 venir",
    "Listen to Your Favorite Music, Podcasts, and Radio Stations for Free! \u2013 iHeart": "\xC9coutez votre musique, votre radio et vos balados pr\xE9f\xE9r\xE9s en ligne gratuitement - iHeart",
    "iHeart. All your favorite music, podcasts, and radio stations available for free. Listen to thousands of live radio stations or create your own artist stations and playlists. Get the latest music and trending news, from your favorite artists and bands.": "iHeart. Tous vos balados, votre musique et vos stations radio disponible gratuitement. \xC9coutez des milliers de stations en direct ou cr\xE9ez votre propre station artiste. Trouver les derni\xE8res nouvelles et tendances musicales, de vos artistes et groupes pr\xE9f\xE9r\xE9s. ",
    "Get Started Free": "Commencer gratuitement",
    "All your favorite music, radio and podcasts, all free.": "Toute votre musique, vos radios et vos balados pr\xE9f\xE9r\xE9s, tout cela gratuitement.",
    "Your browser does not support video playback": "Votre navigateur ne supporte pas la lecture de vid\xE9os",
    "The best live stations from around the country, any time, any place.": "Les meilleures stations radio du pays, \xE0 \xE9couter n'importe quand, n'importe o\xF9",
    "View More Live Stations": "Voir plus de stations en direct",
    "New on iHeart": "Nouveau sur iHeart",
    "Latest Music News": "Les derni\xE8res nouvelles musicales",
    "View More Music News": "Voir plus de nouvelles musicales",
    "Popular and exclusive podcasts in a variety of genres and topics.": "Des balados populaires et exclusifs de tout genre et sur tous les sujets.",
    "View More Podcasts": "Voir plus de balados",
    "{count} song{plural}": "{count} chanson{plural}",
    "Browse Artists": "Parcourir les artistes",
    "Need to find a great new album?": "Besoin d'un excellent nouvel album?",
    "Any albums you save will show up here": "Les albums que vous sauvegardez appara\xEEtront ici",
    "Need to find an artist you love?": "Besoin de trouver un artiste que vous aimez?",
    "Any artists you follow will show up here": "Les artistes que vous suivez appara\xEEtront ici",
    "Access your music library and create unlimited playlists with iHeart All Access": "Acc\xE9dez \xE0 votre librairie musicale et cr\xE9ez autant de playlists que vous voulez avec Tout Acc\xE8s iHeart",
    "song{pluralSongs}": "chanson{pluralSongs}",
    "by": "par",
    "Browse Playlists": "Parcourir les listes d'\xE9coute",
    "Need a playlist to fit your mood?": "Besoin d'une liste d'\xE9coute qui va avec votre humeur?",
    "Any playlists you follow will show up here": "Les listes d'\xE9coute que vous suivez appara\xEEtront ici",
    "Browse Podcasts": "Parcourir les balados",
    "Need a great new podcast to start?": "Besoin d'un excellent nouveau balado?",
    "Any podcasts you follow will show up here": "Les listes d'\xE9coute que vous suivez appara\xEEtront ici",
    "Any radio, music, or podcasts you listen to will show up here": "Tout balado, station ou musique que vous \xE9coutez appara\xEEtra ici",
    "Browse Stations For You": "Parcourir les stations choisies pour vous",
    "Any podcasts you listen to will show up here": "Tout balado que vous \xE9coutez appara\xEEtra ici",
    "Need help finding something new?": "Besoin de trouver quelque chose de neuf?",
    "Remove station": "Supprimer la station",
    "{name} removed from Your Library": "{name} effac\xE9 de votre librairie",
    "Followed Stations": "Stations suivies",
    "Browse Live Radio": "Parcourir la radio en direct",
    "Browse Artist Radio": "Parcourir la radio d'artiste",
    "Need help finding stations to save?": "Besoin d'aide pour trouver des stations \xE0 sauvergarder?",
    "Your followed live and artist radio stations will show up here": "Vos stations en direct et d'artistes sauvegard\xE9es appara\xEEtront ici",
    "{albumName} removed from Your Library": "{albumName} effac\xE9 de votre librairie",
    "Remove": "Supprimer",
    "{artistName} removed from Your Library": "{artistName} effac\xE9 de votre librairie",
    "ARTIST IN YOUR LIBRARY": "ARTISTE DANS VOTRE LIBRAIRIE",
    "Add to playlist": "Ajouter \xE0 la liste d'\xE9coute",
    "Play Now": "Jouer maintenant",
    "{songTitle} removed from Your Library": "{songTitle} effac\xE9e de votre librairie",
    "Need to find a new song?": "Vous voulez trouver une nouvelle chanson?",
    "Any song you save will show up here": "Toute chanson sauvegard\xE9e sera affich\xE9e ici",
    "Playlist Radio": "Radio de listes d'\xE9coute",
    "View All": "Afficher tout",
    "Copied": "Copi\xE9",
    "Read more on iHeartRadio": "Lisez-en plus sur iHeartRadio",
    "Link Copied!": "Lien copi\xE9!",
    "Copy Link": "Copier le lien",
    "Code Copied!": "Code copi\xE9!",
    "Embed": "Int\xE9grer",
    "Follow on iHeartRadio": "Suivre sur iHeartRadio",
    "Playback not supported by device or browser.": "La lecture n'est pas prise en charge par l'appareil ou le fureteur.",
    "Method {method} not supported.": "La m\xE9thode {method} n'est pas prise en charge.",
    "View iHeart.com": "Voir iHeart.com",
    "Oops, that wasn't supposed to happen.": "Oups, cela n'\xE9tait pas suppos\xE9 arriver.",
    "Oops, this feature isn't supported yet.": "Oups, cette fonctionnalit\xE9 n'est pas encore prise en charge.",
    "Oops! We had problems playing this stream.": "Oups, nous avons des probl\xE8mes avec cette diffusion.",
    "This station is not currently available in your country.": "Cette station n'est pas offerte dans votre pays.",
    "Retry": "R\xE9-essayer",
    "Report this issue": "Signaler ce probl\xE8me",
    "View Troubleshooting": "Voir la section de d\xE9pannage",
    "hello": "bonjour",
    "my friend": "mon ami",
    "Share this live station": "Partager cette station en direct",
    "Create your own on iHeart": "Cr\xE9ez votre propre station sur iHeart",
    "We're sorry! This playlist is not available in your country.": "D\xE9sol\xE9s, cette liste d'\xE9coute n'est pas offerte dans votre pays!",
    "Playlist Not Available": "Liste d'\xE9coute non disponible",
    "This playlist is unsupported in your current country.": "Cette liste d'\xE9coute n'est pas prise en charge dans votre pays.",
    "Playback Unsupported In Current Country": "La lecture n'est pas prise en charge dans le pays actuel",
    "Featured artists in this playlist": "Les artistes en vedette dans cette liste d'\xE9coute",
    "View Playlist": "Afficher la liste d'\xE9coute",
    "Share this episode": "Partager cet \xE9pisode",
    "Listen to more episodes": "\xC9couter plus d'\xE9pisodes",
    "Share this podcast": "Partager le balado"
  },
  "options": {
    "plural_rule": "n > 1",
    "plural_number": "2"
  }
};
export {
  translations as activate,
  translations2 as www
};
//# sourceMappingURL=index.mjs.map